//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BaseAPI {
  constructor(protected configuration: Configuration) {}

  getBaseUrl(prefix: string, baseUrl: string) {
    const finalBaseUrl = baseUrl || this.configuration.basePath || BASE_PATH;

    return `${finalBaseUrl}${prefix}`;
  }

  async transformOptions(options: RequestInit): Promise<RequestInit> {
    if (options.headers) {
      let apiKey = "";
      if (this.configuration.apiKeyPromise) {
        apiKey = await this.configuration.apiKeyPromise();
      } else {
        apiKey = this.configuration.apiKey;
      }
      (options.headers as any)["authorization"] = apiKey;
      if (this.configuration.headers) {
        options.headers = {
          ...options.headers,
          ...this.configuration.headers,
        };
      }
      for (const middleware of this.configuration.middlewares) {
        options = (await middleware.pre(options)) || options;
      }
    }

    return Promise.resolve(options);
  }

  async transformResult(
    url: string,
    response: Response,
    processor: (response: Response) => Promise<any>
  ): Promise<any> {
    // is there middlware in configuration
    for (const middleware of this.configuration.middlewares) {
      response = (await middleware.post(response)) || response;
    }

    return processor(response);
  }
}

export interface IAbsenceApi {

    importAbsences(x_Version?: string | null | undefined): Promise<Result>;
}

export class AbsenceApi extends BaseAPI implements IAbsenceApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    importAbsences(x_Version?: string | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Absence/importAbsences";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportAbsences(_response));
        });
    }

    protected processImportAbsences(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export interface IActionRoleApi {

    updateActionRole(dto: UpdateActionRoleDto, x_Version?: string | null | undefined): Promise<FileResponse>;

    baseSearch(searchQuery: SearchQueryOfActionRoleSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfActionGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class ActionRoleApi extends BaseAPI implements IActionRoleApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    updateActionRole(dto: UpdateActionRoleDto, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ActionRole/UpdateActionRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateActionRole(_response));
        });
    }

    protected processUpdateActionRole(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfActionRoleSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfActionGridDto> {
        let url_ = this.baseUrl + "/api/ActionRole/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfActionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfActionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfActionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ActionRole/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/ActionRole/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IApaApi {

    sendBufferedRequests(x_Version?: string | null | undefined): Promise<number>;

    syncPermitTypes(x_Version?: string | null | undefined): Promise<number>;

    syncCountries(x_Version?: string | null | undefined): Promise<number>;

    syncGenders(x_Version?: string | null | undefined): Promise<number>;

    syncEmployees(x_Version?: string | null | undefined): Promise<number>;

    syncWelcomeOffices(x_Version?: string | null | undefined): Promise<number>;

    syncHourlyTypes(x_Version?: string | null | undefined): Promise<number>;

    syncLanguages(x_Version?: string | null | undefined): Promise<number>;

    syncStatuses(x_Version?: string | null | undefined): Promise<number>;

    syncNewcomers(x_Version?: string | null | undefined): Promise<number>;

    syncOperators(x_Version?: string | null | undefined): Promise<number>;

    syncTrainingTypes(x_Version?: string | null | undefined): Promise<number>;

    syncActivityTypes(x_Version?: string | null | undefined): Promise<number>;

    syncRegistrationsForTraining(x_Version?: string | null | undefined): Promise<number>;
}

export class ApaApi extends BaseAPI implements IApaApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    sendBufferedRequests(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Apa/SendBufferedRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendBufferedRequests(_response));
        });
    }

    protected processSendBufferedRequests(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    syncPermitTypes(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Apa/SyncApaPermitTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncPermitTypes(_response));
        });
    }

    protected processSyncPermitTypes(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    syncCountries(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Apa/SyncApaCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncCountries(_response));
        });
    }

    protected processSyncCountries(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    syncGenders(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Apa/SyncApaGenders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncGenders(_response));
        });
    }

    protected processSyncGenders(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    syncEmployees(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Apa/SyncApaEmployees";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncEmployees(_response));
        });
    }

    protected processSyncEmployees(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    syncWelcomeOffices(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Apa/SyncApaWelcomeOffices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncWelcomeOffices(_response));
        });
    }

    protected processSyncWelcomeOffices(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    syncHourlyTypes(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Apa/SyncApaHourlyTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncHourlyTypes(_response));
        });
    }

    protected processSyncHourlyTypes(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    syncLanguages(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Apa/SyncApaLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncLanguages(_response));
        });
    }

    protected processSyncLanguages(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    syncStatuses(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Apa/SyncApaStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncStatuses(_response));
        });
    }

    protected processSyncStatuses(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    syncNewcomers(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Apa/SyncApaNewcomers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncNewcomers(_response));
        });
    }

    protected processSyncNewcomers(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    syncOperators(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Apa/SyncApaOperators";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncOperators(_response));
        });
    }

    protected processSyncOperators(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    syncTrainingTypes(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Apa/SyncApaTrainingTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncTrainingTypes(_response));
        });
    }

    protected processSyncTrainingTypes(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    syncActivityTypes(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Apa/SyncApaActivityTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncActivityTypes(_response));
        });
    }

    protected processSyncActivityTypes(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    syncRegistrationsForTraining(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Apa/SyncApaRegistrationsForTraining";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncRegistrationsForTraining(_response));
        });
    }

    protected processSyncRegistrationsForTraining(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IAssignmentApi {

    getAssignment(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditAssignmentDto>;

    deleteAssignment(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    saveAssignment(saveDto: EditAssignmentDto, x_Version?: string | null | undefined): Promise<number>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    baseSearch(searchQuery: SearchQueryOfAssignmentSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfAssignmentGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class AssignmentApi extends BaseAPI implements IAssignmentApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAssignment(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditAssignmentDto> {
        let url_ = this.baseUrl + "/api/Assignment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAssignment(_response));
        });
    }

    protected processGetAssignment(response: Response): Promise<EditAssignmentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditAssignmentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditAssignmentDto>(null as any);
    }

    deleteAssignment(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Assignment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteAssignment(_response));
        });
    }

    protected processDeleteAssignment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveAssignment(saveDto: EditAssignmentDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Assignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveAssignment(_response));
        });
    }

    protected processSaveAssignment(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/Assignment/display-name?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfAssignmentSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfAssignmentGridDto> {
        let url_ = this.baseUrl + "/api/Assignment/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfAssignmentGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfAssignmentGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfAssignmentGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Assignment/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Assignment/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IAttendanceApi {

    baseSearch(sObj: SessionAttendeeSearch, x_Version?: string | null | undefined): Promise<PaginatedResultsOfSessionsAwaitingAttendanceGridDto>;

    getAttendeesForSession(sessionId?: number | undefined, x_Version?: string | null | undefined): Promise<AttendanceForSessionDto>;

    saveSessionAttendance(dto: AttendanceForSessionDto, x_Version?: string | null | undefined): Promise<number>;

    export(trainingId?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class AttendanceApi extends BaseAPI implements IAttendanceApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: SessionAttendeeSearch, x_Version?: string | null | undefined): Promise<PaginatedResultsOfSessionsAwaitingAttendanceGridDto> {
        let url_ = this.baseUrl + "/api/Attendance/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfSessionsAwaitingAttendanceGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfSessionsAwaitingAttendanceGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfSessionsAwaitingAttendanceGridDto>(null as any);
    }

    getAttendeesForSession(sessionId?: number | undefined, x_Version?: string | null | undefined): Promise<AttendanceForSessionDto> {
        let url_ = this.baseUrl + "/api/Attendance/getAttendeesForSession?";
        if (sessionId === null)
            throw new Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAttendeesForSession(_response));
        });
    }

    protected processGetAttendeesForSession(response: Response): Promise<AttendanceForSessionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendanceForSessionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttendanceForSessionDto>(null as any);
    }

    saveSessionAttendance(dto: AttendanceForSessionDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Attendance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveSessionAttendance(_response));
        });
    }

    protected processSaveSessionAttendance(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    export(trainingId?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Attendance/export?";
        if (trainingId === null)
            throw new Error("The parameter 'trainingId' cannot be null.");
        else if (trainingId !== undefined)
            url_ += "trainingId=" + encodeURIComponent("" + trainingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Attendance/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Attendance/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IAzureEventApi {

    syncAzureEvents(x_Version?: string | null | undefined): Promise<number>;
}

export class AzureEventApi extends BaseAPI implements IAzureEventApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    syncAzureEvents(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AzureEvent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncAzureEvents(_response));
        });
    }

    protected processSyncAzureEvents(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IContactApi {

    baseSearch(searchQuery: SearchQueryOfSearchContactDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfContactGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class ContactApi extends BaseAPI implements IContactApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(searchQuery: SearchQueryOfSearchContactDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfContactGridDto> {
        let url_ = this.baseUrl + "/api/Contact/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfContactGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfContactGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfContactGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Contact/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Contact/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IDataTranslationApi {

    updateTranslation(updateTranslationCommand: UpdateDataTranslationCommand, x_Version?: string | null | undefined): Promise<FileResponse>;

    export(x_Version?: string | null | undefined): Promise<FileResponse>;

    upload(x_Version?: string | null | undefined, file?: FileParameter | null | undefined): Promise<Result>;

    getImportTemplate(x_Version?: string | null | undefined): Promise<FileResponse>;

    baseSearch(searchQuery: SearchQueryOfDataTranslationInfoSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfDataTranslationGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class DataTranslationApi extends BaseAPI implements IDataTranslationApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    updateTranslation(updateTranslationCommand: UpdateDataTranslationCommand, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DataTranslation/UpdateTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateTranslationCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTranslation(_response));
        });
    }

    protected processUpdateTranslation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    export(x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DataTranslation/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upload(x_Version?: string | null | undefined, file?: FileParameter | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/DataTranslation/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpload(_response));
        });
    }

    protected processUpload(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getImportTemplate(x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DataTranslation/template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetImportTemplate(_response));
        });
    }

    protected processGetImportTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfDataTranslationInfoSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfDataTranslationGridDto> {
        let url_ = this.baseUrl + "/api/DataTranslation/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDataTranslationGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDataTranslationGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDataTranslationGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DataTranslation/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/DataTranslation/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IDutyApi {

    getDuty(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditDutyDto>;

    deleteDuty(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    saveDuty(saveDto: EditDutyDto, x_Version?: string | null | undefined): Promise<number>;

    getDutiesForEmployee(employeeId?: number | undefined, x_Version?: string | null | undefined): Promise<DutyGridDto[]>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    getDutiesByDateForEmployee(employeeId?: number | undefined, date?: Date | undefined, x_Version?: string | null | undefined): Promise<EditDutiesDto>;

    saveDutiesByDateForEmployee(dto: EditDutiesDto, x_Version?: string | null | undefined): Promise<number>;

    baseSearch(searchQuery: SearchQueryOfDutySearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfDutyGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class DutyApi extends BaseAPI implements IDutyApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDuty(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditDutyDto> {
        let url_ = this.baseUrl + "/api/Duty?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDuty(_response));
        });
    }

    protected processGetDuty(response: Response): Promise<EditDutyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditDutyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditDutyDto>(null as any);
    }

    deleteDuty(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Duty?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDuty(_response));
        });
    }

    protected processDeleteDuty(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveDuty(saveDto: EditDutyDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Duty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDuty(_response));
        });
    }

    protected processSaveDuty(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDutiesForEmployee(employeeId?: number | undefined, x_Version?: string | null | undefined): Promise<DutyGridDto[]> {
        let url_ = this.baseUrl + "/api/Duty/getDutiesForEmployee?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDutiesForEmployee(_response));
        });
    }

    protected processGetDutiesForEmployee(response: Response): Promise<DutyGridDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DutyGridDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DutyGridDto[]>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/Duty/display-name?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    getDutiesByDateForEmployee(employeeId?: number | undefined, date?: Date | undefined, x_Version?: string | null | undefined): Promise<EditDutiesDto> {
        let url_ = this.baseUrl + "/api/Duty/getDutiesByDateForEmployee?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDutiesByDateForEmployee(_response));
        });
    }

    protected processGetDutiesByDateForEmployee(response: Response): Promise<EditDutiesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditDutiesDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditDutiesDto>(null as any);
    }

    saveDutiesByDateForEmployee(dto: EditDutiesDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Duty/saveDutiesByDateForEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDutiesByDateForEmployee(_response));
        });
    }

    protected processSaveDutiesByDateForEmployee(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfDutySearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfDutyGridDto> {
        let url_ = this.baseUrl + "/api/Duty/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDutyGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDutyGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDutyGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Duty/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Duty/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IEmployeeApi {

    getEmployee(employeeId?: number | undefined, x_Version?: string | null | undefined): Promise<EditEmployeeDto>;

    saveEmployee(dto: EditEmployeeDto, x_Version?: string | null | undefined): Promise<number>;

    deleteEmployee(employeeId?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    getAllEmployees(employeePlanningDto: EmployeePlanningSearchDto, x_Version?: string | null | undefined): Promise<EmployeeCalendarInfoDto[]>;

    getEmployeeLanguagesQuery(contactId?: number | undefined, x_Version?: string | null | undefined): Promise<EmployeeLanguageDto[]>;

    getEmployeeDisplayName(employeeId?: number | undefined, x_Version?: string | null | undefined): Promise<string>;

    getEmployeeSiteId(employeeId?: number | undefined, x_Version?: string | null | undefined): Promise<number>;

    getAssessment(employeeId?: number | undefined, x_Version?: string | null | undefined): Promise<EditAssessmentDto>;

    saveAssessment(dto: EditAssessmentDto, x_Version?: string | null | undefined): Promise<number>;

    uploadEmployees(x_Version?: string | null | undefined, file?: FileParameter | null | undefined): Promise<Result>;

    baseSearch(searchQuery: SearchQueryOfEmployeeSearch, x_Version?: string | null | undefined): Promise<PaginatedResultsOfEmployeeGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class EmployeeApi extends BaseAPI implements IEmployeeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getEmployee(employeeId?: number | undefined, x_Version?: string | null | undefined): Promise<EditEmployeeDto> {
        let url_ = this.baseUrl + "/api/Employee?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEmployee(_response));
        });
    }

    protected processGetEmployee(response: Response): Promise<EditEmployeeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditEmployeeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditEmployeeDto>(null as any);
    }

    saveEmployee(dto: EditEmployeeDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveEmployee(_response));
        });
    }

    protected processSaveEmployee(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteEmployee(employeeId?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Employee?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteEmployee(_response));
        });
    }

    protected processDeleteEmployee(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAllEmployees(employeePlanningDto: EmployeePlanningSearchDto, x_Version?: string | null | undefined): Promise<EmployeeCalendarInfoDto[]> {
        let url_ = this.baseUrl + "/api/Employee/getAllEmployees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeePlanningDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllEmployees(_response));
        });
    }

    protected processGetAllEmployees(response: Response): Promise<EmployeeCalendarInfoDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeCalendarInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeCalendarInfoDto[]>(null as any);
    }

    getEmployeeLanguagesQuery(contactId?: number | undefined, x_Version?: string | null | undefined): Promise<EmployeeLanguageDto[]> {
        let url_ = this.baseUrl + "/api/Employee/contact_languages?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEmployeeLanguagesQuery(_response));
        });
    }

    protected processGetEmployeeLanguagesQuery(response: Response): Promise<EmployeeLanguageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeLanguageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeLanguageDto[]>(null as any);
    }

    getEmployeeDisplayName(employeeId?: number | undefined, x_Version?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Employee/display-name?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEmployeeDisplayName(_response));
        });
    }

    protected processGetEmployeeDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getEmployeeSiteId(employeeId?: number | undefined, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Employee/employee-siteId?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEmployeeSiteId(_response));
        });
    }

    protected processGetEmployeeSiteId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getAssessment(employeeId?: number | undefined, x_Version?: string | null | undefined): Promise<EditAssessmentDto> {
        let url_ = this.baseUrl + "/api/Employee/getAssessment?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAssessment(_response));
        });
    }

    protected processGetAssessment(response: Response): Promise<EditAssessmentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditAssessmentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditAssessmentDto>(null as any);
    }

    saveAssessment(dto: EditAssessmentDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Employee/saveAssessment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveAssessment(_response));
        });
    }

    protected processSaveAssessment(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    uploadEmployees(x_Version?: string | null | undefined, file?: FileParameter | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Employee/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadEmployees(_response));
        });
    }

    protected processUploadEmployees(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfEmployeeSearch, x_Version?: string | null | undefined): Promise<PaginatedResultsOfEmployeeGridDto> {
        let url_ = this.baseUrl + "/api/Employee/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfEmployeeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfEmployeeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfEmployeeGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Employee/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Employee/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IFunctionApi {

    getFunction(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditFunctionDto>;

    deleteFunction(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    saveFunction(saveDto: EditFunctionDto, x_Version?: string | null | undefined): Promise<number>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    baseSearch(searchQuery: SearchQueryOfFunctionSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfFunctionGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class FunctionApi extends BaseAPI implements IFunctionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getFunction(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditFunctionDto> {
        let url_ = this.baseUrl + "/api/Function?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFunction(_response));
        });
    }

    protected processGetFunction(response: Response): Promise<EditFunctionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditFunctionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditFunctionDto>(null as any);
    }

    deleteFunction(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Function?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteFunction(_response));
        });
    }

    protected processDeleteFunction(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveFunction(saveDto: EditFunctionDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Function";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveFunction(_response));
        });
    }

    protected processSaveFunction(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/Function/display-name?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfFunctionSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfFunctionGridDto> {
        let url_ = this.baseUrl + "/api/Function/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfFunctionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfFunctionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfFunctionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Function/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Function/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IHourlyTypeApi {

    getHourlyType(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditHourlyTypeDto>;

    saveHourlyType(saveDto: EditHourlyTypeDto, x_Version?: string | null | undefined): Promise<number>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    baseSearch(searchQuery: SearchQueryOfHourlyTypeSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfHourlyTypeGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class HourlyTypeApi extends BaseAPI implements IHourlyTypeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getHourlyType(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditHourlyTypeDto> {
        let url_ = this.baseUrl + "/api/HourlyType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHourlyType(_response));
        });
    }

    protected processGetHourlyType(response: Response): Promise<EditHourlyTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditHourlyTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditHourlyTypeDto>(null as any);
    }

    saveHourlyType(saveDto: EditHourlyTypeDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/HourlyType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveHourlyType(_response));
        });
    }

    protected processSaveHourlyType(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/HourlyType/display-name?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfHourlyTypeSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfHourlyTypeGridDto> {
        let url_ = this.baseUrl + "/api/HourlyType/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfHourlyTypeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfHourlyTypeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfHourlyTypeGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/HourlyType/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/HourlyType/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ILanguageApi {

    getLanguages(x_Version?: string | null | undefined): Promise<LanguageDto[]>;

    getKnowledgeLanguages(x_Version?: string | null | undefined): Promise<ApaLanguageDto[]>;

    getFrontLanguages(x_Version?: string | null | undefined): Promise<LanguageDto[]>;
}

export class LanguageApi extends BaseAPI implements ILanguageApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getLanguages(x_Version?: string | null | undefined): Promise<LanguageDto[]> {
        let url_ = this.baseUrl + "/api/Language";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLanguages(_response));
        });
    }

    protected processGetLanguages(response: Response): Promise<LanguageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LanguageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageDto[]>(null as any);
    }

    getKnowledgeLanguages(x_Version?: string | null | undefined): Promise<ApaLanguageDto[]> {
        let url_ = this.baseUrl + "/api/Language/knowledge-languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetKnowledgeLanguages(_response));
        });
    }

    protected processGetKnowledgeLanguages(response: Response): Promise<ApaLanguageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApaLanguageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApaLanguageDto[]>(null as any);
    }

    getFrontLanguages(x_Version?: string | null | undefined): Promise<LanguageDto[]> {
        let url_ = this.baseUrl + "/api/Language/front-languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFrontLanguages(_response));
        });
    }

    protected processGetFrontLanguages(response: Response): Promise<LanguageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LanguageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageDto[]>(null as any);
    }
}

export interface IMailApi {

    sendBufferedEmails(x_Version?: string | null | undefined): Promise<FileResponse>;
}

export class MailApi extends BaseAPI implements IMailApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    sendBufferedEmails(x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Mail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendBufferedEmails(_response));
        });
    }

    protected processSendBufferedEmails(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IMailTemplateApi {

    getMailTemplate(mailTemplateId?: number | undefined, x_Version?: string | null | undefined): Promise<EditMailTemplateDto>;

    getMailTemplateDisplayName(mailTemplateId?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    getMailTemplateContent(dto: MailTemplateContentGridDto, x_Version?: string | null | undefined): Promise<EditMailTemplateContentDto>;

    saveMailTemplateContent(toSave: EditMailTemplateContentDto, x_Version?: string | null | undefined): Promise<number>;

    saveMailTemplate(toSave: EditMailTemplateDto, x_Version?: string | null | undefined): Promise<number>;

    baseSearch(searchQuery: SearchQueryOfMailTemplateSearch, x_Version?: string | null | undefined): Promise<PaginatedResultsOfMailTemplateGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class MailTemplateApi extends BaseAPI implements IMailTemplateApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getMailTemplate(mailTemplateId?: number | undefined, x_Version?: string | null | undefined): Promise<EditMailTemplateDto> {
        let url_ = this.baseUrl + "/api/MailTemplate?";
        if (mailTemplateId === null)
            throw new Error("The parameter 'mailTemplateId' cannot be null.");
        else if (mailTemplateId !== undefined)
            url_ += "mailTemplateId=" + encodeURIComponent("" + mailTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMailTemplate(_response));
        });
    }

    protected processGetMailTemplate(response: Response): Promise<EditMailTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditMailTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditMailTemplateDto>(null as any);
    }

    getMailTemplateDisplayName(mailTemplateId?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/MailTemplate/displayName?";
        if (mailTemplateId === null)
            throw new Error("The parameter 'mailTemplateId' cannot be null.");
        else if (mailTemplateId !== undefined)
            url_ += "mailTemplateId=" + encodeURIComponent("" + mailTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMailTemplateDisplayName(_response));
        });
    }

    protected processGetMailTemplateDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    getMailTemplateContent(dto: MailTemplateContentGridDto, x_Version?: string | null | undefined): Promise<EditMailTemplateContentDto> {
        let url_ = this.baseUrl + "/api/MailTemplate/mailTemplateContent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMailTemplateContent(_response));
        });
    }

    protected processGetMailTemplateContent(response: Response): Promise<EditMailTemplateContentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditMailTemplateContentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditMailTemplateContentDto>(null as any);
    }

    saveMailTemplateContent(toSave: EditMailTemplateContentDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/MailTemplate/saveMailTemplateContent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveMailTemplateContent(_response));
        });
    }

    protected processSaveMailTemplateContent(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveMailTemplate(toSave: EditMailTemplateDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/MailTemplate/saveMailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveMailTemplate(_response));
        });
    }

    protected processSaveMailTemplate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfMailTemplateSearch, x_Version?: string | null | undefined): Promise<PaginatedResultsOfMailTemplateGridDto> {
        let url_ = this.baseUrl + "/api/MailTemplate/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfMailTemplateGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfMailTemplateGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfMailTemplateGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/MailTemplate/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/MailTemplate/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IMeetingApi {

    baseSearchByUser(searchQuery: SearchQueryOfMeetingSearchDto, employeId?: number | undefined, x_Version?: string | null | undefined): Promise<PaginatedResultsOfMeetingGridDto>;

    saveMeeting(dto: EditMeetingDto, x_Version?: string | null | undefined): Promise<number>;

    getMeeting(meetingId?: number | undefined, x_Version?: string | null | undefined): Promise<EditMeetingDto>;

    deleteMeeting(meetingId?: number | undefined, x_Version?: string | null | undefined): Promise<number>;

    getPossibleBookings(data: RoomBookingInformationFormDto, x_Version?: string | null | undefined): Promise<RoomBookingDto[]>;

    getMeetingDisplayName(meetingId?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    saveRoomBooking(data: RoomBookingDto, x_Version?: string | null | undefined): Promise<number>;

    getRoomBooking(meetingId?: number | undefined, x_Version?: string | null | undefined): Promise<RoomBookingDto>;

    deleteRoomBooking(roomBookingId?: number | undefined, x_Version?: string | null | undefined): Promise<number>;

    getMeetingsByEmployee(employeeId?: number | undefined, isPassed?: boolean | undefined, x_Version?: string | null | undefined): Promise<MeetingGridDto[]>;

    baseSearch(searchQuery: SearchQueryOfMeetingSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfMeetingGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class MeetingApi extends BaseAPI implements IMeetingApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearchByUser(searchQuery: SearchQueryOfMeetingSearchDto, employeId?: number | undefined, x_Version?: string | null | undefined): Promise<PaginatedResultsOfMeetingGridDto> {
        let url_ = this.baseUrl + "/api/Meeting/searchByUser?";
        if (employeId === null)
            throw new Error("The parameter 'employeId' cannot be null.");
        else if (employeId !== undefined)
            url_ += "employeId=" + encodeURIComponent("" + employeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearchByUser(_response));
        });
    }

    protected processBaseSearchByUser(response: Response): Promise<PaginatedResultsOfMeetingGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfMeetingGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfMeetingGridDto>(null as any);
    }

    saveMeeting(dto: EditMeetingDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Meeting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveMeeting(_response));
        });
    }

    protected processSaveMeeting(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getMeeting(meetingId?: number | undefined, x_Version?: string | null | undefined): Promise<EditMeetingDto> {
        let url_ = this.baseUrl + "/api/Meeting?";
        if (meetingId === null)
            throw new Error("The parameter 'meetingId' cannot be null.");
        else if (meetingId !== undefined)
            url_ += "meetingId=" + encodeURIComponent("" + meetingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMeeting(_response));
        });
    }

    protected processGetMeeting(response: Response): Promise<EditMeetingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditMeetingDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditMeetingDto>(null as any);
    }

    deleteMeeting(meetingId?: number | undefined, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Meeting?";
        if (meetingId === null)
            throw new Error("The parameter 'meetingId' cannot be null.");
        else if (meetingId !== undefined)
            url_ += "meetingId=" + encodeURIComponent("" + meetingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteMeeting(_response));
        });
    }

    protected processDeleteMeeting(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getPossibleBookings(data: RoomBookingInformationFormDto, x_Version?: string | null | undefined): Promise<RoomBookingDto[]> {
        let url_ = this.baseUrl + "/api/Meeting/getPossibleBookings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPossibleBookings(_response));
        });
    }

    protected processGetPossibleBookings(response: Response): Promise<RoomBookingDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomBookingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomBookingDto[]>(null as any);
    }

    getMeetingDisplayName(meetingId?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/Meeting/display-name?";
        if (meetingId === null)
            throw new Error("The parameter 'meetingId' cannot be null.");
        else if (meetingId !== undefined)
            url_ += "meetingId=" + encodeURIComponent("" + meetingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMeetingDisplayName(_response));
        });
    }

    protected processGetMeetingDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    saveRoomBooking(data: RoomBookingDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Meeting/saveRoomBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveRoomBooking(_response));
        });
    }

    protected processSaveRoomBooking(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getRoomBooking(meetingId?: number | undefined, x_Version?: string | null | undefined): Promise<RoomBookingDto> {
        let url_ = this.baseUrl + "/api/Meeting/getRoomBooking?";
        if (meetingId === null)
            throw new Error("The parameter 'meetingId' cannot be null.");
        else if (meetingId !== undefined)
            url_ += "meetingId=" + encodeURIComponent("" + meetingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRoomBooking(_response));
        });
    }

    protected processGetRoomBooking(response: Response): Promise<RoomBookingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoomBookingDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomBookingDto>(null as any);
    }

    deleteRoomBooking(roomBookingId?: number | undefined, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Meeting/deleteRoomBooking?";
        if (roomBookingId === null)
            throw new Error("The parameter 'roomBookingId' cannot be null.");
        else if (roomBookingId !== undefined)
            url_ += "roomBookingId=" + encodeURIComponent("" + roomBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteRoomBooking(_response));
        });
    }

    protected processDeleteRoomBooking(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getMeetingsByEmployee(employeeId?: number | undefined, isPassed?: boolean | undefined, x_Version?: string | null | undefined): Promise<MeetingGridDto[]> {
        let url_ = this.baseUrl + "/api/Meeting/getMeetingsByEmployee?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (isPassed === null)
            throw new Error("The parameter 'isPassed' cannot be null.");
        else if (isPassed !== undefined)
            url_ += "isPassed=" + encodeURIComponent("" + isPassed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMeetingsByEmployee(_response));
        });
    }

    protected processGetMeetingsByEmployee(response: Response): Promise<MeetingGridDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeetingGridDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingGridDto[]>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfMeetingSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfMeetingGridDto> {
        let url_ = this.baseUrl + "/api/Meeting/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfMeetingGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfMeetingGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfMeetingGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Meeting/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Meeting/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IMeetingDashboardApi {

    baseSearch(searchQuery: SearchQueryOfMeetingDashboardSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfMeetingGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class MeetingDashboardApi extends BaseAPI implements IMeetingDashboardApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(searchQuery: SearchQueryOfMeetingDashboardSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfMeetingGridDto> {
        let url_ = this.baseUrl + "/api/MeetingDashboard/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfMeetingGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfMeetingGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfMeetingGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/MeetingDashboard/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/MeetingDashboard/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IMeetingTypeApi {

    getMeetingType(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditMeetingTypeDto>;

    deleteMeetingType(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    saveMeetingType(saveDto: EditMeetingTypeDto, x_Version?: string | null | undefined): Promise<number>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    baseSearch(searchQuery: SearchQueryOfMeetingTypeSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfMeetingTypeGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class MeetingTypeApi extends BaseAPI implements IMeetingTypeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getMeetingType(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditMeetingTypeDto> {
        let url_ = this.baseUrl + "/api/MeetingType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMeetingType(_response));
        });
    }

    protected processGetMeetingType(response: Response): Promise<EditMeetingTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditMeetingTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditMeetingTypeDto>(null as any);
    }

    deleteMeetingType(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MeetingType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteMeetingType(_response));
        });
    }

    protected processDeleteMeetingType(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveMeetingType(saveDto: EditMeetingTypeDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/MeetingType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveMeetingType(_response));
        });
    }

    protected processSaveMeetingType(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/MeetingType/display-name?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfMeetingTypeSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfMeetingTypeGridDto> {
        let url_ = this.baseUrl + "/api/MeetingType/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfMeetingTypeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfMeetingTypeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfMeetingTypeGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/MeetingType/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/MeetingType/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface INewComerApi {

    getNewComer(newComerId?: number | undefined, x_Version?: string | null | undefined): Promise<NewComerDto>;

    saveNewComerLanguages(nc: NewComerDto, x_Version?: string | null | undefined): Promise<number>;

    getNewComerLanguagesQuery(contactId?: number | undefined, x_Version?: string | null | undefined): Promise<NewComerLanguageDto[]>;

    getNewComerStatusInfos(newComerId?: number | undefined, x_Version?: string | null | undefined): Promise<NewComerStatusInfoDto>;

    getNewComerDisplayName(newComerId?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    getNewcomerApaTrainingHistory(newcomerId?: number | undefined, x_Version?: string | null | undefined): Promise<ApaTrainingGridDto[]>;

    getNewcomerMeetings(newcomerId?: number | undefined, x_Version?: string | null | undefined): Promise<MeetingGridDto[]>;

    baseSearch(searchQuery: SearchQueryOfNewComerSearch, x_Version?: string | null | undefined): Promise<PaginatedResultsOfNewComerGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class NewComerApi extends BaseAPI implements INewComerApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getNewComer(newComerId?: number | undefined, x_Version?: string | null | undefined): Promise<NewComerDto> {
        let url_ = this.baseUrl + "/api/NewComer?";
        if (newComerId === null)
            throw new Error("The parameter 'newComerId' cannot be null.");
        else if (newComerId !== undefined)
            url_ += "newComerId=" + encodeURIComponent("" + newComerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNewComer(_response));
        });
    }

    protected processGetNewComer(response: Response): Promise<NewComerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewComerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewComerDto>(null as any);
    }

    saveNewComerLanguages(nc: NewComerDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/NewComer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nc);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNewComerLanguages(_response));
        });
    }

    protected processSaveNewComerLanguages(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getNewComerLanguagesQuery(contactId?: number | undefined, x_Version?: string | null | undefined): Promise<NewComerLanguageDto[]> {
        let url_ = this.baseUrl + "/api/NewComer/contact_languages?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNewComerLanguagesQuery(_response));
        });
    }

    protected processGetNewComerLanguagesQuery(response: Response): Promise<NewComerLanguageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewComerLanguageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewComerLanguageDto[]>(null as any);
    }

    getNewComerStatusInfos(newComerId?: number | undefined, x_Version?: string | null | undefined): Promise<NewComerStatusInfoDto> {
        let url_ = this.baseUrl + "/api/NewComer/GetNewComerStatusInfos?";
        if (newComerId === null)
            throw new Error("The parameter 'newComerId' cannot be null.");
        else if (newComerId !== undefined)
            url_ += "newComerId=" + encodeURIComponent("" + newComerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNewComerStatusInfos(_response));
        });
    }

    protected processGetNewComerStatusInfos(response: Response): Promise<NewComerStatusInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewComerStatusInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewComerStatusInfoDto>(null as any);
    }

    getNewComerDisplayName(newComerId?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/NewComer/display-name?";
        if (newComerId === null)
            throw new Error("The parameter 'newComerId' cannot be null.");
        else if (newComerId !== undefined)
            url_ += "newComerId=" + encodeURIComponent("" + newComerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNewComerDisplayName(_response));
        });
    }

    protected processGetNewComerDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    getNewcomerApaTrainingHistory(newcomerId?: number | undefined, x_Version?: string | null | undefined): Promise<ApaTrainingGridDto[]> {
        let url_ = this.baseUrl + "/api/NewComer/GetNewcomerApaTrainingHistory?";
        if (newcomerId === null)
            throw new Error("The parameter 'newcomerId' cannot be null.");
        else if (newcomerId !== undefined)
            url_ += "newcomerId=" + encodeURIComponent("" + newcomerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNewcomerApaTrainingHistory(_response));
        });
    }

    protected processGetNewcomerApaTrainingHistory(response: Response): Promise<ApaTrainingGridDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApaTrainingGridDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApaTrainingGridDto[]>(null as any);
    }

    getNewcomerMeetings(newcomerId?: number | undefined, x_Version?: string | null | undefined): Promise<MeetingGridDto[]> {
        let url_ = this.baseUrl + "/api/NewComer/GetNewcomerMeetings?";
        if (newcomerId === null)
            throw new Error("The parameter 'newcomerId' cannot be null.");
        else if (newcomerId !== undefined)
            url_ += "newcomerId=" + encodeURIComponent("" + newcomerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNewcomerMeetings(_response));
        });
    }

    protected processGetNewcomerMeetings(response: Response): Promise<MeetingGridDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeetingGridDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingGridDto[]>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfNewComerSearch, x_Version?: string | null | undefined): Promise<PaginatedResultsOfNewComerGridDto> {
        let url_ = this.baseUrl + "/api/NewComer/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfNewComerGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfNewComerGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfNewComerGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/NewComer/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/NewComer/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface INewComerFileApi {

    downloadNewComerFile(newComerFileId?: number | undefined, x_Version?: string | null | undefined): Promise<FileDownloadDto>;

    uploadNewComerFiles(newComerId?: number | undefined, x_Version?: string | null | undefined, file?: FileParameter | null | undefined): Promise<number>;

    deleteNewComerFile(newComerFileId?: number | undefined, x_Version?: string | null | undefined): Promise<number>;

    baseSearch(searchQuery: SearchQueryOfNewComerFileSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfNewComerFileGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class NewComerFileApi extends BaseAPI implements INewComerFileApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    downloadNewComerFile(newComerFileId?: number | undefined, x_Version?: string | null | undefined): Promise<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/NewComerFile/download?";
        if (newComerFileId === null)
            throw new Error("The parameter 'newComerFileId' cannot be null.");
        else if (newComerFileId !== undefined)
            url_ += "newComerFileId=" + encodeURIComponent("" + newComerFileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadNewComerFile(_response));
        });
    }

    protected processDownloadNewComerFile(response: Response): Promise<FileDownloadDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDownloadDto>(null as any);
    }

    uploadNewComerFiles(newComerId?: number | undefined, x_Version?: string | null | undefined, file?: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/NewComerFile/upload?";
        if (newComerId === null)
            throw new Error("The parameter 'newComerId' cannot be null.");
        else if (newComerId !== undefined)
            url_ += "NewComerId=" + encodeURIComponent("" + newComerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadNewComerFiles(_response));
        });
    }

    protected processUploadNewComerFiles(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteNewComerFile(newComerFileId?: number | undefined, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/NewComerFile?";
        if (newComerFileId === null)
            throw new Error("The parameter 'newComerFileId' cannot be null.");
        else if (newComerFileId !== undefined)
            url_ += "newComerFileId=" + encodeURIComponent("" + newComerFileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteNewComerFile(_response));
        });
    }

    protected processDeleteNewComerFile(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfNewComerFileSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfNewComerFileGridDto> {
        let url_ = this.baseUrl + "/api/NewComerFile/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfNewComerFileGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfNewComerFileGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfNewComerFileGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/NewComerFile/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/NewComerFile/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IOccupationApi {

    getEmployeeOccupations(data: EmployeeOccupationsFormDto, x_Version?: string | null | undefined): Promise<EmployeeOccupationDto[]>;

    getAbsences(datefrom?: Date | undefined, dateTo?: Date | undefined, x_Version?: string | null | undefined): Promise<EmployeeOccupationDto[]>;

    getRoomOccupations(data: RoomOccupationFormDataDto, x_Version?: string | null | undefined): Promise<RoomOccupationDto[]>;
}

export class OccupationApi extends BaseAPI implements IOccupationApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getEmployeeOccupations(data: EmployeeOccupationsFormDto, x_Version?: string | null | undefined): Promise<EmployeeOccupationDto[]> {
        let url_ = this.baseUrl + "/api/Occupation/employeeOccupations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEmployeeOccupations(_response));
        });
    }

    protected processGetEmployeeOccupations(response: Response): Promise<EmployeeOccupationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeOccupationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeOccupationDto[]>(null as any);
    }

    getAbsences(datefrom?: Date | undefined, dateTo?: Date | undefined, x_Version?: string | null | undefined): Promise<EmployeeOccupationDto[]> {
        let url_ = this.baseUrl + "/api/Occupation/employeeAbsences?";
        if (datefrom === null)
            throw new Error("The parameter 'datefrom' cannot be null.");
        else if (datefrom !== undefined)
            url_ += "datefrom=" + encodeURIComponent(datefrom ? "" + datefrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAbsences(_response));
        });
    }

    protected processGetAbsences(response: Response): Promise<EmployeeOccupationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeOccupationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeOccupationDto[]>(null as any);
    }

    getRoomOccupations(data: RoomOccupationFormDataDto, x_Version?: string | null | undefined): Promise<RoomOccupationDto[]> {
        let url_ = this.baseUrl + "/api/Occupation/roomOccupations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRoomOccupations(_response));
        });
    }

    protected processGetRoomOccupations(response: Response): Promise<RoomOccupationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomOccupationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomOccupationDto[]>(null as any);
    }
}

export interface IPartnerApi {

    getPartner(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditPartnerDto>;

    deletePartner(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    savePartner(saveDto: EditPartnerDto, x_Version?: string | null | undefined): Promise<number>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    baseSearch(searchQuery: SearchQueryOfPartnerSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfPartnerGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class PartnerApi extends BaseAPI implements IPartnerApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getPartner(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditPartnerDto> {
        let url_ = this.baseUrl + "/api/Partner?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPartner(_response));
        });
    }

    protected processGetPartner(response: Response): Promise<EditPartnerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditPartnerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditPartnerDto>(null as any);
    }

    deletePartner(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Partner?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeletePartner(_response));
        });
    }

    protected processDeletePartner(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    savePartner(saveDto: EditPartnerDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Partner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSavePartner(_response));
        });
    }

    protected processSavePartner(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/Partner/display-name?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfPartnerSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfPartnerGridDto> {
        let url_ = this.baseUrl + "/api/Partner/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfPartnerGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfPartnerGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfPartnerGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Partner/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Partner/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IPartnerTypeApi {

    getPartnerType(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditPartnerTypeDto>;

    deletePartnerType(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    savePartnerType(saveDto: EditPartnerTypeDto, x_Version?: string | null | undefined): Promise<number>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    baseSearch(searchQuery: SearchQueryOfPartnerTypeSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfPartnerTypeGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class PartnerTypeApi extends BaseAPI implements IPartnerTypeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getPartnerType(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditPartnerTypeDto> {
        let url_ = this.baseUrl + "/api/PartnerType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPartnerType(_response));
        });
    }

    protected processGetPartnerType(response: Response): Promise<EditPartnerTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditPartnerTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditPartnerTypeDto>(null as any);
    }

    deletePartnerType(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/PartnerType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeletePartnerType(_response));
        });
    }

    protected processDeletePartnerType(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    savePartnerType(saveDto: EditPartnerTypeDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/PartnerType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSavePartnerType(_response));
        });
    }

    protected processSavePartnerType(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/PartnerType/display-name?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfPartnerTypeSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfPartnerTypeGridDto> {
        let url_ = this.baseUrl + "/api/PartnerType/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfPartnerTypeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfPartnerTypeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfPartnerTypeGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/PartnerType/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/PartnerType/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IReferentialApi {

    languages(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    roles(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    validationValues(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    operators(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    trainers(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    countries(x_Version?: string | null | undefined): Promise<CountryReferentialDto[]>;

    postalCodes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    cities(postalCode?: number | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    sites(x_Version?: string | null | undefined): Promise<SiteReferentialDto[]>;

    rooms(mergeableWithSourceRoomId?: number | null | undefined, mergeableWithSourceSiteId?: number | null | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    roomsBySite(siteId?: number | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    functions(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    assignments(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    emailTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    phoneNumberTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    genders(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    trainingTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    activeAndCurrentTrainingTypes(currentTrainingId?: number | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    hourlyTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    mainSites(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    operatorTypes(x_Version?: string | null | undefined): Promise<OperatorTypeReferentialItemDto[]>;

    trainerByLanguageAndTrainingType(languageId?: number | undefined, trainingTypes?: ETrainingTypes | null | undefined, trainingtypeId?: number | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    employees(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    planningTypes(x_Version?: string | null | undefined): Promise<PlaningTypeReferentialItemDto[]>;

    knowledgeLanguages(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    actions(alreadyUsedActionIds: number[], x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    sessions(trainingId?: number | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    meetingTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    partnerTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    thematicTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    availableEmployeesForMeeting(meetingId?: number | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;

    newComers(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class ReferentialApi extends BaseAPI implements IReferentialApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    languages(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLanguages(_response));
        });
    }

    protected processLanguages(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    roles(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRoles(_response));
        });
    }

    protected processRoles(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    validationValues(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/validationValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidationValues(_response));
        });
    }

    protected processValidationValues(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    operators(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/operators";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOperators(_response));
        });
    }

    protected processOperators(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    trainers(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/trainers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTrainers(_response));
        });
    }

    protected processTrainers(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    countries(x_Version?: string | null | undefined): Promise<CountryReferentialDto[]> {
        let url_ = this.baseUrl + "/api/Referential/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCountries(_response));
        });
    }

    protected processCountries(response: Response): Promise<CountryReferentialDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryReferentialDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryReferentialDto[]>(null as any);
    }

    postalCodes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/postal-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPostalCodes(_response));
        });
    }

    protected processPostalCodes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    cities(postalCode?: number | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/cities?";
        if (postalCode === null)
            throw new Error("The parameter 'postalCode' cannot be null.");
        else if (postalCode !== undefined)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCities(_response));
        });
    }

    protected processCities(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    sites(x_Version?: string | null | undefined): Promise<SiteReferentialDto[]> {
        let url_ = this.baseUrl + "/api/Referential/sites";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSites(_response));
        });
    }

    protected processSites(response: Response): Promise<SiteReferentialDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteReferentialDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SiteReferentialDto[]>(null as any);
    }

    rooms(mergeableWithSourceRoomId?: number | null | undefined, mergeableWithSourceSiteId?: number | null | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/rooms?";
        if (mergeableWithSourceRoomId !== undefined && mergeableWithSourceRoomId !== null)
            url_ += "MergeableWithSourceRoomId=" + encodeURIComponent("" + mergeableWithSourceRoomId) + "&";
        if (mergeableWithSourceSiteId !== undefined && mergeableWithSourceSiteId !== null)
            url_ += "MergeableWithSourceSiteId=" + encodeURIComponent("" + mergeableWithSourceSiteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRooms(_response));
        });
    }

    protected processRooms(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    roomsBySite(siteId?: number | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/roomsBySite?";
        if (siteId === null)
            throw new Error("The parameter 'siteId' cannot be null.");
        else if (siteId !== undefined)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRoomsBySite(_response));
        });
    }

    protected processRoomsBySite(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    functions(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/functions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFunctions(_response));
        });
    }

    protected processFunctions(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    assignments(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/assignments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAssignments(_response));
        });
    }

    protected processAssignments(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    emailTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/emailTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEmailTypes(_response));
        });
    }

    protected processEmailTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    phoneNumberTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/phoneNumberTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPhoneNumberTypes(_response));
        });
    }

    protected processPhoneNumberTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    genders(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/genders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenders(_response));
        });
    }

    protected processGenders(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    trainingTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/trainingTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTrainingTypes(_response));
        });
    }

    protected processTrainingTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    activeAndCurrentTrainingTypes(currentTrainingId?: number | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/activeAndCurrentTrainingTypes?";
        if (currentTrainingId === null)
            throw new Error("The parameter 'currentTrainingId' cannot be null.");
        else if (currentTrainingId !== undefined)
            url_ += "currentTrainingId=" + encodeURIComponent("" + currentTrainingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActiveAndCurrentTrainingTypes(_response));
        });
    }

    protected processActiveAndCurrentTrainingTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    hourlyTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/hourlyTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHourlyTypes(_response));
        });
    }

    protected processHourlyTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    mainSites(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/mainSites";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMainSites(_response));
        });
    }

    protected processMainSites(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    operatorTypes(x_Version?: string | null | undefined): Promise<OperatorTypeReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/operatorTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOperatorTypes(_response));
        });
    }

    protected processOperatorTypes(response: Response): Promise<OperatorTypeReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OperatorTypeReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OperatorTypeReferentialItemDto[]>(null as any);
    }

    trainerByLanguageAndTrainingType(languageId?: number | undefined, trainingTypes?: ETrainingTypes | null | undefined, trainingtypeId?: number | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/trainerByLanguageAndTrainingType?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        if (trainingTypes !== undefined && trainingTypes !== null)
            url_ += "trainingTypes=" + encodeURIComponent("" + trainingTypes) + "&";
        if (trainingtypeId === null)
            throw new Error("The parameter 'trainingtypeId' cannot be null.");
        else if (trainingtypeId !== undefined)
            url_ += "trainingtypeId=" + encodeURIComponent("" + trainingtypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTrainerByLanguageAndTrainingType(_response));
        });
    }

    protected processTrainerByLanguageAndTrainingType(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    employees(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/employees";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEmployees(_response));
        });
    }

    protected processEmployees(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    planningTypes(x_Version?: string | null | undefined): Promise<PlaningTypeReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/planningTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPlanningTypes(_response));
        });
    }

    protected processPlanningTypes(response: Response): Promise<PlaningTypeReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaningTypeReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaningTypeReferentialItemDto[]>(null as any);
    }

    knowledgeLanguages(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/knowledgeLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processKnowledgeLanguages(_response));
        });
    }

    protected processKnowledgeLanguages(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    actions(alreadyUsedActionIds: number[], x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/actions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alreadyUsedActionIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActions(_response));
        });
    }

    protected processActions(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    sessions(trainingId?: number | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/sessions?";
        if (trainingId === null)
            throw new Error("The parameter 'trainingId' cannot be null.");
        else if (trainingId !== undefined)
            url_ += "trainingId=" + encodeURIComponent("" + trainingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSessions(_response));
        });
    }

    protected processSessions(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    meetingTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/meetingTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMeetingTypes(_response));
        });
    }

    protected processMeetingTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    partnerTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/partnerTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPartnerTypes(_response));
        });
    }

    protected processPartnerTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    thematicTypes(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/thematicTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processThematicTypes(_response));
        });
    }

    protected processThematicTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    availableEmployeesForMeeting(meetingId?: number | undefined, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/availableEmployeesForMeeting?";
        if (meetingId === null)
            throw new Error("The parameter 'meetingId' cannot be null.");
        else if (meetingId !== undefined)
            url_ += "meetingId=" + encodeURIComponent("" + meetingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableEmployeesForMeeting(_response));
        });
    }

    protected processAvailableEmployeesForMeeting(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    newComers(x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/newComers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNewComers(_response));
        });
    }

    protected processNewComers(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IRegistrationApi {

    getRegistrationsForTraining(id?: number | undefined, x_Version?: string | null | undefined): Promise<RegistrationDto[]>;

    getNumberOfRegistrationsForTraining(id?: number | undefined, x_Version?: string | null | undefined): Promise<RegistrationNumbersDto>;

    registerNewComers(newComersToRegisterDto: NewComersToRegisterDto, x_Version?: string | null | undefined): Promise<NewComersToRegisterDto>;

    deleteRegistration(registrationId?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;
}

export class RegistrationApi extends BaseAPI implements IRegistrationApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getRegistrationsForTraining(id?: number | undefined, x_Version?: string | null | undefined): Promise<RegistrationDto[]> {
        let url_ = this.baseUrl + "/api/Registration/getRegistrationsForTraining?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRegistrationsForTraining(_response));
        });
    }

    protected processGetRegistrationsForTraining(response: Response): Promise<RegistrationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationDto[]>(null as any);
    }

    getNumberOfRegistrationsForTraining(id?: number | undefined, x_Version?: string | null | undefined): Promise<RegistrationNumbersDto> {
        let url_ = this.baseUrl + "/api/Registration/getNumberOfRegistrationsForTraining?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNumberOfRegistrationsForTraining(_response));
        });
    }

    protected processGetNumberOfRegistrationsForTraining(response: Response): Promise<RegistrationNumbersDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationNumbersDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationNumbersDto>(null as any);
    }

    registerNewComers(newComersToRegisterDto: NewComersToRegisterDto, x_Version?: string | null | undefined): Promise<NewComersToRegisterDto> {
        let url_ = this.baseUrl + "/api/Registration/registerNewComers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newComersToRegisterDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRegisterNewComers(_response));
        });
    }

    protected processRegisterNewComers(response: Response): Promise<NewComersToRegisterDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewComersToRegisterDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewComersToRegisterDto>(null as any);
    }

    deleteRegistration(registrationId?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Registration?";
        if (registrationId === null)
            throw new Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteRegistration(_response));
        });
    }

    protected processDeleteRegistration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IReminderPhoneCallApi {

    getReminderPhoneCall(employeeId?: number | undefined, x_Version?: string | null | undefined): Promise<EditReminderPhoneCallDto>;
}

export class ReminderPhoneCallApi extends BaseAPI implements IReminderPhoneCallApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getReminderPhoneCall(employeeId?: number | undefined, x_Version?: string | null | undefined): Promise<EditReminderPhoneCallDto> {
        let url_ = this.baseUrl + "/api/ReminderPhoneCall?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReminderPhoneCall(_response));
        });
    }

    protected processGetReminderPhoneCall(response: Response): Promise<EditReminderPhoneCallDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditReminderPhoneCallDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditReminderPhoneCallDto>(null as any);
    }
}

export interface IReportApi {

    generateTestReport(data: TestReportDto, x_Version?: string | null | undefined): Promise<FileResponse>;

    generateSessionReport(x_Version?: string | null | undefined): Promise<FileResponse>;
}

export class ReportApi extends BaseAPI implements IReportApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    generateTestReport(data: TestReportDto, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Report/test";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateTestReport(_response));
        });
    }

    protected processGenerateTestReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generateSessionReport(x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Report/sessionReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateSessionReport(_response));
        });
    }

    protected processGenerateSessionReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IRoomApi {

    getRoom(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditRoomDto>;

    saveRoom(roomDto: EditRoomDto, x_Version?: string | null | undefined): Promise<number>;

    deleteRoom(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<string>;

    getLinkedRoomCapacity(otherRoomId?: number | undefined, x_Version?: string | null | undefined): Promise<number>;

    baseSearch(searchQuery: SearchQueryOfRoomSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfRoomGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class RoomApi extends BaseAPI implements IRoomApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getRoom(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditRoomDto> {
        let url_ = this.baseUrl + "/api/Room?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRoom(_response));
        });
    }

    protected processGetRoom(response: Response): Promise<EditRoomDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditRoomDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditRoomDto>(null as any);
    }

    saveRoom(roomDto: EditRoomDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Room";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roomDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveRoom(_response));
        });
    }

    protected processSaveRoom(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteRoom(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Room?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteRoom(_response));
        });
    }

    protected processDeleteRoom(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Room/display-name?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getLinkedRoomCapacity(otherRoomId?: number | undefined, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Room/rooms-capacity?";
        if (otherRoomId === null)
            throw new Error("The parameter 'otherRoomId' cannot be null.");
        else if (otherRoomId !== undefined)
            url_ += "otherRoomId=" + encodeURIComponent("" + otherRoomId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLinkedRoomCapacity(_response));
        });
    }

    protected processGetLinkedRoomCapacity(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfRoomSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfRoomGridDto> {
        let url_ = this.baseUrl + "/api/Room/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfRoomGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfRoomGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfRoomGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Room/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Room/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ISessionApi {

    saveSession(toSave: EditSessionDto, x_Version?: string | null | undefined): Promise<number>;

    deleteSession(sessionId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean>;

    baseSearch(searchQuery: SearchQueryOfSessionSearch, x_Version?: string | null | undefined): Promise<PaginatedResultsOfSessionGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class SessionApi extends BaseAPI implements ISessionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    saveSession(toSave: EditSessionDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Session/saveSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveSession(_response));
        });
    }

    protected processSaveSession(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteSession(sessionId?: number | undefined, x_Version?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Session/deleteSession?";
        if (sessionId === null)
            throw new Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteSession(_response));
        });
    }

    protected processDeleteSession(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfSessionSearch, x_Version?: string | null | undefined): Promise<PaginatedResultsOfSessionGridDto> {
        let url_ = this.baseUrl + "/api/Session/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfSessionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfSessionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfSessionGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Session/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Session/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ISiteApi {

    baseSearch(sObj: PaginatedSearch, x_Version?: string | null | undefined): Promise<PaginatedResultsOfSiteGridDto>;

    getSite(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditSiteDto>;

    saveSite(dto: EditSiteDto, x_Version?: string | null | undefined): Promise<number>;

    deleteSite(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<string>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class SiteApi extends BaseAPI implements ISiteApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: PaginatedSearch, x_Version?: string | null | undefined): Promise<PaginatedResultsOfSiteGridDto> {
        let url_ = this.baseUrl + "/api/Site/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfSiteGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfSiteGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfSiteGridDto>(null as any);
    }

    getSite(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditSiteDto> {
        let url_ = this.baseUrl + "/api/Site?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSite(_response));
        });
    }

    protected processGetSite(response: Response): Promise<EditSiteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditSiteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditSiteDto>(null as any);
    }

    saveSite(dto: EditSiteDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Site";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveSite(_response));
        });
    }

    protected processSaveSite(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteSite(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Site?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteSite(_response));
        });
    }

    protected processDeleteSite(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Site/display-name?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Site/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Site/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ISmsTemplateApi {

    getSmsTemplate(smsTemplateId?: number | undefined, x_Version?: string | null | undefined): Promise<EditSmsTemplateDto>;

    getSmsTemplateDisplayName(smsTemplateId?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    getSmsContent(dto: SmsContentGridDto, x_Version?: string | null | undefined): Promise<EditSmsContentDto>;

    saveSmsContent(toSave: EditSmsContentDto, x_Version?: string | null | undefined): Promise<number>;

    saveSmsTemplate(toSave: EditSmsTemplateDto, x_Version?: string | null | undefined): Promise<number>;

    baseSearch(searchQuery: SearchQueryOfSmsTemplateSearch, x_Version?: string | null | undefined): Promise<PaginatedResultsOfSmsTemplateGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class SmsTemplateApi extends BaseAPI implements ISmsTemplateApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getSmsTemplate(smsTemplateId?: number | undefined, x_Version?: string | null | undefined): Promise<EditSmsTemplateDto> {
        let url_ = this.baseUrl + "/api/SmsTemplate?";
        if (smsTemplateId === null)
            throw new Error("The parameter 'smsTemplateId' cannot be null.");
        else if (smsTemplateId !== undefined)
            url_ += "smsTemplateId=" + encodeURIComponent("" + smsTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSmsTemplate(_response));
        });
    }

    protected processGetSmsTemplate(response: Response): Promise<EditSmsTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditSmsTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditSmsTemplateDto>(null as any);
    }

    getSmsTemplateDisplayName(smsTemplateId?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/SmsTemplate/displayName?";
        if (smsTemplateId === null)
            throw new Error("The parameter 'smsTemplateId' cannot be null.");
        else if (smsTemplateId !== undefined)
            url_ += "smsTemplateId=" + encodeURIComponent("" + smsTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSmsTemplateDisplayName(_response));
        });
    }

    protected processGetSmsTemplateDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    getSmsContent(dto: SmsContentGridDto, x_Version?: string | null | undefined): Promise<EditSmsContentDto> {
        let url_ = this.baseUrl + "/api/SmsTemplate/smsContent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSmsContent(_response));
        });
    }

    protected processGetSmsContent(response: Response): Promise<EditSmsContentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditSmsContentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditSmsContentDto>(null as any);
    }

    saveSmsContent(toSave: EditSmsContentDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/SmsTemplate/saveSmsContent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveSmsContent(_response));
        });
    }

    protected processSaveSmsContent(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveSmsTemplate(toSave: EditSmsTemplateDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/SmsTemplate/saveSmsTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveSmsTemplate(_response));
        });
    }

    protected processSaveSmsTemplate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfSmsTemplateSearch, x_Version?: string | null | undefined): Promise<PaginatedResultsOfSmsTemplateGridDto> {
        let url_ = this.baseUrl + "/api/SmsTemplate/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfSmsTemplateGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfSmsTemplateGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfSmsTemplateGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/SmsTemplate/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/SmsTemplate/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ISystemApi {

    get(x_Version?: string | null | undefined): Promise<SystemInfoDto>;

    getExposedTypes(x_Version?: string | null | undefined): Promise<ExposedTypes>;

    loadBapas(x_Version?: string | null | undefined): Promise<number>;

    loadCountries(x_Version?: string | null | undefined): Promise<number>;

    loadLanguages(x_Version?: string | null | undefined): Promise<number>;

    loadLookups(x_Version?: string | null | undefined): Promise<number>;

    loadOperators(x_Version?: string | null | undefined): Promise<number>;

    loadStatuses(x_Version?: string | null | undefined): Promise<number>;

    loadTrainings(x_Version?: string | null | undefined): Promise<number>;

    frontendSettings(x_Version?: string | null | undefined): Promise<FrontendSettings>;
}

export class SystemApi extends BaseAPI implements ISystemApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(x_Version?: string | null | undefined): Promise<SystemInfoDto> {
        let url_ = this.baseUrl + "/api/System";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SystemInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemInfoDto>(null as any);
    }

    getExposedTypes(x_Version?: string | null | undefined): Promise<ExposedTypes> {
        let url_ = this.baseUrl + "/api/System/exposed-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExposedTypes(_response));
        });
    }

    protected processGetExposedTypes(response: Response): Promise<ExposedTypes> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExposedTypes.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExposedTypes>(null as any);
    }

    loadBapas(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/System/load-bapas";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadBapas(_response));
        });
    }

    protected processLoadBapas(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    loadCountries(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/System/load-countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadCountries(_response));
        });
    }

    protected processLoadCountries(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    loadLanguages(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/System/load-languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadLanguages(_response));
        });
    }

    protected processLoadLanguages(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    loadLookups(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/System/load-lookups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadLookups(_response));
        });
    }

    protected processLoadLookups(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    loadOperators(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/System/load-operators";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadOperators(_response));
        });
    }

    protected processLoadOperators(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    loadStatuses(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/System/load-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadStatuses(_response));
        });
    }

    protected processLoadStatuses(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    loadTrainings(x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/System/load-trainings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadTrainings(_response));
        });
    }

    protected processLoadTrainings(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    frontendSettings(x_Version?: string | null | undefined): Promise<FrontendSettings> {
        let url_ = this.baseUrl + "/api/System/frontend-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFrontendSettings(_response));
        });
    }

    protected processFrontendSettings(response: Response): Promise<FrontendSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FrontendSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrontendSettings>(null as any);
    }
}

export interface IThematicTypeApi {

    getThematicType(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditThematicTypeDto>;

    deleteThematicType(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    saveThematicType(saveDto: EditThematicTypeDto, x_Version?: string | null | undefined): Promise<number>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    baseSearch(searchQuery: SearchQueryOfThematicTypeSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfThematicTypeGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class ThematicTypeApi extends BaseAPI implements IThematicTypeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getThematicType(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditThematicTypeDto> {
        let url_ = this.baseUrl + "/api/ThematicType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetThematicType(_response));
        });
    }

    protected processGetThematicType(response: Response): Promise<EditThematicTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditThematicTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditThematicTypeDto>(null as any);
    }

    deleteThematicType(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ThematicType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteThematicType(_response));
        });
    }

    protected processDeleteThematicType(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveThematicType(saveDto: EditThematicTypeDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ThematicType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveThematicType(_response));
        });
    }

    protected processSaveThematicType(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/ThematicType/display-name?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfThematicTypeSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfThematicTypeGridDto> {
        let url_ = this.baseUrl + "/api/ThematicType/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfThematicTypeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfThematicTypeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfThematicTypeGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ThematicType/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/ThematicType/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ITrainingApi {

    getTraining(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditTrainingDto>;

    saveTraining(dto: EditTrainingDto, x_Version?: string | null | undefined): Promise<number>;

    deleteTraining(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    getTrainingSessionInfo(id?: number | undefined, x_Version?: string | null | undefined): Promise<TrainingTypeInfoDto>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    getSessionAwaitingPresences(x_Version?: string | null | undefined): Promise<IntDto>;

    baseSearch(searchQuery: SearchQueryOfTrainingSearch, x_Version?: string | null | undefined): Promise<PaginatedResultsOfTrainingGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class TrainingApi extends BaseAPI implements ITrainingApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getTraining(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditTrainingDto> {
        let url_ = this.baseUrl + "/api/Training?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTraining(_response));
        });
    }

    protected processGetTraining(response: Response): Promise<EditTrainingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditTrainingDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditTrainingDto>(null as any);
    }

    saveTraining(dto: EditTrainingDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Training";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveTraining(_response));
        });
    }

    protected processSaveTraining(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteTraining(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Training?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteTraining(_response));
        });
    }

    protected processDeleteTraining(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTrainingSessionInfo(id?: number | undefined, x_Version?: string | null | undefined): Promise<TrainingTypeInfoDto> {
        let url_ = this.baseUrl + "/api/Training/getTrainingSessionInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTrainingSessionInfo(_response));
        });
    }

    protected processGetTrainingSessionInfo(response: Response): Promise<TrainingTypeInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingTypeInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingTypeInfoDto>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/Training/display-name?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    getSessionAwaitingPresences(x_Version?: string | null | undefined): Promise<IntDto> {
        let url_ = this.baseUrl + "/api/Training/getSessionsAwaitingPresence";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSessionAwaitingPresences(_response));
        });
    }

    protected processGetSessionAwaitingPresences(response: Response): Promise<IntDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntDto>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfTrainingSearch, x_Version?: string | null | undefined): Promise<PaginatedResultsOfTrainingGridDto> {
        let url_ = this.baseUrl + "/api/Training/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTrainingGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTrainingGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTrainingGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Training/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Training/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ITrainingPlanificationApi {

    getPossibleSessionTimes(info: TrainingPlanificationInformationsDto, x_Version?: string | null | undefined): Promise<EditSessionDto[]>;

    getPossibleSessionTimesVisio(info: TrainingPlanificationInformationsDto, x_Version?: string | null | undefined): Promise<EditSessionDto[]>;

    getTrainingPlanificationInformations(trainingId?: number | undefined, x_Version?: string | null | undefined): Promise<TrainingPlanificationInformationsDto>;
}

export class TrainingPlanificationApi extends BaseAPI implements ITrainingPlanificationApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getPossibleSessionTimes(info: TrainingPlanificationInformationsDto, x_Version?: string | null | undefined): Promise<EditSessionDto[]> {
        let url_ = this.baseUrl + "/api/TrainingPlanification/getPossibleSessionTimes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(info);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPossibleSessionTimes(_response));
        });
    }

    protected processGetPossibleSessionTimes(response: Response): Promise<EditSessionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EditSessionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditSessionDto[]>(null as any);
    }

    getPossibleSessionTimesVisio(info: TrainingPlanificationInformationsDto, x_Version?: string | null | undefined): Promise<EditSessionDto[]> {
        let url_ = this.baseUrl + "/api/TrainingPlanification/getPossibleSessionTimesVisio";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(info);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPossibleSessionTimesVisio(_response));
        });
    }

    protected processGetPossibleSessionTimesVisio(response: Response): Promise<EditSessionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EditSessionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditSessionDto[]>(null as any);
    }

    getTrainingPlanificationInformations(trainingId?: number | undefined, x_Version?: string | null | undefined): Promise<TrainingPlanificationInformationsDto> {
        let url_ = this.baseUrl + "/api/TrainingPlanification/getTrainingPlanificationInformations?";
        if (trainingId === null)
            throw new Error("The parameter 'trainingId' cannot be null.");
        else if (trainingId !== undefined)
            url_ += "trainingId=" + encodeURIComponent("" + trainingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTrainingPlanificationInformations(_response));
        });
    }

    protected processGetTrainingPlanificationInformations(response: Response): Promise<TrainingPlanificationInformationsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingPlanificationInformationsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingPlanificationInformationsDto>(null as any);
    }
}

export interface ITrainingTypeApi {

    getTrainingType(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditTrainingTypeDto>;

    deleteTrainingType(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse>;

    saveTrainingType(saveDto: EditTrainingTypeDto, x_Version?: string | null | undefined): Promise<number>;

    getSessionInfos(id?: number | undefined, x_Version?: string | null | undefined): Promise<TrainingTypeInfoDto>;

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto>;

    baseSearch(searchQuery: SearchQueryOfTrainingTypeSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfTrainingTypeGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class TrainingTypeApi extends BaseAPI implements ITrainingTypeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getTrainingType(id?: number | undefined, x_Version?: string | null | undefined): Promise<EditTrainingTypeDto> {
        let url_ = this.baseUrl + "/api/TrainingType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTrainingType(_response));
        });
    }

    protected processGetTrainingType(response: Response): Promise<EditTrainingTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditTrainingTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditTrainingTypeDto>(null as any);
    }

    deleteTrainingType(id?: number | undefined, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TrainingType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteTrainingType(_response));
        });
    }

    protected processDeleteTrainingType(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveTrainingType(saveDto: EditTrainingTypeDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/TrainingType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveTrainingType(_response));
        });
    }

    protected processSaveTrainingType(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getSessionInfos(id?: number | undefined, x_Version?: string | null | undefined): Promise<TrainingTypeInfoDto> {
        let url_ = this.baseUrl + "/api/TrainingType/sessionInfos?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSessionInfos(_response));
        });
    }

    protected processGetSessionInfos(response: Response): Promise<TrainingTypeInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingTypeInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingTypeInfoDto>(null as any);
    }

    getDisplayName(id?: number | undefined, x_Version?: string | null | undefined): Promise<DisplayNameDto> {
        let url_ = this.baseUrl + "/api/TrainingType/display-name?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<DisplayNameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisplayNameDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisplayNameDto>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfTrainingTypeSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfTrainingTypeGridDto> {
        let url_ = this.baseUrl + "/api/TrainingType/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTrainingTypeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTrainingTypeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTrainingTypeGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/TrainingType/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/TrainingType/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ITranslationCodeApi {

    baseSearch(searchQuery: SearchQueryOfTranslationCodeSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfTranslationCodeDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class TranslationCodeApi extends BaseAPI implements ITranslationCodeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(searchQuery: SearchQueryOfTranslationCodeSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfTranslationCodeDto> {
        let url_ = this.baseUrl + "/api/TranslationCode/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTranslationCodeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTranslationCodeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTranslationCodeDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/TranslationCode/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/TranslationCode/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface ITranslationApi {

    getTranslationsGET(languageCode?: string | null | undefined, x_Version?: string | null | undefined): Promise<TranslationDto[]>;

    getTranslationsPOST(searchQuery: SearchQueryOfTranslationSearchCriteria, x_Version?: string | null | undefined): Promise<TranslationDto[]>;

    saveTranslation(languageCode: string, dto: SaveTranslationDto, x_Version?: string | null | undefined): Promise<void>;

    updateTranslation(updateTranslationCommand: UpdateTranslationCommand, x_Version?: string | null | undefined): Promise<FileResponse>;

    export(x_Version?: string | null | undefined): Promise<FileResponse>;

    deleteTranslationCode(translationCode?: string | null | undefined, x_Version?: string | null | undefined): Promise<boolean>;

    upload(x_Version?: string | null | undefined, file?: FileParameter | null | undefined): Promise<Result>;

    baseSearch(searchQuery: SearchQueryOfTranslationSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfTranslationDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class TranslationApi extends BaseAPI implements ITranslationApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getTranslationsGET(languageCode?: string | null | undefined, x_Version?: string | null | undefined): Promise<TranslationDto[]> {
        let url_ = this.baseUrl + "/api/Translation?";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTranslationsGET(_response));
        });
    }

    protected processGetTranslationsGET(response: Response): Promise<TranslationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TranslationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TranslationDto[]>(null as any);
    }

    getTranslationsPOST(searchQuery: SearchQueryOfTranslationSearchCriteria, x_Version?: string | null | undefined): Promise<TranslationDto[]> {
        let url_ = this.baseUrl + "/api/Translation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTranslationsPOST(_response));
        });
    }

    protected processGetTranslationsPOST(response: Response): Promise<TranslationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TranslationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TranslationDto[]>(null as any);
    }

    saveTranslation(languageCode: string, dto: SaveTranslationDto, x_Version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Translation/{languageCode}";
        if (languageCode === undefined || languageCode === null)
            throw new Error("The parameter 'languageCode' must be defined.");
        url_ = url_.replace("{languageCode}", encodeURIComponent("" + languageCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveTranslation(_response));
        });
    }

    protected processSaveTranslation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateTranslation(updateTranslationCommand: UpdateTranslationCommand, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Translation/UpdateTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateTranslationCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTranslation(_response));
        });
    }

    protected processUpdateTranslation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    export(x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Translation/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteTranslationCode(translationCode?: string | null | undefined, x_Version?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Translation/DeleteCode?";
        if (translationCode !== undefined && translationCode !== null)
            url_ += "translationCode=" + encodeURIComponent("" + translationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteTranslationCode(_response));
        });
    }

    protected processDeleteTranslationCode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    upload(x_Version?: string | null | undefined, file?: FileParameter | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Translation/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpload(_response));
        });
    }

    protected processUpload(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfTranslationSearchCriteria, x_Version?: string | null | undefined): Promise<PaginatedResultsOfTranslationDto> {
        let url_ = this.baseUrl + "/api/Translation/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTranslationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTranslationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTranslationDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Translation/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Translation/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IUserApi {

    getUser(id: number, x_Version?: string | null | undefined): Promise<EditUserDto>;

    deleteUser(id: number, x_Version?: string | null | undefined): Promise<FileResponse>;

    saveUser(dto: EditUserDto, x_Version?: string | null | undefined): Promise<number>;

    getDisplayName(id: number, x_Version?: string | null | undefined): Promise<string>;

    profile(x_Version?: string | null | undefined): Promise<UserProfileDto>;

    baseSearch(searchQuery: SearchQueryOfUserSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfUserGridDto>;

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]>;
}

export class UserApi extends BaseAPI implements IUserApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getUser(id: number, x_Version?: string | null | undefined): Promise<EditUserDto> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUser(_response));
        });
    }

    protected processGetUser(response: Response): Promise<EditUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditUserDto>(null as any);
    }

    deleteUser(id: number, x_Version?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteUser(_response));
        });
    }

    protected processDeleteUser(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveUser(dto: EditUserDto, x_Version?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveUser(_response));
        });
    }

    protected processSaveUser(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id: number, x_Version?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/User/display-name/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    profile(x_Version?: string | null | undefined): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/api/User/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProfile(_response));
        });
    }

    protected processProfile(response: Response): Promise<UserProfileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }

    baseSearch(searchQuery: SearchQueryOfUserSearchDto, x_Version?: string | null | undefined): Promise<PaginatedResultsOfUserGridDto> {
        let url_ = this.baseUrl + "/api/User/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfUserGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfUserGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfUserGridDto>(null as any);
    }

    getSearchCriterias(includeListsValues?: boolean | undefined, x_Version?: string | null | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/User/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string, x_Version?: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/User/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IHealthCheckApi {

    getHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel>;

    getStartupHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel>;

    getReadyHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel>;

    getLiveHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel>;
}

export class HealthCheckApi extends BaseAPI implements IHealthCheckApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHealthCheck(_response));
        });
    }

    protected processGetHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getStartupHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/startup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStartupHealthCheck(_response));
        });
    }

    protected processGetStartupHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getReadyHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/ready";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReadyHealthCheck(_response));
        });
    }

    protected processGetReadyHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getLiveHealthCheck(x_Version?: string | null | undefined): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/live";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLiveHealthCheck(_response));
        });
    }

    protected processGetLiveHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }
}

export interface IApiKeyApi {

    getApiKey(clientName?: string | null | undefined, x_Version?: string | null | undefined): Promise<ClientApiKey>;
}

export class ApiKeyApi extends BaseAPI implements IApiKeyApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getApiKey(clientName?: string | null | undefined, x_Version?: string | null | undefined): Promise<ClientApiKey> {
        let url_ = this.baseUrl + "/apikey?";
        if (clientName !== undefined && clientName !== null)
            url_ += "clientName=" + encodeURIComponent("" + clientName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Version": x_Version !== undefined && x_Version !== null ? "" + x_Version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetApiKey(_response));
        });
    }

    protected processGetApiKey(response: Response): Promise<ClientApiKey> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientApiKey.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientApiKey>(null as any);
    }
}

export class Result implements IResult {
    status?: ResultStatus;
    errors?: ResultError[] | undefined;
    isFailure?: boolean;
    isSuccess?: boolean;
    isNone?: boolean;
    isInvalid?: boolean;
    isNotFound?: boolean;
    rawValue?: MaybeOfObject;

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ResultError.fromJS(item));
            }
            this.isFailure = _data["isFailure"];
            this.isSuccess = _data["isSuccess"];
            this.isNone = _data["isNone"];
            this.isInvalid = _data["isInvalid"];
            this.isNotFound = _data["isNotFound"];
            this.rawValue = _data["rawValue"] ? MaybeOfObject.fromJS(_data["rawValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isFailure"] = this.isFailure;
        data["isSuccess"] = this.isSuccess;
        data["isNone"] = this.isNone;
        data["isInvalid"] = this.isInvalid;
        data["isNotFound"] = this.isNotFound;
        data["rawValue"] = this.rawValue ? this.rawValue.toJSON() : <any>undefined;
        return data;
    }

    clone(): Result {
        const json = this.toJSON();
        let result = new Result();
        result.init(json);
        return result;
    }
}

export interface IResult {
    status?: ResultStatus;
    errors?: ResultError[] | undefined;
    isFailure?: boolean;
    isSuccess?: boolean;
    isNone?: boolean;
    isInvalid?: boolean;
    isNotFound?: boolean;
    rawValue?: MaybeOfObject;
}

export enum ResultStatus {
    Success = "Success",
    Invalid = "Invalid",
    NotFound = "NotFound",
    None = "None",
}

export abstract class ValueObject implements IValueObject {

    constructor(data?: IValueObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ValueObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ValueObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ValueObject {
        throw new Error("The abstract class 'ValueObject' cannot be instantiated.");
    }
}

export interface IValueObject {
}

export class ResultError extends ValueObject implements IResultError {
    propertyName?: string | undefined;
    hasPropertyName?: boolean;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    errorLevel?: ResultErrorLevel;
    invalidValue?: any | undefined;

    constructor(data?: IResultError) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.hasPropertyName = _data["hasPropertyName"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.errorLevel = _data["errorLevel"];
            this.invalidValue = _data["invalidValue"];
        }
    }

    static override fromJS(data: any): ResultError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultError();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["hasPropertyName"] = this.hasPropertyName;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["errorLevel"] = this.errorLevel;
        data["invalidValue"] = this.invalidValue;
        super.toJSON(data);
        return data;
    }

    clone(): ResultError {
        const json = this.toJSON();
        let result = new ResultError();
        result.init(json);
        return result;
    }
}

export interface IResultError extends IValueObject {
    propertyName?: string | undefined;
    hasPropertyName?: boolean;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    errorLevel?: ResultErrorLevel;
    invalidValue?: any | undefined;
}

export enum ResultErrorLevel {
    None = "None",
    Info = "Info",
    Warning = "Warning",
    NotFound = "NotFound",
    Error = "Error",
}

export class MaybeOfObject implements IMaybeOfObject {
    value?: any | undefined;
    hasValue?: boolean;
    hasNoValue?: boolean;

    constructor(data?: IMaybeOfObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.hasValue = _data["hasValue"];
            this.hasNoValue = _data["hasNoValue"];
        }
    }

    static fromJS(data: any): MaybeOfObject {
        data = typeof data === 'object' ? data : {};
        let result = new MaybeOfObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["hasValue"] = this.hasValue;
        data["hasNoValue"] = this.hasNoValue;
        return data;
    }

    clone(): MaybeOfObject {
        const json = this.toJSON();
        let result = new MaybeOfObject();
        result.init(json);
        return result;
    }
}

export interface IMaybeOfObject {
    value?: any | undefined;
    hasValue?: boolean;
    hasNoValue?: boolean;
}

export class UpdateActionRoleDto implements IUpdateActionRoleDto {
    roleId?: number;
    actionId?: number;
    isActive?: boolean;

    constructor(data?: IUpdateActionRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.actionId = _data["actionId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateActionRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActionRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["actionId"] = this.actionId;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): UpdateActionRoleDto {
        const json = this.toJSON();
        let result = new UpdateActionRoleDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateActionRoleDto {
    roleId?: number;
    actionId?: number;
    isActive?: boolean;
}

export class PaginatedResultsOfActionGridDto implements IPaginatedResultsOfActionGridDto {
    totalCount?: number;
    results?: ActionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ActionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfActionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfActionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfActionGridDto {
    totalCount?: number;
    results?: ActionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class ActionGridDto implements IActionGridDto {
    id?: number;
    code?: ActionCode;
    actionRoles?: ActionRoleDto[] | undefined;

    constructor(data?: IActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            if (Array.isArray(_data["actionRoles"])) {
                this.actionRoles = [] as any;
                for (let item of _data["actionRoles"])
                    this.actionRoles!.push(ActionRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        if (Array.isArray(this.actionRoles)) {
            data["actionRoles"] = [];
            for (let item of this.actionRoles)
                data["actionRoles"].push(item.toJSON());
        }
        return data;
    }

    clone(): ActionGridDto {
        const json = this.toJSON();
        let result = new ActionGridDto();
        result.init(json);
        return result;
    }
}

export interface IActionGridDto {
    id?: number;
    code?: ActionCode;
    actionRoles?: ActionRoleDto[] | undefined;
}

export enum ActionCode {
    ViewTrainingTypes = "ViewTrainingTypes",
    DeleteTrainingType = "DeleteTrainingType",
    ImportProtimeAbsences = "ImportProtimeAbsences",
    SyncApa = "SyncApa",
    EditTranslation = "EditTranslation",
    ViewEmployees = "ViewEmployees",
    ViewEmployeePlanning = "ViewEmployeePlanning",
    ViewEmployeeAssessments = "ViewEmployeeAssessments",
    EditEmployeeAssessment = "EditEmployeeAssessment",
    EditEmployee = "EditEmployee",
    DeleteEmployee = "DeleteEmployee",
    EditTrainingType = "EditTrainingType",
    SendEmailsJob = "SendEmailsJob",
    ViewMailTemplates = "ViewMailTemplates",
    EditMailTemplate = "EditMailTemplate",
    ViewNewComers = "ViewNewComers",
    EditNewComer = "EditNewComer",
    ViewOperatorsRef = "ViewOperatorsRef",
    ViewRooms = "ViewRooms",
    EditRoom = "EditRoom",
    DeleteRoom = "DeleteRoom",
    ViewSessions = "ViewSessions",
    EditSession = "EditSession",
    DeleteSession = "DeleteSession",
    ViewSites = "ViewSites",
    EditSite = "EditSite",
    DeleteSite = "DeleteSite",
    ViewSmsTemplates = "ViewSmsTemplates",
    EditSmsTemplates = "EditSmsTemplates",
    ViewTrainings = "ViewTrainings",
    EditTraining = "EditTraining",
    DeleteTraining = "DeleteTraining",
    DeleteTranslation = "DeleteTranslation",
    ViewUsers = "ViewUsers",
    DeleteUser = "DeleteUser",
    EditUser = "EditUser",
    ViewRoles = "ViewRoles",
    EditRole = "EditRole",
    ViewAttendance = "ViewAttendance",
    ViewAttendee = "ViewAttendee",
    ViewRoomPlanning = "ViewRoomPlanning",
    ViewMeeting = "ViewMeeting",
    EditMeeting = "EditMeeting",
    DeleteMeeting = "DeleteMeeting",
    ViewRoomBooking = "ViewRoomBooking",
    DeleteRoomBooking = "DeleteRoomBooking",
    CreateRoomBooking = "CreateRoomBooking",
    ViewPartnerTypes = "ViewPartnerTypes",
    EditPartnerType = "EditPartnerType",
    DeletePartnerType = "DeletePartnerType",
    ViewPartners = "ViewPartners",
    EditPartner = "EditPartner",
    DeletePartner = "DeletePartner",
    ViewReminderPhoneCalls = "ViewReminderPhoneCalls",
    EditReminderPhoneCall = "EditReminderPhoneCall",
    ViewMeetingDashboard = "ViewMeetingDashboard",
    ViewDuties = "ViewDuties",
    EditDuty = "EditDuty",
    DeleteDuty = "DeleteDuty",
    ViewMeetingType = "ViewMeetingType",
    EditMeetingType = "EditMeetingType",
    DeleteMeetingType = "DeleteMeetingType",
    ViewFunction = "ViewFunction",
    DeleteFunction = "DeleteFunction",
    EditFunction = "EditFunction",
    ViewApaTraining = "ViewApaTraining",
    ViewAssignment = "ViewAssignment",
    DeleteAssignment = "DeleteAssignment",
    EditAssignment = "EditAssignment",
    ViewHourlyType = "ViewHourlyType",
    EditHourlyType = "EditHourlyType",
    ViewThematics = "ViewThematics",
    ViewThematicTypes = "ViewThematicTypes",
    EditThematicType = "EditThematicType",
    DeleteThematicType = "DeleteThematicType",
    ManageJobs = "ManageJobs",
    EditRoles = "EditRoles",
    EditDataTranslations = "EditDataTranslations",
    EditTranslations = "EditTranslations",
    ViewAllTasks = "ViewAllTasks",
}

export class ActionRoleDto implements IActionRoleDto {
    id?: number;
    roleName?: string | undefined;
    actionId?: number;
    roleId?: number;
    code?: UserRoles;

    constructor(data?: IActionRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleName = _data["roleName"];
            this.actionId = _data["actionId"];
            this.roleId = _data["roleId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ActionRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleName"] = this.roleName;
        data["actionId"] = this.actionId;
        data["roleId"] = this.roleId;
        data["code"] = this.code;
        return data;
    }

    clone(): ActionRoleDto {
        const json = this.toJSON();
        let result = new ActionRoleDto();
        result.init(json);
        return result;
    }
}

export interface IActionRoleDto {
    id?: number;
    roleName?: string | undefined;
    actionId?: number;
    roleId?: number;
    code?: UserRoles;
}

export enum UserRoles {
    SuperAdmin = "SuperAdmin",
    User = "User",
    Viewer = "Viewer",
    NewComer = "NewComer",
}

export class AggregateResult implements IAggregateResult {
    valueDouble?: number | undefined;
    valueDec?: number | undefined;
    valueFloat?: number | undefined;
    key?: string | undefined;
    text?: string | undefined;
    value?: number | undefined;

    constructor(data?: IAggregateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valueDouble = _data["valueDouble"];
            this.valueDec = _data["valueDec"];
            this.valueFloat = _data["valueFloat"];
            this.key = _data["key"];
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AggregateResult {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueDouble"] = this.valueDouble;
        data["valueDec"] = this.valueDec;
        data["valueFloat"] = this.valueFloat;
        data["key"] = this.key;
        data["text"] = this.text;
        data["value"] = this.value;
        return data;
    }

    clone(): AggregateResult {
        const json = this.toJSON();
        let result = new AggregateResult();
        result.init(json);
        return result;
    }
}

export interface IAggregateResult {
    valueDouble?: number | undefined;
    valueDec?: number | undefined;
    valueFloat?: number | undefined;
    key?: string | undefined;
    text?: string | undefined;
    value?: number | undefined;
}

export class SearchQueryOfActionRoleSearchDto implements ISearchQueryOfActionRoleSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: ActionRoleSearchDto | undefined;

    constructor(data?: ISearchQueryOfActionRoleSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? ActionRoleSearchDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfActionRoleSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfActionRoleSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfActionRoleSearchDto {
        const json = this.toJSON();
        let result = new SearchQueryOfActionRoleSearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfActionRoleSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: ActionRoleSearchDto | undefined;
}

export abstract class AbstractSearchExpression implements IAbstractSearchExpression {
    expressionOperator?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IAbstractSearchExpression) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "AbstractSearchExpression";
    }

    init(_data?: any) {
        if (_data) {
            this.expressionOperator = _data["expressionOperator"];
        }
    }

    static fromJS(data: any): AbstractSearchExpression {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "condition") {
            let result = new ConditionSearchExpression();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "group") {
            let result = new GroupSearchExpression();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'AbstractSearchExpression' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["expressionOperator"] = this.expressionOperator;
        return data;
    }

    clone(): AbstractSearchExpression {
        throw new Error("The abstract class 'AbstractSearchExpression' cannot be instantiated.");
    }
}

export interface IAbstractSearchExpression {
    expressionOperator?: string | undefined;
}

export class ConditionSearchExpression extends AbstractSearchExpression implements IConditionSearchExpression {
    field?: string | undefined;
    value?: string | undefined;

    constructor(data?: IConditionSearchExpression) {
        super(data);
        this._discriminator = "condition";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.field = _data["field"];
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): ConditionSearchExpression {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionSearchExpression();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): ConditionSearchExpression {
        const json = this.toJSON();
        let result = new ConditionSearchExpression();
        result.init(json);
        return result;
    }
}

export interface IConditionSearchExpression extends IAbstractSearchExpression {
    field?: string | undefined;
    value?: string | undefined;
}

export class GroupSearchExpression extends AbstractSearchExpression implements IGroupSearchExpression {
    expressions?: AbstractSearchExpression[] | undefined;

    constructor(data?: IGroupSearchExpression) {
        super(data);
        this._discriminator = "group";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["expressions"])) {
                this.expressions = [] as any;
                for (let item of _data["expressions"])
                    this.expressions!.push(AbstractSearchExpression.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GroupSearchExpression {
        data = typeof data === 'object' ? data : {};
        let result = new GroupSearchExpression();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expressions)) {
            data["expressions"] = [];
            for (let item of this.expressions)
                data["expressions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): GroupSearchExpression {
        const json = this.toJSON();
        let result = new GroupSearchExpression();
        result.init(json);
        return result;
    }
}

export interface IGroupSearchExpression extends IAbstractSearchExpression {
    expressions?: AbstractSearchExpression[] | undefined;
}

export class Searchable implements ISearchable {
    filter?: string | undefined;

    constructor(data?: ISearchable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): Searchable {
        data = typeof data === 'object' ? data : {};
        let result = new Searchable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }

    clone(): Searchable {
        const json = this.toJSON();
        let result = new Searchable();
        result.init(json);
        return result;
    }
}

export interface ISearchable {
    filter?: string | undefined;
}

export class PaginatedSearchable extends Searchable implements IPaginatedSearchable {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    skip?: number | undefined;
    take?: number | undefined;

    constructor(data?: IPaginatedSearchable) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sortKey"])) {
                this.sortKey = [] as any;
                for (let item of _data["sortKey"])
                    this.sortKey!.push(item);
            }
            if (Array.isArray(_data["aggregateKeys"])) {
                this.aggregateKeys = [] as any;
                for (let item of _data["aggregateKeys"])
                    this.aggregateKeys!.push(AggregateKeyInfo.fromJS(item));
            }
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static override fromJS(data: any): PaginatedSearchable {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedSearchable();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sortKey)) {
            data["sortKey"] = [];
            for (let item of this.sortKey)
                data["sortKey"].push(item);
        }
        if (Array.isArray(this.aggregateKeys)) {
            data["aggregateKeys"] = [];
            for (let item of this.aggregateKeys)
                data["aggregateKeys"].push(item.toJSON());
        }
        data["skip"] = this.skip;
        data["take"] = this.take;
        super.toJSON(data);
        return data;
    }

    clone(): PaginatedSearchable {
        const json = this.toJSON();
        let result = new PaginatedSearchable();
        result.init(json);
        return result;
    }
}

export interface IPaginatedSearchable extends ISearchable {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    skip?: number | undefined;
    take?: number | undefined;
}

export class ActionRoleSearchDto extends PaginatedSearchable implements IActionRoleSearchDto {

    constructor(data?: IActionRoleSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ActionRoleSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRoleSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ActionRoleSearchDto {
        const json = this.toJSON();
        let result = new ActionRoleSearchDto();
        result.init(json);
        return result;
    }
}

export interface IActionRoleSearchDto extends IPaginatedSearchable {
}

export class AggregateKeyInfo implements IAggregateKeyInfo {
    key?: string | undefined;
    aggregateType?: EAggregateType;
    text?: string | undefined;

    constructor(data?: IAggregateKeyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.aggregateType = _data["aggregateType"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AggregateKeyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateKeyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["aggregateType"] = this.aggregateType;
        data["text"] = this.text;
        return data;
    }

    clone(): AggregateKeyInfo {
        const json = this.toJSON();
        let result = new AggregateKeyInfo();
        result.init(json);
        return result;
    }
}

export interface IAggregateKeyInfo {
    key?: string | undefined;
    aggregateType?: EAggregateType;
    text?: string | undefined;
}

export enum EAggregateType {
    Sum = "Sum",
    Avg = "Avg",
    Min = "Min",
    Max = "Max",
}

export class FilterCriteriaInfo implements IFilterCriteriaInfo {
    criteria?: string | undefined;
    type?: ECriteriaType;
    searchModes?: string[] | undefined;
    defaultSearchMode?: string | undefined;
    listValues?: SelectItem[] | undefined;
    isMultipleOr?: boolean;

    constructor(data?: IFilterCriteriaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.criteria = _data["criteria"];
            this.type = _data["type"];
            if (Array.isArray(_data["searchModes"])) {
                this.searchModes = [] as any;
                for (let item of _data["searchModes"])
                    this.searchModes!.push(item);
            }
            this.defaultSearchMode = _data["defaultSearchMode"];
            if (Array.isArray(_data["listValues"])) {
                this.listValues = [] as any;
                for (let item of _data["listValues"])
                    this.listValues!.push(SelectItem.fromJS(item));
            }
            this.isMultipleOr = _data["isMultipleOr"];
        }
    }

    static fromJS(data: any): FilterCriteriaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FilterCriteriaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria;
        data["type"] = this.type;
        if (Array.isArray(this.searchModes)) {
            data["searchModes"] = [];
            for (let item of this.searchModes)
                data["searchModes"].push(item);
        }
        data["defaultSearchMode"] = this.defaultSearchMode;
        if (Array.isArray(this.listValues)) {
            data["listValues"] = [];
            for (let item of this.listValues)
                data["listValues"].push(item.toJSON());
        }
        data["isMultipleOr"] = this.isMultipleOr;
        return data;
    }

    clone(): FilterCriteriaInfo {
        const json = this.toJSON();
        let result = new FilterCriteriaInfo();
        result.init(json);
        return result;
    }
}

export interface IFilterCriteriaInfo {
    criteria?: string | undefined;
    type?: ECriteriaType;
    searchModes?: string[] | undefined;
    defaultSearchMode?: string | undefined;
    listValues?: SelectItem[] | undefined;
    isMultipleOr?: boolean;
}

export enum ECriteriaType {
    Text = "Text",
    List = "List",
    Date = "Date",
    Boolean = "Boolean",
    Numeric = "Numeric",
    Float = "Float",
}

export class SelectItem extends ValueObject implements ISelectItem {
    idValue?: string | undefined;
    displayValue?: string | undefined;

    constructor(data?: ISelectItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idValue = _data["idValue"];
            this.displayValue = _data["displayValue"];
        }
    }

    static override fromJS(data: any): SelectItem {
        data = typeof data === 'object' ? data : {};
        let result = new SelectItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idValue"] = this.idValue;
        data["displayValue"] = this.displayValue;
        super.toJSON(data);
        return data;
    }

    clone(): SelectItem {
        const json = this.toJSON();
        let result = new SelectItem();
        result.init(json);
        return result;
    }
}

export interface ISelectItem extends IValueObject {
    idValue?: string | undefined;
    displayValue?: string | undefined;
}

export class ReferentialItemDto extends SelectItem implements IReferentialItemDto {
    keyValue?: string | undefined;

    constructor(data?: IReferentialItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keyValue = _data["keyValue"];
        }
    }

    static override fromJS(data: any): ReferentialItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferentialItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyValue"] = this.keyValue;
        super.toJSON(data);
        return data;
    }

    clone(): ReferentialItemDto {
        const json = this.toJSON();
        let result = new ReferentialItemDto();
        result.init(json);
        return result;
    }
}

export interface IReferentialItemDto extends ISelectItem {
    keyValue?: string | undefined;
}

export class LastUpdateViewerDto implements ILastUpdateViewerDto {
    lastUpdate?: Date;
    lastUpdateBy?: string | undefined;

    constructor(data?: ILastUpdateViewerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastUpdate = _data["lastUpdate"] ? new Date(_data["lastUpdate"].toString()) : <any>undefined;
            this.lastUpdateBy = _data["lastUpdateBy"];
        }
    }

    static fromJS(data: any): LastUpdateViewerDto {
        data = typeof data === 'object' ? data : {};
        let result = new LastUpdateViewerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        data["lastUpdateBy"] = this.lastUpdateBy;
        return data;
    }

    clone(): LastUpdateViewerDto {
        const json = this.toJSON();
        let result = new LastUpdateViewerDto();
        result.init(json);
        return result;
    }
}

export interface ILastUpdateViewerDto {
    lastUpdate?: Date;
    lastUpdateBy?: string | undefined;
}

export class EditAssignmentDto extends LastUpdateViewerDto implements IEditAssignmentDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;

    constructor(data?: IEditAssignmentDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): EditAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditAssignmentDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): EditAssignmentDto {
        const json = this.toJSON();
        let result = new EditAssignmentDto();
        result.init(json);
        return result;
    }
}

export interface IEditAssignmentDto extends ILastUpdateViewerDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
}

export class EntityDto implements IEntityDto {
    id?: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): EntityDto {
        const json = this.toJSON();
        let result = new EntityDto();
        result.init(json);
        return result;
    }
}

export interface IEntityDto {
    id?: number;
}

export class DataTranslationDto extends EntityDto implements IDataTranslationDto {
    dataTranslationValues?: DataTranslationValueDto[] | undefined;

    constructor(data?: IDataTranslationDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["dataTranslationValues"])) {
                this.dataTranslationValues = [] as any;
                for (let item of _data["dataTranslationValues"])
                    this.dataTranslationValues!.push(DataTranslationValueDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DataTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataTranslationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataTranslationValues)) {
            data["dataTranslationValues"] = [];
            for (let item of this.dataTranslationValues)
                data["dataTranslationValues"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): DataTranslationDto {
        const json = this.toJSON();
        let result = new DataTranslationDto();
        result.init(json);
        return result;
    }
}

export interface IDataTranslationDto extends IEntityDto {
    dataTranslationValues?: DataTranslationValueDto[] | undefined;
}

export class DataTranslationValueDto extends EntityDto implements IDataTranslationValueDto {
    text?: string | undefined;
    languageId?: number;
    languageCode?: string | undefined;

    constructor(data?: IDataTranslationValueDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"];
            this.languageId = _data["languageId"];
            this.languageCode = _data["languageCode"];
        }
    }

    static override fromJS(data: any): DataTranslationValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataTranslationValueDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["languageId"] = this.languageId;
        data["languageCode"] = this.languageCode;
        super.toJSON(data);
        return data;
    }

    clone(): DataTranslationValueDto {
        const json = this.toJSON();
        let result = new DataTranslationValueDto();
        result.init(json);
        return result;
    }
}

export interface IDataTranslationValueDto extends IEntityDto {
    text?: string | undefined;
    languageId?: number;
    languageCode?: string | undefined;
}

export class DisplayNameDto implements IDisplayNameDto {
    text?: string | undefined;

    constructor(data?: IDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): DisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        return data;
    }

    clone(): DisplayNameDto {
        const json = this.toJSON();
        let result = new DisplayNameDto();
        result.init(json);
        return result;
    }
}

export interface IDisplayNameDto {
    text?: string | undefined;
}

export class PaginatedResultsOfAssignmentGridDto implements IPaginatedResultsOfAssignmentGridDto {
    totalCount?: number;
    results?: AssignmentGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfAssignmentGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AssignmentGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfAssignmentGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfAssignmentGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfAssignmentGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfAssignmentGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfAssignmentGridDto {
    totalCount?: number;
    results?: AssignmentGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class AssignmentGridDto implements IAssignmentGridDto {
    id?: number | undefined;
    code?: string | undefined;
    label?: string | undefined;

    constructor(data?: IAssignmentGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): AssignmentGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["label"] = this.label;
        return data;
    }

    clone(): AssignmentGridDto {
        const json = this.toJSON();
        let result = new AssignmentGridDto();
        result.init(json);
        return result;
    }
}

export interface IAssignmentGridDto {
    id?: number | undefined;
    code?: string | undefined;
    label?: string | undefined;
}

export class SearchQueryOfAssignmentSearchDto implements ISearchQueryOfAssignmentSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: AssignmentSearchDto | undefined;

    constructor(data?: ISearchQueryOfAssignmentSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? AssignmentSearchDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfAssignmentSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfAssignmentSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfAssignmentSearchDto {
        const json = this.toJSON();
        let result = new SearchQueryOfAssignmentSearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfAssignmentSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: AssignmentSearchDto | undefined;
}

export class AssignmentSearchDto extends PaginatedSearchable implements IAssignmentSearchDto {

    constructor(data?: IAssignmentSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AssignmentSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): AssignmentSearchDto {
        const json = this.toJSON();
        let result = new AssignmentSearchDto();
        result.init(json);
        return result;
    }
}

export interface IAssignmentSearchDto extends IPaginatedSearchable {
}

export class PaginatedResultsOfSessionsAwaitingAttendanceGridDto implements IPaginatedResultsOfSessionsAwaitingAttendanceGridDto {
    totalCount?: number;
    results?: SessionsAwaitingAttendanceGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfSessionsAwaitingAttendanceGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SessionsAwaitingAttendanceGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfSessionsAwaitingAttendanceGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfSessionsAwaitingAttendanceGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfSessionsAwaitingAttendanceGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfSessionsAwaitingAttendanceGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfSessionsAwaitingAttendanceGridDto {
    totalCount?: number;
    results?: SessionsAwaitingAttendanceGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class SessionsAwaitingAttendanceGridDto implements ISessionsAwaitingAttendanceGridDto {
    trainingId?: number;
    sessionId?: number;
    numberOfAttendants?: number;
    occursOn?: Date;
    apaLanguageId?: number;
    apaLanguage?: string | undefined;
    siteId?: number;
    site?: string | undefined;
    trainingType?: string | undefined;

    constructor(data?: ISessionsAwaitingAttendanceGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingId = _data["trainingId"];
            this.sessionId = _data["sessionId"];
            this.numberOfAttendants = _data["numberOfAttendants"];
            this.occursOn = _data["occursOn"] ? new Date(_data["occursOn"].toString()) : <any>undefined;
            this.apaLanguageId = _data["apaLanguageId"];
            this.apaLanguage = _data["apaLanguage"];
            this.siteId = _data["siteId"];
            this.site = _data["site"];
            this.trainingType = _data["trainingType"];
        }
    }

    static fromJS(data: any): SessionsAwaitingAttendanceGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionsAwaitingAttendanceGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingId"] = this.trainingId;
        data["sessionId"] = this.sessionId;
        data["numberOfAttendants"] = this.numberOfAttendants;
        data["occursOn"] = this.occursOn ? this.occursOn.toISOString() : <any>undefined;
        data["apaLanguageId"] = this.apaLanguageId;
        data["apaLanguage"] = this.apaLanguage;
        data["siteId"] = this.siteId;
        data["site"] = this.site;
        data["trainingType"] = this.trainingType;
        return data;
    }

    clone(): SessionsAwaitingAttendanceGridDto {
        const json = this.toJSON();
        let result = new SessionsAwaitingAttendanceGridDto();
        result.init(json);
        return result;
    }
}

export interface ISessionsAwaitingAttendanceGridDto {
    trainingId?: number;
    sessionId?: number;
    numberOfAttendants?: number;
    occursOn?: Date;
    apaLanguageId?: number;
    apaLanguage?: string | undefined;
    siteId?: number;
    site?: string | undefined;
    trainingType?: string | undefined;
}

export class FilterSearch implements IFilterSearch {
    filter?: string | undefined;

    constructor(data?: IFilterSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FilterSearch {
        data = typeof data === 'object' ? data : {};
        let result = new FilterSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }

    clone(): FilterSearch {
        const json = this.toJSON();
        let result = new FilterSearch();
        result.init(json);
        return result;
    }
}

export interface IFilterSearch {
    filter?: string | undefined;
}

export class PaginatedSearch extends FilterSearch implements IPaginatedSearch {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    forceSkip?: number | undefined;
    forceTake?: number | undefined;
    parameters?: any | undefined;

    constructor(data?: IPaginatedSearch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sortKey"])) {
                this.sortKey = [] as any;
                for (let item of _data["sortKey"])
                    this.sortKey!.push(item);
            }
            if (Array.isArray(_data["aggregateKeys"])) {
                this.aggregateKeys = [] as any;
                for (let item of _data["aggregateKeys"])
                    this.aggregateKeys!.push(AggregateKeyInfo.fromJS(item));
            }
            this.forceSkip = _data["forceSkip"];
            this.forceTake = _data["forceTake"];
            this.parameters = _data["parameters"];
        }
    }

    static override fromJS(data: any): PaginatedSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedSearch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sortKey)) {
            data["sortKey"] = [];
            for (let item of this.sortKey)
                data["sortKey"].push(item);
        }
        if (Array.isArray(this.aggregateKeys)) {
            data["aggregateKeys"] = [];
            for (let item of this.aggregateKeys)
                data["aggregateKeys"].push(item.toJSON());
        }
        data["forceSkip"] = this.forceSkip;
        data["forceTake"] = this.forceTake;
        data["parameters"] = this.parameters;
        super.toJSON(data);
        return data;
    }

    clone(): PaginatedSearch {
        const json = this.toJSON();
        let result = new PaginatedSearch();
        result.init(json);
        return result;
    }
}

export interface IPaginatedSearch extends IFilterSearch {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    forceSkip?: number | undefined;
    forceTake?: number | undefined;
    parameters?: any | undefined;
}

export class SessionAttendeeSearch extends PaginatedSearch implements ISessionAttendeeSearch {
    forAllUsers?: boolean;

    constructor(data?: ISessionAttendeeSearch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.forAllUsers = _data["forAllUsers"];
        }
    }

    static override fromJS(data: any): SessionAttendeeSearch {
        data = typeof data === 'object' ? data : {};
        let result = new SessionAttendeeSearch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forAllUsers"] = this.forAllUsers;
        super.toJSON(data);
        return data;
    }

    clone(): SessionAttendeeSearch {
        const json = this.toJSON();
        let result = new SessionAttendeeSearch();
        result.init(json);
        return result;
    }
}

export interface ISessionAttendeeSearch extends IPaginatedSearch {
    forAllUsers?: boolean;
}

export class AttendanceForSessionDto implements IAttendanceForSessionDto {
    id?: number;
    presencesAreDefinitive?: boolean;
    isEditable?: boolean;
    attendees?: AttendeeForSessionDto[] | undefined;

    constructor(data?: IAttendanceForSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.presencesAreDefinitive = _data["presencesAreDefinitive"];
            this.isEditable = _data["isEditable"];
            if (Array.isArray(_data["attendees"])) {
                this.attendees = [] as any;
                for (let item of _data["attendees"])
                    this.attendees!.push(AttendeeForSessionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttendanceForSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceForSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["presencesAreDefinitive"] = this.presencesAreDefinitive;
        data["isEditable"] = this.isEditable;
        if (Array.isArray(this.attendees)) {
            data["attendees"] = [];
            for (let item of this.attendees)
                data["attendees"].push(item.toJSON());
        }
        return data;
    }

    clone(): AttendanceForSessionDto {
        const json = this.toJSON();
        let result = new AttendanceForSessionDto();
        result.init(json);
        return result;
    }
}

export interface IAttendanceForSessionDto {
    id?: number;
    presencesAreDefinitive?: boolean;
    isEditable?: boolean;
    attendees?: AttendeeForSessionDto[] | undefined;
}

export class AttendeeForSessionDto implements IAttendeeForSessionDto {
    id?: number;
    sessionId?: number;
    newcomerId?: number;
    fullName?: string | undefined;
    isPresent?: boolean;

    constructor(data?: IAttendeeForSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sessionId = _data["sessionId"];
            this.newcomerId = _data["newcomerId"];
            this.fullName = _data["fullName"];
            this.isPresent = _data["isPresent"];
        }
    }

    static fromJS(data: any): AttendeeForSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendeeForSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sessionId"] = this.sessionId;
        data["newcomerId"] = this.newcomerId;
        data["fullName"] = this.fullName;
        data["isPresent"] = this.isPresent;
        return data;
    }

    clone(): AttendeeForSessionDto {
        const json = this.toJSON();
        let result = new AttendeeForSessionDto();
        result.init(json);
        return result;
    }
}

export interface IAttendeeForSessionDto {
    id?: number;
    sessionId?: number;
    newcomerId?: number;
    fullName?: string | undefined;
    isPresent?: boolean;
}

export class PaginatedResultsOfContactGridDto implements IPaginatedResultsOfContactGridDto {
    totalCount?: number;
    results?: ContactGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfContactGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ContactGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfContactGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfContactGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfContactGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfContactGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfContactGridDto {
    totalCount?: number;
    results?: ContactGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class ContactGridDto implements IContactGridDto {
    id?: number;
    name?: string | undefined;
    firstName?: string | undefined;
    email?: string | undefined;
    nationalRegistrationNumber?: string | undefined;
    employeeId?: number | undefined;
    newComerId?: number | undefined;

    constructor(data?: IContactGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.email = _data["email"];
            this.nationalRegistrationNumber = _data["nationalRegistrationNumber"];
            this.employeeId = _data["employeeId"];
            this.newComerId = _data["newComerId"];
        }
    }

    static fromJS(data: any): ContactGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["email"] = this.email;
        data["nationalRegistrationNumber"] = this.nationalRegistrationNumber;
        data["employeeId"] = this.employeeId;
        data["newComerId"] = this.newComerId;
        return data;
    }

    clone(): ContactGridDto {
        const json = this.toJSON();
        let result = new ContactGridDto();
        result.init(json);
        return result;
    }
}

export interface IContactGridDto {
    id?: number;
    name?: string | undefined;
    firstName?: string | undefined;
    email?: string | undefined;
    nationalRegistrationNumber?: string | undefined;
    employeeId?: number | undefined;
    newComerId?: number | undefined;
}

export class SearchQueryOfSearchContactDto implements ISearchQueryOfSearchContactDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: SearchContactDto | undefined;

    constructor(data?: ISearchQueryOfSearchContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? SearchContactDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfSearchContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfSearchContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfSearchContactDto {
        const json = this.toJSON();
        let result = new SearchQueryOfSearchContactDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfSearchContactDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: SearchContactDto | undefined;
}

export class SearchContactDto extends PaginatedSearchable implements ISearchContactDto {
    firstName?: TextSearch | undefined;

    constructor(data?: ISearchContactDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"] ? TextSearch.fromJS(_data["firstName"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): SearchContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchContactDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName ? this.firstName.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): SearchContactDto {
        const json = this.toJSON();
        let result = new SearchContactDto();
        result.init(json);
        return result;
    }
}

export interface ISearchContactDto extends IPaginatedSearchable {
    firstName?: TextSearch | undefined;
}

export abstract class FilterCriteriaBaseOfETextSearchTypeAndString implements IFilterCriteriaBaseOfETextSearchTypeAndString {
    criterias?: CombinableCriteriaOfETextSearchTypeAndString[] | undefined;
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;

    constructor(data?: IFilterCriteriaBaseOfETextSearchTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfETextSearchTypeAndString.fromJS(item));
            }
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfETextSearchTypeAndString {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfETextSearchTypeAndString' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        return data;
    }

    clone(): FilterCriteriaBaseOfETextSearchTypeAndString {
        throw new Error("The abstract class 'FilterCriteriaBaseOfETextSearchTypeAndString' cannot be instantiated.");
    }
}

export interface IFilterCriteriaBaseOfETextSearchTypeAndString {
    criterias?: CombinableCriteriaOfETextSearchTypeAndString[] | undefined;
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
}

export class TextSearch extends FilterCriteriaBaseOfETextSearchTypeAndString implements ITextSearch {

    constructor(data?: ITextSearch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TextSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TextSearch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TextSearch {
        const json = this.toJSON();
        let result = new TextSearch();
        result.init(json);
        return result;
    }
}

export interface ITextSearch extends IFilterCriteriaBaseOfETextSearchTypeAndString {
}

export class CombinableCriteriaOfETextSearchTypeAndString implements ICombinableCriteriaOfETextSearchTypeAndString {
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;

    constructor(data?: ICombinableCriteriaOfETextSearchTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfETextSearchTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfETextSearchTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }

    clone(): CombinableCriteriaOfETextSearchTypeAndString {
        const json = this.toJSON();
        let result = new CombinableCriteriaOfETextSearchTypeAndString();
        result.init(json);
        return result;
    }
}

export interface ICombinableCriteriaOfETextSearchTypeAndString {
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;
}

export enum ETextSearchType {
    StartWith = "StartWith",
    EndWith = "EndWith",
    Contains = "Contains",
    NotContains = "NotContains",
    Equals = "Equals",
    NotEquals = "NotEquals",
}

export class UpdateDataTranslationCommand implements IUpdateDataTranslationCommand {
    updateDataTranslationDto?: UpdateDataTranslationDto | undefined;

    constructor(data?: IUpdateDataTranslationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateDataTranslationDto = _data["updateDataTranslationDto"] ? UpdateDataTranslationDto.fromJS(_data["updateDataTranslationDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateDataTranslationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataTranslationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateDataTranslationDto"] = this.updateDataTranslationDto ? this.updateDataTranslationDto.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateDataTranslationCommand {
        const json = this.toJSON();
        let result = new UpdateDataTranslationCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateDataTranslationCommand {
    updateDataTranslationDto?: UpdateDataTranslationDto | undefined;
}

export class UpdateDataTranslationDto implements IUpdateDataTranslationDto {
    dataTranslationValueId?: number | undefined;
    dataTranslationId?: number;
    languageCode?: string | undefined;
    text?: string | undefined;

    constructor(data?: IUpdateDataTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataTranslationValueId = _data["dataTranslationValueId"];
            this.dataTranslationId = _data["dataTranslationId"];
            this.languageCode = _data["languageCode"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): UpdateDataTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataTranslationValueId"] = this.dataTranslationValueId;
        data["dataTranslationId"] = this.dataTranslationId;
        data["languageCode"] = this.languageCode;
        data["text"] = this.text;
        return data;
    }

    clone(): UpdateDataTranslationDto {
        const json = this.toJSON();
        let result = new UpdateDataTranslationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDataTranslationDto {
    dataTranslationValueId?: number | undefined;
    dataTranslationId?: number;
    languageCode?: string | undefined;
    text?: string | undefined;
}

export class PaginatedResultsOfDataTranslationGridDto implements IPaginatedResultsOfDataTranslationGridDto {
    totalCount?: number;
    results?: DataTranslationGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDataTranslationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DataTranslationGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDataTranslationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDataTranslationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfDataTranslationGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfDataTranslationGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfDataTranslationGridDto {
    totalCount?: number;
    results?: DataTranslationGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class DataTranslationGridDto implements IDataTranslationGridDto {
    dataTranslationId?: number;
    entityName?: string | undefined;
    entityId?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    dataTranslationText?: string | undefined;

    constructor(data?: IDataTranslationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataTranslationId = _data["dataTranslationId"];
            this.entityName = _data["entityName"];
            this.entityId = _data["entityId"];
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : <any>undefined;
            this.dataTranslationText = _data["dataTranslationText"];
        }
    }

    static fromJS(data: any): DataTranslationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataTranslationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataTranslationId"] = this.dataTranslationId;
        data["entityName"] = this.entityName;
        data["entityId"] = this.entityId;
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : <any>undefined;
        data["dataTranslationText"] = this.dataTranslationText;
        return data;
    }

    clone(): DataTranslationGridDto {
        const json = this.toJSON();
        let result = new DataTranslationGridDto();
        result.init(json);
        return result;
    }
}

export interface IDataTranslationGridDto {
    dataTranslationId?: number;
    entityName?: string | undefined;
    entityId?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    dataTranslationText?: string | undefined;
}

export class SearchQueryOfDataTranslationInfoSearchCriteria implements ISearchQueryOfDataTranslationInfoSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: DataTranslationInfoSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfDataTranslationInfoSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? DataTranslationInfoSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfDataTranslationInfoSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfDataTranslationInfoSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfDataTranslationInfoSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfDataTranslationInfoSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfDataTranslationInfoSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: DataTranslationInfoSearchCriteria | undefined;
}

export class DataTranslationInfoSearchCriteria extends PaginatedSearchable implements IDataTranslationInfoSearchCriteria {

    constructor(data?: IDataTranslationInfoSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DataTranslationInfoSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new DataTranslationInfoSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): DataTranslationInfoSearchCriteria {
        const json = this.toJSON();
        let result = new DataTranslationInfoSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface IDataTranslationInfoSearchCriteria extends IPaginatedSearchable {
}

export class EditDutyDto extends LastUpdateViewerDto implements IEditDutyDto {
    id?: number;
    employeeId?: number;
    dueDate?: Date | undefined;
    isUrgent?: boolean;
    isUnavailable?: boolean;
    isDone?: boolean;
    description?: string | undefined;

    constructor(data?: IEditDutyDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.isUrgent = _data["isUrgent"];
            this.isUnavailable = _data["isUnavailable"];
            this.isDone = _data["isDone"];
            this.description = _data["description"];
        }
    }

    static override fromJS(data: any): EditDutyDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditDutyDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["isUrgent"] = this.isUrgent;
        data["isUnavailable"] = this.isUnavailable;
        data["isDone"] = this.isDone;
        data["description"] = this.description;
        super.toJSON(data);
        return data;
    }

    clone(): EditDutyDto {
        const json = this.toJSON();
        let result = new EditDutyDto();
        result.init(json);
        return result;
    }
}

export interface IEditDutyDto extends ILastUpdateViewerDto {
    id?: number;
    employeeId?: number;
    dueDate?: Date | undefined;
    isUrgent?: boolean;
    isUnavailable?: boolean;
    isDone?: boolean;
    description?: string | undefined;
}

export class DutyGridDto implements IDutyGridDto {
    id?: number;
    employeeId?: number;
    dueDate?: Date | undefined;
    employeeName?: string | undefined;
    isUrgent?: boolean;
    isUnavailable?: boolean;
    isDone?: boolean;
    description?: string | undefined;

    constructor(data?: IDutyGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.employeeName = _data["employeeName"];
            this.isUrgent = _data["isUrgent"];
            this.isUnavailable = _data["isUnavailable"];
            this.isDone = _data["isDone"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DutyGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DutyGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["employeeName"] = this.employeeName;
        data["isUrgent"] = this.isUrgent;
        data["isUnavailable"] = this.isUnavailable;
        data["isDone"] = this.isDone;
        data["description"] = this.description;
        return data;
    }

    clone(): DutyGridDto {
        const json = this.toJSON();
        let result = new DutyGridDto();
        result.init(json);
        return result;
    }
}

export interface IDutyGridDto {
    id?: number;
    employeeId?: number;
    dueDate?: Date | undefined;
    employeeName?: string | undefined;
    isUrgent?: boolean;
    isUnavailable?: boolean;
    isDone?: boolean;
    description?: string | undefined;
}

export class EditDutiesDto implements IEditDutiesDto {
    duties?: DutyGridDto[] | undefined;

    constructor(data?: IEditDutiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["duties"])) {
                this.duties = [] as any;
                for (let item of _data["duties"])
                    this.duties!.push(DutyGridDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditDutiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditDutiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.duties)) {
            data["duties"] = [];
            for (let item of this.duties)
                data["duties"].push(item.toJSON());
        }
        return data;
    }

    clone(): EditDutiesDto {
        const json = this.toJSON();
        let result = new EditDutiesDto();
        result.init(json);
        return result;
    }
}

export interface IEditDutiesDto {
    duties?: DutyGridDto[] | undefined;
}

export class PaginatedResultsOfDutyGridDto implements IPaginatedResultsOfDutyGridDto {
    totalCount?: number;
    results?: DutyGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDutyGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DutyGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDutyGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDutyGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfDutyGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfDutyGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfDutyGridDto {
    totalCount?: number;
    results?: DutyGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class SearchQueryOfDutySearchDto implements ISearchQueryOfDutySearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: DutySearchDto | undefined;

    constructor(data?: ISearchQueryOfDutySearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? DutySearchDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfDutySearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfDutySearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfDutySearchDto {
        const json = this.toJSON();
        let result = new SearchQueryOfDutySearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfDutySearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: DutySearchDto | undefined;
}

export class DutySearchDto extends PaginatedSearchable implements IDutySearchDto {

    constructor(data?: IDutySearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DutySearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new DutySearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): DutySearchDto {
        const json = this.toJSON();
        let result = new DutySearchDto();
        result.init(json);
        return result;
    }
}

export interface IDutySearchDto extends IPaginatedSearchable {
}

export class EditEmployeeDto extends LastUpdateViewerDto implements IEditEmployeeDto {
    id?: number;
    siteId?: number;
    functionId?: number | undefined;
    identifier?: string | undefined;
    contact?: ContactDto | undefined;
    apaAccountIdentifier?: string | undefined;
    employeeLanguages?: EmployeeLanguageDto[] | undefined;
    assignmentIds?: number[] | undefined;

    constructor(data?: IEditEmployeeDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.siteId = _data["siteId"];
            this.functionId = _data["functionId"];
            this.identifier = _data["identifier"];
            this.contact = _data["contact"] ? ContactDto.fromJS(_data["contact"]) : <any>undefined;
            this.apaAccountIdentifier = _data["apaAccountIdentifier"];
            if (Array.isArray(_data["employeeLanguages"])) {
                this.employeeLanguages = [] as any;
                for (let item of _data["employeeLanguages"])
                    this.employeeLanguages!.push(EmployeeLanguageDto.fromJS(item));
            }
            if (Array.isArray(_data["assignmentIds"])) {
                this.assignmentIds = [] as any;
                for (let item of _data["assignmentIds"])
                    this.assignmentIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): EditEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditEmployeeDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["siteId"] = this.siteId;
        data["functionId"] = this.functionId;
        data["identifier"] = this.identifier;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["apaAccountIdentifier"] = this.apaAccountIdentifier;
        if (Array.isArray(this.employeeLanguages)) {
            data["employeeLanguages"] = [];
            for (let item of this.employeeLanguages)
                data["employeeLanguages"].push(item.toJSON());
        }
        if (Array.isArray(this.assignmentIds)) {
            data["assignmentIds"] = [];
            for (let item of this.assignmentIds)
                data["assignmentIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EditEmployeeDto {
        const json = this.toJSON();
        let result = new EditEmployeeDto();
        result.init(json);
        return result;
    }
}

export interface IEditEmployeeDto extends ILastUpdateViewerDto {
    id?: number;
    siteId?: number;
    functionId?: number | undefined;
    identifier?: string | undefined;
    contact?: ContactDto | undefined;
    apaAccountIdentifier?: string | undefined;
    employeeLanguages?: EmployeeLanguageDto[] | undefined;
    assignmentIds?: number[] | undefined;
}

export class ContactDto implements IContactDto {
    id?: number;
    firstName?: string | undefined;
    name?: string | undefined;
    genderId?: number;
    contactPhones?: ContactPhoneNumberDto[] | undefined;
    contactEmails?: ContactEmailDto[] | undefined;
    contactAddresses?: ContactAddressDto[] | undefined;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.name = _data["name"];
            this.genderId = _data["genderId"];
            if (Array.isArray(_data["contactPhones"])) {
                this.contactPhones = [] as any;
                for (let item of _data["contactPhones"])
                    this.contactPhones!.push(ContactPhoneNumberDto.fromJS(item));
            }
            if (Array.isArray(_data["contactEmails"])) {
                this.contactEmails = [] as any;
                for (let item of _data["contactEmails"])
                    this.contactEmails!.push(ContactEmailDto.fromJS(item));
            }
            if (Array.isArray(_data["contactAddresses"])) {
                this.contactAddresses = [] as any;
                for (let item of _data["contactAddresses"])
                    this.contactAddresses!.push(ContactAddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["name"] = this.name;
        data["genderId"] = this.genderId;
        if (Array.isArray(this.contactPhones)) {
            data["contactPhones"] = [];
            for (let item of this.contactPhones)
                data["contactPhones"].push(item.toJSON());
        }
        if (Array.isArray(this.contactEmails)) {
            data["contactEmails"] = [];
            for (let item of this.contactEmails)
                data["contactEmails"].push(item.toJSON());
        }
        if (Array.isArray(this.contactAddresses)) {
            data["contactAddresses"] = [];
            for (let item of this.contactAddresses)
                data["contactAddresses"].push(item.toJSON());
        }
        return data;
    }

    clone(): ContactDto {
        const json = this.toJSON();
        let result = new ContactDto();
        result.init(json);
        return result;
    }
}

export interface IContactDto {
    id?: number;
    firstName?: string | undefined;
    name?: string | undefined;
    genderId?: number;
    contactPhones?: ContactPhoneNumberDto[] | undefined;
    contactEmails?: ContactEmailDto[] | undefined;
    contactAddresses?: ContactAddressDto[] | undefined;
}

export class ContactPhoneNumberDto implements IContactPhoneNumberDto {
    id?: number;
    phoneNumber?: string | undefined;
    contactId?: number;
    phoneNumberTypeId?: number;
    phoneNumberType?: EPhoneNumberTypes;

    constructor(data?: IContactPhoneNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.phoneNumber = _data["phoneNumber"];
            this.contactId = _data["contactId"];
            this.phoneNumberTypeId = _data["phoneNumberTypeId"];
            this.phoneNumberType = _data["phoneNumberType"];
        }
    }

    static fromJS(data: any): ContactPhoneNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactPhoneNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["phoneNumber"] = this.phoneNumber;
        data["contactId"] = this.contactId;
        data["phoneNumberTypeId"] = this.phoneNumberTypeId;
        data["phoneNumberType"] = this.phoneNumberType;
        return data;
    }

    clone(): ContactPhoneNumberDto {
        const json = this.toJSON();
        let result = new ContactPhoneNumberDto();
        result.init(json);
        return result;
    }
}

export interface IContactPhoneNumberDto {
    id?: number;
    phoneNumber?: string | undefined;
    contactId?: number;
    phoneNumberTypeId?: number;
    phoneNumberType?: EPhoneNumberTypes;
}

export enum EPhoneNumberTypes {
    Mobile1 = "Mobile1",
    Mobile2 = "Mobile2",
    Fix = "Fix",
}

export class ContactEmailDto implements IContactEmailDto {
    id?: number;
    email?: string | undefined;
    contactId?: number;
    emailTypeId?: number;
    emailType?: EEmailTypes;

    constructor(data?: IContactEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.contactId = _data["contactId"];
            this.emailTypeId = _data["emailTypeId"];
            this.emailType = _data["emailType"];
        }
    }

    static fromJS(data: any): ContactEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["contactId"] = this.contactId;
        data["emailTypeId"] = this.emailTypeId;
        data["emailType"] = this.emailType;
        return data;
    }

    clone(): ContactEmailDto {
        const json = this.toJSON();
        let result = new ContactEmailDto();
        result.init(json);
        return result;
    }
}

export interface IContactEmailDto {
    id?: number;
    email?: string | undefined;
    contactId?: number;
    emailTypeId?: number;
    emailType?: EEmailTypes;
}

export enum EEmailTypes {
    Main = "Main",
}

export class ContactAddressDto implements IContactAddressDto {
    id?: number;
    contactId?: number;
    addressTypeName?: string | undefined;
    addressType?: EAddressTypes;
    address?: EditAddressDto | undefined;

    constructor(data?: IContactAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.addressTypeName = _data["addressTypeName"];
            this.addressType = _data["addressType"];
            this.address = _data["address"] ? EditAddressDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["addressTypeName"] = this.addressTypeName;
        data["addressType"] = this.addressType;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }

    clone(): ContactAddressDto {
        const json = this.toJSON();
        let result = new ContactAddressDto();
        result.init(json);
        return result;
    }
}

export interface IContactAddressDto {
    id?: number;
    contactId?: number;
    addressTypeName?: string | undefined;
    addressType?: EAddressTypes;
    address?: EditAddressDto | undefined;
}

export enum EAddressTypes {
    Administrative = "Administrative",
    Domiciliation = "Domiciliation",
}

export class EditAddressDto implements IEditAddressDto {
    id?: number;
    street?: string | undefined;
    number?: string | undefined;
    box?: string | undefined;
    countryId?: number;
    postalCode?: string | undefined;
    city?: string | undefined;

    constructor(data?: IEditAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.street = _data["street"];
            this.number = _data["number"];
            this.box = _data["box"];
            this.countryId = _data["countryId"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): EditAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["street"] = this.street;
        data["number"] = this.number;
        data["box"] = this.box;
        data["countryId"] = this.countryId;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        return data;
    }

    clone(): EditAddressDto {
        const json = this.toJSON();
        let result = new EditAddressDto();
        result.init(json);
        return result;
    }
}

export interface IEditAddressDto {
    id?: number;
    street?: string | undefined;
    number?: string | undefined;
    box?: string | undefined;
    countryId?: number;
    postalCode?: string | undefined;
    city?: string | undefined;
}

export class EmployeeLanguageDto implements IEmployeeLanguageDto {
    id?: number;
    employeeId?: number;
    apaLanguageId?: number;
    isMain?: boolean;
    isUsedForTraining?: boolean;
    languageLabel?: string | undefined;

    constructor(data?: IEmployeeLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.apaLanguageId = _data["apaLanguageId"];
            this.isMain = _data["isMain"];
            this.isUsedForTraining = _data["isUsedForTraining"];
            this.languageLabel = _data["languageLabel"];
        }
    }

    static fromJS(data: any): EmployeeLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["apaLanguageId"] = this.apaLanguageId;
        data["isMain"] = this.isMain;
        data["isUsedForTraining"] = this.isUsedForTraining;
        data["languageLabel"] = this.languageLabel;
        return data;
    }

    clone(): EmployeeLanguageDto {
        const json = this.toJSON();
        let result = new EmployeeLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeLanguageDto {
    id?: number;
    employeeId?: number;
    apaLanguageId?: number;
    isMain?: boolean;
    isUsedForTraining?: boolean;
    languageLabel?: string | undefined;
}

export class EmployeeCalendarInfoDto implements IEmployeeCalendarInfoDto {
    id?: number;
    fullName?: string | undefined;

    constructor(data?: IEmployeeCalendarInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): EmployeeCalendarInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeCalendarInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        return data;
    }

    clone(): EmployeeCalendarInfoDto {
        const json = this.toJSON();
        let result = new EmployeeCalendarInfoDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeCalendarInfoDto {
    id?: number;
    fullName?: string | undefined;
}

export class EmployeePlanningSearchDto implements IEmployeePlanningSearchDto {
    siteId?: number | undefined;
    assignmentId?: number | undefined;
    employeeIds?: number[] | undefined;

    constructor(data?: IEmployeePlanningSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.assignmentId = _data["assignmentId"];
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): EmployeePlanningSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePlanningSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["assignmentId"] = this.assignmentId;
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        return data;
    }

    clone(): EmployeePlanningSearchDto {
        const json = this.toJSON();
        let result = new EmployeePlanningSearchDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeePlanningSearchDto {
    siteId?: number | undefined;
    assignmentId?: number | undefined;
    employeeIds?: number[] | undefined;
}

export class EditAssessmentDto implements IEditAssessmentDto {
    id?: number;
    isOkForLevel1?: boolean;
    isOkForLevel2?: boolean;
    isOkForLevel3?: boolean;
    employeeId?: number;
    teacherEmployeeId?: number | undefined;

    constructor(data?: IEditAssessmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOkForLevel1 = _data["isOkForLevel1"];
            this.isOkForLevel2 = _data["isOkForLevel2"];
            this.isOkForLevel3 = _data["isOkForLevel3"];
            this.employeeId = _data["employeeId"];
            this.teacherEmployeeId = _data["teacherEmployeeId"];
        }
    }

    static fromJS(data: any): EditAssessmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditAssessmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOkForLevel1"] = this.isOkForLevel1;
        data["isOkForLevel2"] = this.isOkForLevel2;
        data["isOkForLevel3"] = this.isOkForLevel3;
        data["employeeId"] = this.employeeId;
        data["teacherEmployeeId"] = this.teacherEmployeeId;
        return data;
    }

    clone(): EditAssessmentDto {
        const json = this.toJSON();
        let result = new EditAssessmentDto();
        result.init(json);
        return result;
    }
}

export interface IEditAssessmentDto {
    id?: number;
    isOkForLevel1?: boolean;
    isOkForLevel2?: boolean;
    isOkForLevel3?: boolean;
    employeeId?: number;
    teacherEmployeeId?: number | undefined;
}

export class PaginatedResultsOfEmployeeGridDto implements IPaginatedResultsOfEmployeeGridDto {
    totalCount?: number;
    results?: EmployeeGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfEmployeeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(EmployeeGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfEmployeeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfEmployeeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfEmployeeGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfEmployeeGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfEmployeeGridDto {
    totalCount?: number;
    results?: EmployeeGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class EmployeeGridDto implements IEmployeeGridDto {
    id?: number;
    identifier?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    email?: string | undefined;
    site?: string | undefined;
    absence?: string | undefined;
    function?: string | undefined;
    assignments?: string[] | undefined;

    constructor(data?: IEmployeeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.phone = _data["phone"];
            this.cellPhone = _data["cellPhone"];
            this.email = _data["email"];
            this.site = _data["site"];
            this.absence = _data["absence"];
            this.function = _data["function"];
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(item);
            }
        }
    }

    static fromJS(data: any): EmployeeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["email"] = this.email;
        data["site"] = this.site;
        data["absence"] = this.absence;
        data["function"] = this.function;
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item);
        }
        return data;
    }

    clone(): EmployeeGridDto {
        const json = this.toJSON();
        let result = new EmployeeGridDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeGridDto {
    id?: number;
    identifier?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    email?: string | undefined;
    site?: string | undefined;
    absence?: string | undefined;
    function?: string | undefined;
    assignments?: string[] | undefined;
}

export class SearchQueryOfEmployeeSearch implements ISearchQueryOfEmployeeSearch {
    expression?: AbstractSearchExpression | undefined;
    criteria?: EmployeeSearch | undefined;

    constructor(data?: ISearchQueryOfEmployeeSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? EmployeeSearch.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfEmployeeSearch {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfEmployeeSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfEmployeeSearch {
        const json = this.toJSON();
        let result = new SearchQueryOfEmployeeSearch();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfEmployeeSearch {
    expression?: AbstractSearchExpression | undefined;
    criteria?: EmployeeSearch | undefined;
}

export class EmployeeSearch extends PaginatedSearchable implements IEmployeeSearch {
    lastName?: TextSearch | undefined;
    firstName?: TextSearch | undefined;
    siteSearch?: TextSearch | undefined;
    apaIdentifier?: TextSearch | undefined;
    assignment?: TextSearch | undefined;
    functionConcat?: TextSearch | undefined;

    constructor(data?: IEmployeeSearch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lastName = _data["lastName"] ? TextSearch.fromJS(_data["lastName"]) : <any>undefined;
            this.firstName = _data["firstName"] ? TextSearch.fromJS(_data["firstName"]) : <any>undefined;
            this.siteSearch = _data["siteSearch"] ? TextSearch.fromJS(_data["siteSearch"]) : <any>undefined;
            this.apaIdentifier = _data["apaIdentifier"] ? TextSearch.fromJS(_data["apaIdentifier"]) : <any>undefined;
            this.assignment = _data["assignment"] ? TextSearch.fromJS(_data["assignment"]) : <any>undefined;
            this.functionConcat = _data["functionConcat"] ? TextSearch.fromJS(_data["functionConcat"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): EmployeeSearch {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSearch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastName"] = this.lastName ? this.lastName.toJSON() : <any>undefined;
        data["firstName"] = this.firstName ? this.firstName.toJSON() : <any>undefined;
        data["siteSearch"] = this.siteSearch ? this.siteSearch.toJSON() : <any>undefined;
        data["apaIdentifier"] = this.apaIdentifier ? this.apaIdentifier.toJSON() : <any>undefined;
        data["assignment"] = this.assignment ? this.assignment.toJSON() : <any>undefined;
        data["functionConcat"] = this.functionConcat ? this.functionConcat.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeSearch {
        const json = this.toJSON();
        let result = new EmployeeSearch();
        result.init(json);
        return result;
    }
}

export interface IEmployeeSearch extends IPaginatedSearchable {
    lastName?: TextSearch | undefined;
    firstName?: TextSearch | undefined;
    siteSearch?: TextSearch | undefined;
    apaIdentifier?: TextSearch | undefined;
    assignment?: TextSearch | undefined;
    functionConcat?: TextSearch | undefined;
}

export class EditFunctionDto extends LastUpdateViewerDto implements IEditFunctionDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;

    constructor(data?: IEditFunctionDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): EditFunctionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditFunctionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): EditFunctionDto {
        const json = this.toJSON();
        let result = new EditFunctionDto();
        result.init(json);
        return result;
    }
}

export interface IEditFunctionDto extends ILastUpdateViewerDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
}

export class PaginatedResultsOfFunctionGridDto implements IPaginatedResultsOfFunctionGridDto {
    totalCount?: number;
    results?: FunctionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfFunctionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FunctionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfFunctionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfFunctionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfFunctionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfFunctionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfFunctionGridDto {
    totalCount?: number;
    results?: FunctionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class FunctionGridDto implements IFunctionGridDto {
    id?: number | undefined;
    code?: string | undefined;
    label?: string | undefined;

    constructor(data?: IFunctionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): FunctionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["label"] = this.label;
        return data;
    }

    clone(): FunctionGridDto {
        const json = this.toJSON();
        let result = new FunctionGridDto();
        result.init(json);
        return result;
    }
}

export interface IFunctionGridDto {
    id?: number | undefined;
    code?: string | undefined;
    label?: string | undefined;
}

export class SearchQueryOfFunctionSearchDto implements ISearchQueryOfFunctionSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: FunctionSearchDto | undefined;

    constructor(data?: ISearchQueryOfFunctionSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? FunctionSearchDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfFunctionSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfFunctionSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfFunctionSearchDto {
        const json = this.toJSON();
        let result = new SearchQueryOfFunctionSearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfFunctionSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: FunctionSearchDto | undefined;
}

export class FunctionSearchDto extends PaginatedSearchable implements IFunctionSearchDto {

    constructor(data?: IFunctionSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): FunctionSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): FunctionSearchDto {
        const json = this.toJSON();
        let result = new FunctionSearchDto();
        result.init(json);
        return result;
    }
}

export interface IFunctionSearchDto extends IPaginatedSearchable {
}

export class EditHourlyTypeDto extends LastUpdateViewerDto implements IEditHourlyTypeDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    timeFrom?: string | undefined;
    frontTimeFrom?: Date | undefined;
    timeTo?: string | undefined;
    frontTimeTo?: Date | undefined;
    useForVia?: boolean;

    constructor(data?: IEditHourlyTypeDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : <any>undefined;
            this.timeFrom = _data["timeFrom"];
            this.frontTimeFrom = _data["frontTimeFrom"] ? new Date(_data["frontTimeFrom"].toString()) : <any>undefined;
            this.timeTo = _data["timeTo"];
            this.frontTimeTo = _data["frontTimeTo"] ? new Date(_data["frontTimeTo"].toString()) : <any>undefined;
            this.useForVia = _data["useForVia"];
        }
    }

    static override fromJS(data: any): EditHourlyTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditHourlyTypeDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : <any>undefined;
        data["timeFrom"] = this.timeFrom;
        data["frontTimeFrom"] = this.frontTimeFrom ? this.frontTimeFrom.toISOString() : <any>undefined;
        data["timeTo"] = this.timeTo;
        data["frontTimeTo"] = this.frontTimeTo ? this.frontTimeTo.toISOString() : <any>undefined;
        data["useForVia"] = this.useForVia;
        super.toJSON(data);
        return data;
    }

    clone(): EditHourlyTypeDto {
        const json = this.toJSON();
        let result = new EditHourlyTypeDto();
        result.init(json);
        return result;
    }
}

export interface IEditHourlyTypeDto extends ILastUpdateViewerDto {
    id?: number;
    code?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    timeFrom?: string | undefined;
    frontTimeFrom?: Date | undefined;
    timeTo?: string | undefined;
    frontTimeTo?: Date | undefined;
    useForVia?: boolean;
}

export class PaginatedResultsOfHourlyTypeGridDto implements IPaginatedResultsOfHourlyTypeGridDto {
    totalCount?: number;
    results?: HourlyTypeGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfHourlyTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(HourlyTypeGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfHourlyTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfHourlyTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfHourlyTypeGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfHourlyTypeGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfHourlyTypeGridDto {
    totalCount?: number;
    results?: HourlyTypeGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class HourlyTypeGridDto implements IHourlyTypeGridDto {
    id?: number | undefined;
    code?: string | undefined;
    label?: string | undefined;
    useForVia?: boolean;

    constructor(data?: IHourlyTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.label = _data["label"];
            this.useForVia = _data["useForVia"];
        }
    }

    static fromJS(data: any): HourlyTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new HourlyTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["label"] = this.label;
        data["useForVia"] = this.useForVia;
        return data;
    }

    clone(): HourlyTypeGridDto {
        const json = this.toJSON();
        let result = new HourlyTypeGridDto();
        result.init(json);
        return result;
    }
}

export interface IHourlyTypeGridDto {
    id?: number | undefined;
    code?: string | undefined;
    label?: string | undefined;
    useForVia?: boolean;
}

export class SearchQueryOfHourlyTypeSearchDto implements ISearchQueryOfHourlyTypeSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: HourlyTypeSearchDto | undefined;

    constructor(data?: ISearchQueryOfHourlyTypeSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? HourlyTypeSearchDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfHourlyTypeSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfHourlyTypeSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfHourlyTypeSearchDto {
        const json = this.toJSON();
        let result = new SearchQueryOfHourlyTypeSearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfHourlyTypeSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: HourlyTypeSearchDto | undefined;
}

export class HourlyTypeSearchDto extends PaginatedSearchable implements IHourlyTypeSearchDto {

    constructor(data?: IHourlyTypeSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): HourlyTypeSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new HourlyTypeSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): HourlyTypeSearchDto {
        const json = this.toJSON();
        let result = new HourlyTypeSearchDto();
        result.init(json);
        return result;
    }
}

export interface IHourlyTypeSearchDto extends IPaginatedSearchable {
}

export class LanguageDto implements ILanguageDto {
    id?: number;
    code?: string | undefined;
    label?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: ILanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.label = _data["label"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["label"] = this.label;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): LanguageDto {
        const json = this.toJSON();
        let result = new LanguageDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageDto {
    id?: number;
    code?: string | undefined;
    label?: string | undefined;
    isActive?: boolean | undefined;
}

export class ApaLanguageDto implements IApaLanguageDto {
    id?: number;
    frLabel?: string | undefined;
    iso?: string | undefined;

    constructor(data?: IApaLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.frLabel = _data["frLabel"];
            this.iso = _data["iso"];
        }
    }

    static fromJS(data: any): ApaLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApaLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["frLabel"] = this.frLabel;
        data["iso"] = this.iso;
        return data;
    }

    clone(): ApaLanguageDto {
        const json = this.toJSON();
        let result = new ApaLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IApaLanguageDto {
    id?: number;
    frLabel?: string | undefined;
    iso?: string | undefined;
}

export class EditMailTemplateDto extends LastUpdateViewerDto implements IEditMailTemplateDto {
    id?: number;
    code?: EEmailTemplate;
    descriptionTranslation?: DataTranslationDto | undefined;
    mailContents?: MailTemplateContentGridDto[] | undefined;

    constructor(data?: IEditMailTemplateDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.descriptionTranslation = _data["descriptionTranslation"] ? DataTranslationDto.fromJS(_data["descriptionTranslation"]) : <any>undefined;
            if (Array.isArray(_data["mailContents"])) {
                this.mailContents = [] as any;
                for (let item of _data["mailContents"])
                    this.mailContents!.push(MailTemplateContentGridDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EditMailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditMailTemplateDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["descriptionTranslation"] = this.descriptionTranslation ? this.descriptionTranslation.toJSON() : <any>undefined;
        if (Array.isArray(this.mailContents)) {
            data["mailContents"] = [];
            for (let item of this.mailContents)
                data["mailContents"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): EditMailTemplateDto {
        const json = this.toJSON();
        let result = new EditMailTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IEditMailTemplateDto extends ILastUpdateViewerDto {
    id?: number;
    code?: EEmailTemplate;
    descriptionTranslation?: DataTranslationDto | undefined;
    mailContents?: MailTemplateContentGridDto[] | undefined;
}

export enum EEmailTemplate {
    TestEmail = "TestEmail",
    AbsenceNotification = "AbsenceNotification",
}

export class MailTemplateContentGridDto implements IMailTemplateContentGridDto {
    mailTemplateId?: number;
    apaLanguageId?: number;
    subject?: string | undefined;
    apaLanguageLabel?: string | undefined;
    hasContent?: boolean;

    constructor(data?: IMailTemplateContentGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailTemplateId = _data["mailTemplateId"];
            this.apaLanguageId = _data["apaLanguageId"];
            this.subject = _data["subject"];
            this.apaLanguageLabel = _data["apaLanguageLabel"];
            this.hasContent = _data["hasContent"];
        }
    }

    static fromJS(data: any): MailTemplateContentGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateContentGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailTemplateId"] = this.mailTemplateId;
        data["apaLanguageId"] = this.apaLanguageId;
        data["subject"] = this.subject;
        data["apaLanguageLabel"] = this.apaLanguageLabel;
        data["hasContent"] = this.hasContent;
        return data;
    }

    clone(): MailTemplateContentGridDto {
        const json = this.toJSON();
        let result = new MailTemplateContentGridDto();
        result.init(json);
        return result;
    }
}

export interface IMailTemplateContentGridDto {
    mailTemplateId?: number;
    apaLanguageId?: number;
    subject?: string | undefined;
    apaLanguageLabel?: string | undefined;
    hasContent?: boolean;
}

export class EditMailTemplateContentDto extends LastUpdateViewerDto implements IEditMailTemplateContentDto {
    mailTemplateId?: number;
    apaLanguageId?: number;
    apaLanguageLabel?: string | undefined;
    subject?: string | undefined;
    content?: string | undefined;

    constructor(data?: IEditMailTemplateContentDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mailTemplateId = _data["mailTemplateId"];
            this.apaLanguageId = _data["apaLanguageId"];
            this.apaLanguageLabel = _data["apaLanguageLabel"];
            this.subject = _data["subject"];
            this.content = _data["content"];
        }
    }

    static override fromJS(data: any): EditMailTemplateContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditMailTemplateContentDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailTemplateId"] = this.mailTemplateId;
        data["apaLanguageId"] = this.apaLanguageId;
        data["apaLanguageLabel"] = this.apaLanguageLabel;
        data["subject"] = this.subject;
        data["content"] = this.content;
        super.toJSON(data);
        return data;
    }

    clone(): EditMailTemplateContentDto {
        const json = this.toJSON();
        let result = new EditMailTemplateContentDto();
        result.init(json);
        return result;
    }
}

export interface IEditMailTemplateContentDto extends ILastUpdateViewerDto {
    mailTemplateId?: number;
    apaLanguageId?: number;
    apaLanguageLabel?: string | undefined;
    subject?: string | undefined;
    content?: string | undefined;
}

export class PaginatedResultsOfMailTemplateGridDto implements IPaginatedResultsOfMailTemplateGridDto {
    totalCount?: number;
    results?: MailTemplateGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfMailTemplateGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MailTemplateGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfMailTemplateGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfMailTemplateGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfMailTemplateGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfMailTemplateGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfMailTemplateGridDto {
    totalCount?: number;
    results?: MailTemplateGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class MailTemplateGridDto implements IMailTemplateGridDto {
    id?: number;
    code?: EEmailTemplate;
    description?: string | undefined;
    isTranslated?: boolean;

    constructor(data?: IMailTemplateGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.isTranslated = _data["isTranslated"];
        }
    }

    static fromJS(data: any): MailTemplateGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["isTranslated"] = this.isTranslated;
        return data;
    }

    clone(): MailTemplateGridDto {
        const json = this.toJSON();
        let result = new MailTemplateGridDto();
        result.init(json);
        return result;
    }
}

export interface IMailTemplateGridDto {
    id?: number;
    code?: EEmailTemplate;
    description?: string | undefined;
    isTranslated?: boolean;
}

export class SearchQueryOfMailTemplateSearch implements ISearchQueryOfMailTemplateSearch {
    expression?: AbstractSearchExpression | undefined;
    criteria?: MailTemplateSearch | undefined;

    constructor(data?: ISearchQueryOfMailTemplateSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? MailTemplateSearch.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfMailTemplateSearch {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfMailTemplateSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfMailTemplateSearch {
        const json = this.toJSON();
        let result = new SearchQueryOfMailTemplateSearch();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfMailTemplateSearch {
    expression?: AbstractSearchExpression | undefined;
    criteria?: MailTemplateSearch | undefined;
}

export class MailTemplateSearch extends PaginatedSearchable implements IMailTemplateSearch {

    constructor(data?: IMailTemplateSearch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MailTemplateSearch {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateSearch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): MailTemplateSearch {
        const json = this.toJSON();
        let result = new MailTemplateSearch();
        result.init(json);
        return result;
    }
}

export interface IMailTemplateSearch extends IPaginatedSearchable {
}

export class PaginatedResultsOfMeetingGridDto implements IPaginatedResultsOfMeetingGridDto {
    totalCount?: number;
    results?: MeetingGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfMeetingGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MeetingGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfMeetingGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfMeetingGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfMeetingGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfMeetingGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfMeetingGridDto {
    totalCount?: number;
    results?: MeetingGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class MeetingGridDto implements IMeetingGridDto {
    id?: number;
    roomId?: number | undefined;
    room?: string | undefined;
    site?: string | undefined;
    bookingDate?: Date | undefined;
    startHour?: Date | undefined;
    duration?: number | undefined;
    employee?: string | undefined;
    employeeId?: number;
    contact?: string | undefined;
    isInterpreterRequired?: boolean;
    isUrgent?: boolean;
    meetingType?: string | undefined;
    meetingTypeId?: number;
    meetingAttendee?: string | undefined;

    constructor(data?: IMeetingGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roomId = _data["roomId"];
            this.room = _data["room"];
            this.site = _data["site"];
            this.bookingDate = _data["bookingDate"] ? new Date(_data["bookingDate"].toString()) : <any>undefined;
            this.startHour = _data["startHour"] ? new Date(_data["startHour"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.employee = _data["employee"];
            this.employeeId = _data["employeeId"];
            this.contact = _data["contact"];
            this.isInterpreterRequired = _data["isInterpreterRequired"];
            this.isUrgent = _data["isUrgent"];
            this.meetingType = _data["meetingType"];
            this.meetingTypeId = _data["meetingTypeId"];
            this.meetingAttendee = _data["meetingAttendee"];
        }
    }

    static fromJS(data: any): MeetingGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roomId"] = this.roomId;
        data["room"] = this.room;
        data["site"] = this.site;
        data["bookingDate"] = this.bookingDate ? this.bookingDate.toISOString() : <any>undefined;
        data["startHour"] = this.startHour ? this.startHour.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["employee"] = this.employee;
        data["employeeId"] = this.employeeId;
        data["contact"] = this.contact;
        data["isInterpreterRequired"] = this.isInterpreterRequired;
        data["isUrgent"] = this.isUrgent;
        data["meetingType"] = this.meetingType;
        data["meetingTypeId"] = this.meetingTypeId;
        data["meetingAttendee"] = this.meetingAttendee;
        return data;
    }

    clone(): MeetingGridDto {
        const json = this.toJSON();
        let result = new MeetingGridDto();
        result.init(json);
        return result;
    }
}

export interface IMeetingGridDto {
    id?: number;
    roomId?: number | undefined;
    room?: string | undefined;
    site?: string | undefined;
    bookingDate?: Date | undefined;
    startHour?: Date | undefined;
    duration?: number | undefined;
    employee?: string | undefined;
    employeeId?: number;
    contact?: string | undefined;
    isInterpreterRequired?: boolean;
    isUrgent?: boolean;
    meetingType?: string | undefined;
    meetingTypeId?: number;
    meetingAttendee?: string | undefined;
}

export class SearchQueryOfMeetingSearchDto implements ISearchQueryOfMeetingSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: MeetingSearchDto | undefined;

    constructor(data?: ISearchQueryOfMeetingSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? MeetingSearchDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfMeetingSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfMeetingSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfMeetingSearchDto {
        const json = this.toJSON();
        let result = new SearchQueryOfMeetingSearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfMeetingSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: MeetingSearchDto | undefined;
}

export class MeetingSearchDto extends PaginatedSearchable implements IMeetingSearchDto {

    constructor(data?: IMeetingSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MeetingSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): MeetingSearchDto {
        const json = this.toJSON();
        let result = new MeetingSearchDto();
        result.init(json);
        return result;
    }
}

export interface IMeetingSearchDto extends IPaginatedSearchable {
}

export class EditMeetingDto extends LastUpdateViewerDto implements IEditMeetingDto {
    id?: number;
    employeeId?: number;
    isInterpreterRequired?: boolean;
    isUrgent?: boolean;
    description?: string | undefined;
    contactId?: number | undefined;
    contactFreeText?: string | undefined;
    meetingTypeId?: number;
    contactText?: string | undefined;
    presence?: boolean;
    setPresence?: boolean;
    meetingDate?: Date | undefined;
    newcomerLanguages?: NewComerLanguageDto[] | undefined;
    employeeLanguages?: EmployeeLanguageDto[] | undefined;

    constructor(data?: IEditMeetingDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.isInterpreterRequired = _data["isInterpreterRequired"];
            this.isUrgent = _data["isUrgent"];
            this.description = _data["description"];
            this.contactId = _data["contactId"];
            this.contactFreeText = _data["contactFreeText"];
            this.meetingTypeId = _data["meetingTypeId"];
            this.contactText = _data["contactText"];
            this.presence = _data["presence"];
            this.setPresence = _data["setPresence"];
            this.meetingDate = _data["meetingDate"] ? new Date(_data["meetingDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["newcomerLanguages"])) {
                this.newcomerLanguages = [] as any;
                for (let item of _data["newcomerLanguages"])
                    this.newcomerLanguages!.push(NewComerLanguageDto.fromJS(item));
            }
            if (Array.isArray(_data["employeeLanguages"])) {
                this.employeeLanguages = [] as any;
                for (let item of _data["employeeLanguages"])
                    this.employeeLanguages!.push(EmployeeLanguageDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): EditMeetingDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditMeetingDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["isInterpreterRequired"] = this.isInterpreterRequired;
        data["isUrgent"] = this.isUrgent;
        data["description"] = this.description;
        data["contactId"] = this.contactId;
        data["contactFreeText"] = this.contactFreeText;
        data["meetingTypeId"] = this.meetingTypeId;
        data["contactText"] = this.contactText;
        data["presence"] = this.presence;
        data["setPresence"] = this.setPresence;
        data["meetingDate"] = this.meetingDate ? this.meetingDate.toISOString() : <any>undefined;
        if (Array.isArray(this.newcomerLanguages)) {
            data["newcomerLanguages"] = [];
            for (let item of this.newcomerLanguages)
                data["newcomerLanguages"].push(item.toJSON());
        }
        if (Array.isArray(this.employeeLanguages)) {
            data["employeeLanguages"] = [];
            for (let item of this.employeeLanguages)
                data["employeeLanguages"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): EditMeetingDto {
        const json = this.toJSON();
        let result = new EditMeetingDto();
        result.init(json);
        return result;
    }
}

export interface IEditMeetingDto extends ILastUpdateViewerDto {
    id?: number;
    employeeId?: number;
    isInterpreterRequired?: boolean;
    isUrgent?: boolean;
    description?: string | undefined;
    contactId?: number | undefined;
    contactFreeText?: string | undefined;
    meetingTypeId?: number;
    contactText?: string | undefined;
    presence?: boolean;
    setPresence?: boolean;
    meetingDate?: Date | undefined;
    newcomerLanguages?: NewComerLanguageDto[] | undefined;
    employeeLanguages?: EmployeeLanguageDto[] | undefined;
}

export class NewComerLanguageDto implements INewComerLanguageDto {
    id?: number;
    isFavorite?: boolean;
    newComerId?: number;
    apaLanguageId?: number;
    languageLabel?: string | undefined;

    constructor(data?: INewComerLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isFavorite = _data["isFavorite"];
            this.newComerId = _data["newComerId"];
            this.apaLanguageId = _data["apaLanguageId"];
            this.languageLabel = _data["languageLabel"];
        }
    }

    static fromJS(data: any): NewComerLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewComerLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isFavorite"] = this.isFavorite;
        data["newComerId"] = this.newComerId;
        data["apaLanguageId"] = this.apaLanguageId;
        data["languageLabel"] = this.languageLabel;
        return data;
    }

    clone(): NewComerLanguageDto {
        const json = this.toJSON();
        let result = new NewComerLanguageDto();
        result.init(json);
        return result;
    }
}

export interface INewComerLanguageDto {
    id?: number;
    isFavorite?: boolean;
    newComerId?: number;
    apaLanguageId?: number;
    languageLabel?: string | undefined;
}

export class RoomBookingDto implements IRoomBookingDto {
    id?: number;
    roomId?: number;
    roomName?: string | undefined;
    siteId?: number;
    siteName?: string | undefined;
    bookingDate?: Date;
    duration?: number;
    employeeInRoomNextHour?: boolean;
    employeeInRoomPreviousHour?: boolean;
    meetingId?: number;
    employeeId?: number;

    constructor(data?: IRoomBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roomId = _data["roomId"];
            this.roomName = _data["roomName"];
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.bookingDate = _data["bookingDate"] ? new Date(_data["bookingDate"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.employeeInRoomNextHour = _data["employeeInRoomNextHour"];
            this.employeeInRoomPreviousHour = _data["employeeInRoomPreviousHour"];
            this.meetingId = _data["meetingId"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): RoomBookingDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomBookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roomId"] = this.roomId;
        data["roomName"] = this.roomName;
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["bookingDate"] = this.bookingDate ? this.bookingDate.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["employeeInRoomNextHour"] = this.employeeInRoomNextHour;
        data["employeeInRoomPreviousHour"] = this.employeeInRoomPreviousHour;
        data["meetingId"] = this.meetingId;
        data["employeeId"] = this.employeeId;
        return data;
    }

    clone(): RoomBookingDto {
        const json = this.toJSON();
        let result = new RoomBookingDto();
        result.init(json);
        return result;
    }
}

export interface IRoomBookingDto {
    id?: number;
    roomId?: number;
    roomName?: string | undefined;
    siteId?: number;
    siteName?: string | undefined;
    bookingDate?: Date;
    duration?: number;
    employeeInRoomNextHour?: boolean;
    employeeInRoomPreviousHour?: boolean;
    meetingId?: number;
    employeeId?: number;
}

export class RoomBookingInformationFormDto implements IRoomBookingInformationFormDto {
    hourFrom?: Date;
    hourTo?: Date;
    duration?: number;
    roomId?: number | undefined;
    siteId?: number | undefined;
    meetingId?: number;

    constructor(data?: IRoomBookingInformationFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hourFrom = _data["hourFrom"] ? new Date(_data["hourFrom"].toString()) : <any>undefined;
            this.hourTo = _data["hourTo"] ? new Date(_data["hourTo"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.roomId = _data["roomId"];
            this.siteId = _data["siteId"];
            this.meetingId = _data["meetingId"];
        }
    }

    static fromJS(data: any): RoomBookingInformationFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomBookingInformationFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hourFrom"] = this.hourFrom ? this.hourFrom.toISOString() : <any>undefined;
        data["hourTo"] = this.hourTo ? this.hourTo.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["roomId"] = this.roomId;
        data["siteId"] = this.siteId;
        data["meetingId"] = this.meetingId;
        return data;
    }

    clone(): RoomBookingInformationFormDto {
        const json = this.toJSON();
        let result = new RoomBookingInformationFormDto();
        result.init(json);
        return result;
    }
}

export interface IRoomBookingInformationFormDto {
    hourFrom?: Date;
    hourTo?: Date;
    duration?: number;
    roomId?: number | undefined;
    siteId?: number | undefined;
    meetingId?: number;
}

export class SearchQueryOfMeetingDashboardSearchDto implements ISearchQueryOfMeetingDashboardSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: MeetingDashboardSearchDto | undefined;

    constructor(data?: ISearchQueryOfMeetingDashboardSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? MeetingDashboardSearchDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfMeetingDashboardSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfMeetingDashboardSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfMeetingDashboardSearchDto {
        const json = this.toJSON();
        let result = new SearchQueryOfMeetingDashboardSearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfMeetingDashboardSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: MeetingDashboardSearchDto | undefined;
}

export class MeetingDashboardSearchDto extends PaginatedSearchable implements IMeetingDashboardSearchDto {
    employeeId?: number;
    dateFrom?: Date;
    dateTo?: Date;

    constructor(data?: IMeetingDashboardSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): MeetingDashboardSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingDashboardSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): MeetingDashboardSearchDto {
        const json = this.toJSON();
        let result = new MeetingDashboardSearchDto();
        result.init(json);
        return result;
    }
}

export interface IMeetingDashboardSearchDto extends IPaginatedSearchable {
    employeeId?: number;
    dateFrom?: Date;
    dateTo?: Date;
}

export class EditMeetingTypeDto extends LastUpdateViewerDto implements IEditMeetingTypeDto {
    id?: number;
    code?: string | undefined;
    colorCode?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    assignmentIds?: number[] | undefined;

    constructor(data?: IEditMeetingTypeDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.colorCode = _data["colorCode"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : <any>undefined;
            if (Array.isArray(_data["assignmentIds"])) {
                this.assignmentIds = [] as any;
                for (let item of _data["assignmentIds"])
                    this.assignmentIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): EditMeetingTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditMeetingTypeDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["colorCode"] = this.colorCode;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : <any>undefined;
        if (Array.isArray(this.assignmentIds)) {
            data["assignmentIds"] = [];
            for (let item of this.assignmentIds)
                data["assignmentIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): EditMeetingTypeDto {
        const json = this.toJSON();
        let result = new EditMeetingTypeDto();
        result.init(json);
        return result;
    }
}

export interface IEditMeetingTypeDto extends ILastUpdateViewerDto {
    id?: number;
    code?: string | undefined;
    colorCode?: string | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    assignmentIds?: number[] | undefined;
}

export class PaginatedResultsOfMeetingTypeGridDto implements IPaginatedResultsOfMeetingTypeGridDto {
    totalCount?: number;
    results?: MeetingTypeGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfMeetingTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MeetingTypeGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfMeetingTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfMeetingTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfMeetingTypeGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfMeetingTypeGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfMeetingTypeGridDto {
    totalCount?: number;
    results?: MeetingTypeGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class MeetingTypeGridDto implements IMeetingTypeGridDto {
    id?: number | undefined;
    code?: string | undefined;
    label?: string | undefined;
    colorCode?: string | undefined;

    constructor(data?: IMeetingTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.label = _data["label"];
            this.colorCode = _data["colorCode"];
        }
    }

    static fromJS(data: any): MeetingTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["label"] = this.label;
        data["colorCode"] = this.colorCode;
        return data;
    }

    clone(): MeetingTypeGridDto {
        const json = this.toJSON();
        let result = new MeetingTypeGridDto();
        result.init(json);
        return result;
    }
}

export interface IMeetingTypeGridDto {
    id?: number | undefined;
    code?: string | undefined;
    label?: string | undefined;
    colorCode?: string | undefined;
}

export class SearchQueryOfMeetingTypeSearchDto implements ISearchQueryOfMeetingTypeSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: MeetingTypeSearchDto | undefined;

    constructor(data?: ISearchQueryOfMeetingTypeSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? MeetingTypeSearchDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfMeetingTypeSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfMeetingTypeSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfMeetingTypeSearchDto {
        const json = this.toJSON();
        let result = new SearchQueryOfMeetingTypeSearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfMeetingTypeSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: MeetingTypeSearchDto | undefined;
}

export class MeetingTypeSearchDto extends PaginatedSearchable implements IMeetingTypeSearchDto {

    constructor(data?: IMeetingTypeSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MeetingTypeSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingTypeSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): MeetingTypeSearchDto {
        const json = this.toJSON();
        let result = new MeetingTypeSearchDto();
        result.init(json);
        return result;
    }
}

export interface IMeetingTypeSearchDto extends IPaginatedSearchable {
}

export class NewComerDto implements INewComerDto {
    id?: number;
    contact?: ContactDto | undefined;
    birthDate?: Date | undefined;
    nationalRegistrationNumber?: string | undefined;
    gender?: string | undefined;
    originCountry?: string | undefined;
    socialReportDoneOn?: Date | undefined;
    permitType?: string | undefined;
    permitDeliveredOn?: Date | undefined;
    generatedConventionDate?: Date | undefined;
    permitValidityInMonth?: number | undefined;
    newComerLanguages?: NewComerLanguageDto[] | undefined;
    newComerTrainingLanguages?: NewComerLanguageDto[] | undefined;
    apaInternalId?: number;

    constructor(data?: INewComerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contact = _data["contact"] ? ContactDto.fromJS(_data["contact"]) : <any>undefined;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.nationalRegistrationNumber = _data["nationalRegistrationNumber"];
            this.gender = _data["gender"];
            this.originCountry = _data["originCountry"];
            this.socialReportDoneOn = _data["socialReportDoneOn"] ? new Date(_data["socialReportDoneOn"].toString()) : <any>undefined;
            this.permitType = _data["permitType"];
            this.permitDeliveredOn = _data["permitDeliveredOn"] ? new Date(_data["permitDeliveredOn"].toString()) : <any>undefined;
            this.generatedConventionDate = _data["generatedConventionDate"] ? new Date(_data["generatedConventionDate"].toString()) : <any>undefined;
            this.permitValidityInMonth = _data["permitValidityInMonth"];
            if (Array.isArray(_data["newComerLanguages"])) {
                this.newComerLanguages = [] as any;
                for (let item of _data["newComerLanguages"])
                    this.newComerLanguages!.push(NewComerLanguageDto.fromJS(item));
            }
            if (Array.isArray(_data["newComerTrainingLanguages"])) {
                this.newComerTrainingLanguages = [] as any;
                for (let item of _data["newComerTrainingLanguages"])
                    this.newComerTrainingLanguages!.push(NewComerLanguageDto.fromJS(item));
            }
            this.apaInternalId = _data["apaInternalId"];
        }
    }

    static fromJS(data: any): NewComerDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewComerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["nationalRegistrationNumber"] = this.nationalRegistrationNumber;
        data["gender"] = this.gender;
        data["originCountry"] = this.originCountry;
        data["socialReportDoneOn"] = this.socialReportDoneOn ? this.socialReportDoneOn.toISOString() : <any>undefined;
        data["permitType"] = this.permitType;
        data["permitDeliveredOn"] = this.permitDeliveredOn ? this.permitDeliveredOn.toISOString() : <any>undefined;
        data["generatedConventionDate"] = this.generatedConventionDate ? this.generatedConventionDate.toISOString() : <any>undefined;
        data["permitValidityInMonth"] = this.permitValidityInMonth;
        if (Array.isArray(this.newComerLanguages)) {
            data["newComerLanguages"] = [];
            for (let item of this.newComerLanguages)
                data["newComerLanguages"].push(item.toJSON());
        }
        if (Array.isArray(this.newComerTrainingLanguages)) {
            data["newComerTrainingLanguages"] = [];
            for (let item of this.newComerTrainingLanguages)
                data["newComerTrainingLanguages"].push(item.toJSON());
        }
        data["apaInternalId"] = this.apaInternalId;
        return data;
    }

    clone(): NewComerDto {
        const json = this.toJSON();
        let result = new NewComerDto();
        result.init(json);
        return result;
    }
}

export interface INewComerDto {
    id?: number;
    contact?: ContactDto | undefined;
    birthDate?: Date | undefined;
    nationalRegistrationNumber?: string | undefined;
    gender?: string | undefined;
    originCountry?: string | undefined;
    socialReportDoneOn?: Date | undefined;
    permitType?: string | undefined;
    permitDeliveredOn?: Date | undefined;
    generatedConventionDate?: Date | undefined;
    permitValidityInMonth?: number | undefined;
    newComerLanguages?: NewComerLanguageDto[] | undefined;
    newComerTrainingLanguages?: NewComerLanguageDto[] | undefined;
    apaInternalId?: number;
}

export class NewComerStatusInfoDto implements INewComerStatusInfoDto {
    status?: string | undefined;
    sharepointUri?: string | undefined;
    accompagnyingPersonName?: string | undefined;
    accompagnyingPersonId?: number;
    creationDate?: Date | undefined;
    lastModified?: Date | undefined;
    accompagnyingPersonMail?: string | undefined;

    constructor(data?: INewComerStatusInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.sharepointUri = _data["sharepointUri"];
            this.accompagnyingPersonName = _data["accompagnyingPersonName"];
            this.accompagnyingPersonId = _data["accompagnyingPersonId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.accompagnyingPersonMail = _data["accompagnyingPersonMail"];
        }
    }

    static fromJS(data: any): NewComerStatusInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewComerStatusInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["sharepointUri"] = this.sharepointUri;
        data["accompagnyingPersonName"] = this.accompagnyingPersonName;
        data["accompagnyingPersonId"] = this.accompagnyingPersonId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["accompagnyingPersonMail"] = this.accompagnyingPersonMail;
        return data;
    }

    clone(): NewComerStatusInfoDto {
        const json = this.toJSON();
        let result = new NewComerStatusInfoDto();
        result.init(json);
        return result;
    }
}

export interface INewComerStatusInfoDto {
    status?: string | undefined;
    sharepointUri?: string | undefined;
    accompagnyingPersonName?: string | undefined;
    accompagnyingPersonId?: number;
    creationDate?: Date | undefined;
    lastModified?: Date | undefined;
    accompagnyingPersonMail?: string | undefined;
}

export class ApaTrainingGridDto implements IApaTrainingGridDto {
    id?: number;
    operatorLabel?: string | undefined;
    hourlyTypeLabel?: string | undefined;
    trainingTypeLabel?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    availabilityDate?: Date;

    constructor(data?: IApaTrainingGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operatorLabel = _data["operatorLabel"];
            this.hourlyTypeLabel = _data["hourlyTypeLabel"];
            this.trainingTypeLabel = _data["trainingTypeLabel"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.availabilityDate = _data["availabilityDate"] ? new Date(_data["availabilityDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ApaTrainingGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApaTrainingGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operatorLabel"] = this.operatorLabel;
        data["hourlyTypeLabel"] = this.hourlyTypeLabel;
        data["trainingTypeLabel"] = this.trainingTypeLabel;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["availabilityDate"] = this.availabilityDate ? this.availabilityDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): ApaTrainingGridDto {
        const json = this.toJSON();
        let result = new ApaTrainingGridDto();
        result.init(json);
        return result;
    }
}

export interface IApaTrainingGridDto {
    id?: number;
    operatorLabel?: string | undefined;
    hourlyTypeLabel?: string | undefined;
    trainingTypeLabel?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    availabilityDate?: Date;
}

export class PaginatedResultsOfNewComerGridDto implements IPaginatedResultsOfNewComerGridDto {
    totalCount?: number;
    results?: NewComerGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfNewComerGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(NewComerGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfNewComerGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfNewComerGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfNewComerGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfNewComerGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfNewComerGridDto {
    totalCount?: number;
    results?: NewComerGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class NewComerGridDto implements INewComerGridDto {
    id?: number;
    name?: string | undefined;
    firstName?: string | undefined;
    gender?: string | undefined;
    genderId?: number;
    originCountryId?: number;
    nationalRegistrationNumber?: string | undefined;
    originCountry?: string | undefined;
    accompagnyingPersonFullName?: string | undefined;
    gsm?: string | undefined;
    tel?: string | undefined;
    email?: string | undefined;
    statusDossier?: string | undefined;
    employeeId?: number | undefined;
    contactId?: number | undefined;
    haveTrainings?: boolean;

    constructor(data?: INewComerGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.gender = _data["gender"];
            this.genderId = _data["genderId"];
            this.originCountryId = _data["originCountryId"];
            this.nationalRegistrationNumber = _data["nationalRegistrationNumber"];
            this.originCountry = _data["originCountry"];
            this.accompagnyingPersonFullName = _data["accompagnyingPersonFullName"];
            this.gsm = _data["gsm"];
            this.tel = _data["tel"];
            this.email = _data["email"];
            this.statusDossier = _data["statusDossier"];
            this.employeeId = _data["employeeId"];
            this.contactId = _data["contactId"];
            this.haveTrainings = _data["haveTrainings"];
        }
    }

    static fromJS(data: any): NewComerGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewComerGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["gender"] = this.gender;
        data["genderId"] = this.genderId;
        data["originCountryId"] = this.originCountryId;
        data["nationalRegistrationNumber"] = this.nationalRegistrationNumber;
        data["originCountry"] = this.originCountry;
        data["accompagnyingPersonFullName"] = this.accompagnyingPersonFullName;
        data["gsm"] = this.gsm;
        data["tel"] = this.tel;
        data["email"] = this.email;
        data["statusDossier"] = this.statusDossier;
        data["employeeId"] = this.employeeId;
        data["contactId"] = this.contactId;
        data["haveTrainings"] = this.haveTrainings;
        return data;
    }

    clone(): NewComerGridDto {
        const json = this.toJSON();
        let result = new NewComerGridDto();
        result.init(json);
        return result;
    }
}

export interface INewComerGridDto {
    id?: number;
    name?: string | undefined;
    firstName?: string | undefined;
    gender?: string | undefined;
    genderId?: number;
    originCountryId?: number;
    nationalRegistrationNumber?: string | undefined;
    originCountry?: string | undefined;
    accompagnyingPersonFullName?: string | undefined;
    gsm?: string | undefined;
    tel?: string | undefined;
    email?: string | undefined;
    statusDossier?: string | undefined;
    employeeId?: number | undefined;
    contactId?: number | undefined;
    haveTrainings?: boolean;
}

export class SearchQueryOfNewComerSearch implements ISearchQueryOfNewComerSearch {
    expression?: AbstractSearchExpression | undefined;
    criteria?: NewComerSearch | undefined;

    constructor(data?: ISearchQueryOfNewComerSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? NewComerSearch.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfNewComerSearch {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfNewComerSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfNewComerSearch {
        const json = this.toJSON();
        let result = new SearchQueryOfNewComerSearch();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfNewComerSearch {
    expression?: AbstractSearchExpression | undefined;
    criteria?: NewComerSearch | undefined;
}

export class NewComerSearch extends PaginatedSearchable implements INewComerSearch {

    constructor(data?: INewComerSearch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): NewComerSearch {
        data = typeof data === 'object' ? data : {};
        let result = new NewComerSearch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): NewComerSearch {
        const json = this.toJSON();
        let result = new NewComerSearch();
        result.init(json);
        return result;
    }
}

export interface INewComerSearch extends IPaginatedSearchable {
}

export class FileDownloadDto implements IFileDownloadDto {
    fileName?: string | undefined;
    base64Content?: string | undefined;

    constructor(data?: IFileDownloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.base64Content = _data["base64Content"];
        }
    }

    static fromJS(data: any): FileDownloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["base64Content"] = this.base64Content;
        return data;
    }

    clone(): FileDownloadDto {
        const json = this.toJSON();
        let result = new FileDownloadDto();
        result.init(json);
        return result;
    }
}

export interface IFileDownloadDto {
    fileName?: string | undefined;
    base64Content?: string | undefined;
}

export class PaginatedResultsOfNewComerFileGridDto implements IPaginatedResultsOfNewComerFileGridDto {
    totalCount?: number;
    results?: NewComerFileGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfNewComerFileGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(NewComerFileGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfNewComerFileGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfNewComerFileGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfNewComerFileGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfNewComerFileGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfNewComerFileGridDto {
    totalCount?: number;
    results?: NewComerFileGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class NewComerFileGridDto implements INewComerFileGridDto {
    newComerFileId?: number;
    newComerId?: number;
    fileName?: string | undefined;

    constructor(data?: INewComerFileGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newComerFileId = _data["newComerFileId"];
            this.newComerId = _data["newComerId"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): NewComerFileGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewComerFileGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newComerFileId"] = this.newComerFileId;
        data["newComerId"] = this.newComerId;
        data["fileName"] = this.fileName;
        return data;
    }

    clone(): NewComerFileGridDto {
        const json = this.toJSON();
        let result = new NewComerFileGridDto();
        result.init(json);
        return result;
    }
}

export interface INewComerFileGridDto {
    newComerFileId?: number;
    newComerId?: number;
    fileName?: string | undefined;
}

export class SearchQueryOfNewComerFileSearchDto implements ISearchQueryOfNewComerFileSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: NewComerFileSearchDto | undefined;

    constructor(data?: ISearchQueryOfNewComerFileSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? NewComerFileSearchDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfNewComerFileSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfNewComerFileSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfNewComerFileSearchDto {
        const json = this.toJSON();
        let result = new SearchQueryOfNewComerFileSearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfNewComerFileSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: NewComerFileSearchDto | undefined;
}

export class NewComerFileSearchDto extends PaginatedSearchable implements INewComerFileSearchDto {
    newComerId?: number;

    constructor(data?: INewComerFileSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.newComerId = _data["newComerId"];
        }
    }

    static override fromJS(data: any): NewComerFileSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewComerFileSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newComerId"] = this.newComerId;
        super.toJSON(data);
        return data;
    }

    clone(): NewComerFileSearchDto {
        const json = this.toJSON();
        let result = new NewComerFileSearchDto();
        result.init(json);
        return result;
    }
}

export interface INewComerFileSearchDto extends IPaginatedSearchable {
    newComerId?: number;
}

export class OccupationDto implements IOccupationDto {
    id?: number;
    occupationType?: EOccupationType;
    start?: Date;
    end?: Date;
    color?: string | undefined;
    title?: string | undefined;

    constructor(data?: IOccupationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.occupationType = _data["occupationType"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.color = _data["color"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): OccupationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OccupationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["occupationType"] = this.occupationType;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["color"] = this.color;
        data["title"] = this.title;
        return data;
    }

    clone(): OccupationDto {
        const json = this.toJSON();
        let result = new OccupationDto();
        result.init(json);
        return result;
    }
}

export interface IOccupationDto {
    id?: number;
    occupationType?: EOccupationType;
    start?: Date;
    end?: Date;
    color?: string | undefined;
    title?: string | undefined;
}

export class EmployeeOccupationDto extends OccupationDto implements IEmployeeOccupationDto {
    employeeId?: number | undefined;
    roomId?: number | undefined;
    siteId?: number | undefined;
    language?: string | undefined;
    siteName?: string | undefined;
    roomName?: string | undefined;
    participants?: number;
    visioUri?: string | undefined;

    constructor(data?: IEmployeeOccupationDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.roomId = _data["roomId"];
            this.siteId = _data["siteId"];
            this.language = _data["language"];
            this.siteName = _data["siteName"];
            this.roomName = _data["roomName"];
            this.participants = _data["participants"];
            this.visioUri = _data["visioUri"];
        }
    }

    static override fromJS(data: any): EmployeeOccupationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeOccupationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["roomId"] = this.roomId;
        data["siteId"] = this.siteId;
        data["language"] = this.language;
        data["siteName"] = this.siteName;
        data["roomName"] = this.roomName;
        data["participants"] = this.participants;
        data["visioUri"] = this.visioUri;
        super.toJSON(data);
        return data;
    }

    clone(): EmployeeOccupationDto {
        const json = this.toJSON();
        let result = new EmployeeOccupationDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeOccupationDto extends IOccupationDto {
    employeeId?: number | undefined;
    roomId?: number | undefined;
    siteId?: number | undefined;
    language?: string | undefined;
    siteName?: string | undefined;
    roomName?: string | undefined;
    participants?: number;
    visioUri?: string | undefined;
}

export enum EOccupationType {
    EmployeeAbsence = "EmployeeAbsence",
    Session = "Session",
    Meeting = "Meeting",
}

export class EmployeeOccupationsFormDto implements IEmployeeOccupationsFormDto {
    employeeId?: number;
    emergency?: EValidationValues | undefined;
    withInterpreter?: EValidationValues | undefined;
    dateFrom?: Date;
    dateTo?: Date;

    constructor(data?: IEmployeeOccupationsFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.emergency = _data["emergency"];
            this.withInterpreter = _data["withInterpreter"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeOccupationsFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeOccupationsFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["emergency"] = this.emergency;
        data["withInterpreter"] = this.withInterpreter;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        return data;
    }

    clone(): EmployeeOccupationsFormDto {
        const json = this.toJSON();
        let result = new EmployeeOccupationsFormDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeOccupationsFormDto {
    employeeId?: number;
    emergency?: EValidationValues | undefined;
    withInterpreter?: EValidationValues | undefined;
    dateFrom?: Date;
    dateTo?: Date;
}

export enum EValidationValues {
    Everything = "Everything",
    Yes = "Yes",
    No = "No",
}

export class RoomOccupationDto extends OccupationDto implements IRoomOccupationDto {
    roomId?: number | undefined;

    constructor(data?: IRoomOccupationDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.roomId = _data["roomId"];
        }
    }

    static override fromJS(data: any): RoomOccupationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomOccupationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roomId"] = this.roomId;
        super.toJSON(data);
        return data;
    }

    clone(): RoomOccupationDto {
        const json = this.toJSON();
        let result = new RoomOccupationDto();
        result.init(json);
        return result;
    }
}

export interface IRoomOccupationDto extends IOccupationDto {
    roomId?: number | undefined;
}

export class RoomOccupationFormDataDto implements IRoomOccupationFormDataDto {
    roomId?: number;
    dateFrom?: Date;
    dateTo?: Date;

    constructor(data?: IRoomOccupationFormDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roomId = _data["roomId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoomOccupationFormDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomOccupationFormDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roomId"] = this.roomId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        return data;
    }

    clone(): RoomOccupationFormDataDto {
        const json = this.toJSON();
        let result = new RoomOccupationFormDataDto();
        result.init(json);
        return result;
    }
}

export interface IRoomOccupationFormDataDto {
    roomId?: number;
    dateFrom?: Date;
    dateTo?: Date;
}

export class EditPartnerDto extends LastUpdateViewerDto implements IEditPartnerDto {
    id?: number;
    partnerTypeId?: number;
    thematicTypeId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    description?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    remark?: string | undefined;
    websiteUri?: string | undefined;
    organization?: string | undefined;
    partnerAddresses?: EditPartnerAddressDto[] | undefined;
    partnerAddress?: EditPartnerAddressDto | undefined;

    constructor(data?: IEditPartnerDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.partnerTypeId = _data["partnerTypeId"];
            this.thematicTypeId = _data["thematicTypeId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.description = _data["description"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.remark = _data["remark"];
            this.websiteUri = _data["websiteUri"];
            this.organization = _data["organization"];
            if (Array.isArray(_data["partnerAddresses"])) {
                this.partnerAddresses = [] as any;
                for (let item of _data["partnerAddresses"])
                    this.partnerAddresses!.push(EditPartnerAddressDto.fromJS(item));
            }
            this.partnerAddress = _data["partnerAddress"] ? EditPartnerAddressDto.fromJS(_data["partnerAddress"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): EditPartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditPartnerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partnerTypeId"] = this.partnerTypeId;
        data["thematicTypeId"] = this.thematicTypeId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["description"] = this.description;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["remark"] = this.remark;
        data["websiteUri"] = this.websiteUri;
        data["organization"] = this.organization;
        if (Array.isArray(this.partnerAddresses)) {
            data["partnerAddresses"] = [];
            for (let item of this.partnerAddresses)
                data["partnerAddresses"].push(item.toJSON());
        }
        data["partnerAddress"] = this.partnerAddress ? this.partnerAddress.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): EditPartnerDto {
        const json = this.toJSON();
        let result = new EditPartnerDto();
        result.init(json);
        return result;
    }
}

export interface IEditPartnerDto extends ILastUpdateViewerDto {
    id?: number;
    partnerTypeId?: number;
    thematicTypeId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    description?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    remark?: string | undefined;
    websiteUri?: string | undefined;
    organization?: string | undefined;
    partnerAddresses?: EditPartnerAddressDto[] | undefined;
    partnerAddress?: EditPartnerAddressDto | undefined;
}

export class EditPartnerAddressDto implements IEditPartnerAddressDto {
    id?: number;
    addressType?: EAddressTypes;
    partnerAddressId?: number;
    address?: EditAddressDto | undefined;

    constructor(data?: IEditPartnerAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.addressType = _data["addressType"];
            this.partnerAddressId = _data["partnerAddressId"];
            this.address = _data["address"] ? EditAddressDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditPartnerAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditPartnerAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["addressType"] = this.addressType;
        data["partnerAddressId"] = this.partnerAddressId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }

    clone(): EditPartnerAddressDto {
        const json = this.toJSON();
        let result = new EditPartnerAddressDto();
        result.init(json);
        return result;
    }
}

export interface IEditPartnerAddressDto {
    id?: number;
    addressType?: EAddressTypes;
    partnerAddressId?: number;
    address?: EditAddressDto | undefined;
}

export class PaginatedResultsOfPartnerGridDto implements IPaginatedResultsOfPartnerGridDto {
    totalCount?: number;
    results?: PartnerGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfPartnerGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PartnerGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfPartnerGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfPartnerGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfPartnerGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfPartnerGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfPartnerGridDto {
    totalCount?: number;
    results?: PartnerGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class PartnerGridDto implements IPartnerGridDto {
    id?: number;
    lastName?: string | undefined;
    firstName?: string | undefined;
    partnerTypeName?: string | undefined;
    thematicTypeName?: string | undefined;
    organization?: string | undefined;

    constructor(data?: IPartnerGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.partnerTypeName = _data["partnerTypeName"];
            this.thematicTypeName = _data["thematicTypeName"];
            this.organization = _data["organization"];
        }
    }

    static fromJS(data: any): PartnerGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["partnerTypeName"] = this.partnerTypeName;
        data["thematicTypeName"] = this.thematicTypeName;
        data["organization"] = this.organization;
        return data;
    }

    clone(): PartnerGridDto {
        const json = this.toJSON();
        let result = new PartnerGridDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerGridDto {
    id?: number;
    lastName?: string | undefined;
    firstName?: string | undefined;
    partnerTypeName?: string | undefined;
    thematicTypeName?: string | undefined;
    organization?: string | undefined;
}

export class SearchQueryOfPartnerSearchDto implements ISearchQueryOfPartnerSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: PartnerSearchDto | undefined;

    constructor(data?: ISearchQueryOfPartnerSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? PartnerSearchDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfPartnerSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfPartnerSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfPartnerSearchDto {
        const json = this.toJSON();
        let result = new SearchQueryOfPartnerSearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfPartnerSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: PartnerSearchDto | undefined;
}

export class PartnerSearchDto extends PaginatedSearchable implements IPartnerSearchDto {

    constructor(data?: IPartnerSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PartnerSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): PartnerSearchDto {
        const json = this.toJSON();
        let result = new PartnerSearchDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerSearchDto extends IPaginatedSearchable {
}

export class EditPartnerTypeDto extends LastUpdateViewerDto implements IEditPartnerTypeDto {
    id?: number;
    dataTranslation?: DataTranslationDto | undefined;

    constructor(data?: IEditPartnerTypeDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): EditPartnerTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditPartnerTypeDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): EditPartnerTypeDto {
        const json = this.toJSON();
        let result = new EditPartnerTypeDto();
        result.init(json);
        return result;
    }
}

export interface IEditPartnerTypeDto extends ILastUpdateViewerDto {
    id?: number;
    dataTranslation?: DataTranslationDto | undefined;
}

export class PaginatedResultsOfPartnerTypeGridDto implements IPaginatedResultsOfPartnerTypeGridDto {
    totalCount?: number;
    results?: PartnerTypeGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfPartnerTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PartnerTypeGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfPartnerTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfPartnerTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfPartnerTypeGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfPartnerTypeGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfPartnerTypeGridDto {
    totalCount?: number;
    results?: PartnerTypeGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class PartnerTypeGridDto implements IPartnerTypeGridDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IPartnerTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PartnerTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): PartnerTypeGridDto {
        const json = this.toJSON();
        let result = new PartnerTypeGridDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerTypeGridDto {
    id?: number;
    name?: string | undefined;
}

export class SearchQueryOfPartnerTypeSearchDto implements ISearchQueryOfPartnerTypeSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: PartnerTypeSearchDto | undefined;

    constructor(data?: ISearchQueryOfPartnerTypeSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? PartnerTypeSearchDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfPartnerTypeSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfPartnerTypeSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfPartnerTypeSearchDto {
        const json = this.toJSON();
        let result = new SearchQueryOfPartnerTypeSearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfPartnerTypeSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: PartnerTypeSearchDto | undefined;
}

export class PartnerTypeSearchDto extends PaginatedSearchable implements IPartnerTypeSearchDto {

    constructor(data?: IPartnerTypeSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PartnerTypeSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerTypeSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): PartnerTypeSearchDto {
        const json = this.toJSON();
        let result = new PartnerTypeSearchDto();
        result.init(json);
        return result;
    }
}

export interface IPartnerTypeSearchDto extends IPaginatedSearchable {
}

export class CountryReferentialDto extends SelectItem implements ICountryReferentialDto {
    code?: string | undefined;

    constructor(data?: ICountryReferentialDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
        }
    }

    static override fromJS(data: any): CountryReferentialDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryReferentialDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        super.toJSON(data);
        return data;
    }

    clone(): CountryReferentialDto {
        const json = this.toJSON();
        let result = new CountryReferentialDto();
        result.init(json);
        return result;
    }
}

export interface ICountryReferentialDto extends ISelectItem {
    code?: string | undefined;
}

export class SiteReferentialDto extends SelectItem implements ISiteReferentialDto {
    address?: EditAddressDto | undefined;

    constructor(data?: ISiteReferentialDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.address = _data["address"] ? EditAddressDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): SiteReferentialDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiteReferentialDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): SiteReferentialDto {
        const json = this.toJSON();
        let result = new SiteReferentialDto();
        result.init(json);
        return result;
    }
}

export interface ISiteReferentialDto extends ISelectItem {
    address?: EditAddressDto | undefined;
}

export class OperatorTypeReferentialItemDto extends ReferentialItemDto implements IOperatorTypeReferentialItemDto {
    isInternal?: boolean;

    constructor(data?: IOperatorTypeReferentialItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isInternal = _data["isInternal"];
        }
    }

    static override fromJS(data: any): OperatorTypeReferentialItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorTypeReferentialItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isInternal"] = this.isInternal;
        super.toJSON(data);
        return data;
    }

    clone(): OperatorTypeReferentialItemDto {
        const json = this.toJSON();
        let result = new OperatorTypeReferentialItemDto();
        result.init(json);
        return result;
    }
}

export interface IOperatorTypeReferentialItemDto extends IReferentialItemDto {
    isInternal?: boolean;
}

export enum ETrainingTypes {
    RightAndDuty = "RightAndDuty",
    Citizenship = "Citizenship",
}

export class PlaningTypeReferentialItemDto extends SelectItem implements IPlaningTypeReferentialItemDto {
    code?: EPlanningTypes;

    constructor(data?: IPlaningTypeReferentialItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
        }
    }

    static override fromJS(data: any): PlaningTypeReferentialItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaningTypeReferentialItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        super.toJSON(data);
        return data;
    }

    clone(): PlaningTypeReferentialItemDto {
        const json = this.toJSON();
        let result = new PlaningTypeReferentialItemDto();
        result.init(json);
        return result;
    }
}

export interface IPlaningTypeReferentialItemDto extends ISelectItem {
    code?: EPlanningTypes;
}

export enum EPlanningTypes {
    RequiresHours = "RequiresHours",
    RequiresNumberOfSessions = "RequiresNumberOfSessions",
}

export class RegistrationDto implements IRegistrationDto {
    id?: number;
    fullName?: string | undefined;
    trainingLanguages?: string[] | undefined;
    phoneNumbers?: string[] | undefined;
    emails?: string[] | undefined;

    constructor(data?: IRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            if (Array.isArray(_data["trainingLanguages"])) {
                this.trainingLanguages = [] as any;
                for (let item of _data["trainingLanguages"])
                    this.trainingLanguages!.push(item);
            }
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(item);
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any): RegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        if (Array.isArray(this.trainingLanguages)) {
            data["trainingLanguages"] = [];
            for (let item of this.trainingLanguages)
                data["trainingLanguages"].push(item);
        }
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }

    clone(): RegistrationDto {
        const json = this.toJSON();
        let result = new RegistrationDto();
        result.init(json);
        return result;
    }
}

export interface IRegistrationDto {
    id?: number;
    fullName?: string | undefined;
    trainingLanguages?: string[] | undefined;
    phoneNumbers?: string[] | undefined;
    emails?: string[] | undefined;
}

export class RegistrationNumbersDto implements IRegistrationNumbersDto {
    registrationNumber?: number;
    totalRegistration?: number;

    constructor(data?: IRegistrationNumbersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationNumber = _data["registrationNumber"];
            this.totalRegistration = _data["totalRegistration"];
        }
    }

    static fromJS(data: any): RegistrationNumbersDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationNumbersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationNumber"] = this.registrationNumber;
        data["totalRegistration"] = this.totalRegistration;
        return data;
    }

    clone(): RegistrationNumbersDto {
        const json = this.toJSON();
        let result = new RegistrationNumbersDto();
        result.init(json);
        return result;
    }
}

export interface IRegistrationNumbersDto {
    registrationNumber?: number;
    totalRegistration?: number;
}

export class NewComersToRegisterDto implements INewComersToRegisterDto {
    trainingId?: number;
    newComerIds?: number[] | undefined;

    constructor(data?: INewComersToRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingId = _data["trainingId"];
            if (Array.isArray(_data["newComerIds"])) {
                this.newComerIds = [] as any;
                for (let item of _data["newComerIds"])
                    this.newComerIds!.push(item);
            }
        }
    }

    static fromJS(data: any): NewComersToRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewComersToRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingId"] = this.trainingId;
        if (Array.isArray(this.newComerIds)) {
            data["newComerIds"] = [];
            for (let item of this.newComerIds)
                data["newComerIds"].push(item);
        }
        return data;
    }

    clone(): NewComersToRegisterDto {
        const json = this.toJSON();
        let result = new NewComersToRegisterDto();
        result.init(json);
        return result;
    }
}

export interface INewComersToRegisterDto {
    trainingId?: number;
    newComerIds?: number[] | undefined;
}

export class EditReminderPhoneCallDto implements IEditReminderPhoneCallDto {
    employeeId?: number | undefined;
    reminders?: ReminderPhoneCallDto[] | undefined;

    constructor(data?: IEditReminderPhoneCallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            if (Array.isArray(_data["reminders"])) {
                this.reminders = [] as any;
                for (let item of _data["reminders"])
                    this.reminders!.push(ReminderPhoneCallDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditReminderPhoneCallDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditReminderPhoneCallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        if (Array.isArray(this.reminders)) {
            data["reminders"] = [];
            for (let item of this.reminders)
                data["reminders"].push(item.toJSON());
        }
        return data;
    }

    clone(): EditReminderPhoneCallDto {
        const json = this.toJSON();
        let result = new EditReminderPhoneCallDto();
        result.init(json);
        return result;
    }
}

export interface IEditReminderPhoneCallDto {
    employeeId?: number | undefined;
    reminders?: ReminderPhoneCallDto[] | undefined;
}

export class ReminderPhoneCallDto implements IReminderPhoneCallDto {
    id?: number;
    sessionAttendeeId?: number;
    reminderPhoneCallResultId?: number;

    constructor(data?: IReminderPhoneCallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sessionAttendeeId = _data["sessionAttendeeId"];
            this.reminderPhoneCallResultId = _data["reminderPhoneCallResultId"];
        }
    }

    static fromJS(data: any): ReminderPhoneCallDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderPhoneCallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sessionAttendeeId"] = this.sessionAttendeeId;
        data["reminderPhoneCallResultId"] = this.reminderPhoneCallResultId;
        return data;
    }

    clone(): ReminderPhoneCallDto {
        const json = this.toJSON();
        let result = new ReminderPhoneCallDto();
        result.init(json);
        return result;
    }
}

export interface IReminderPhoneCallDto {
    id?: number;
    sessionAttendeeId?: number;
    reminderPhoneCallResultId?: number;
}

export class BaseReportDto implements IBaseReportDto {
    metadata?: ReportMetadata;

    constructor(data?: IBaseReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadata = _data["metadata"] ? ReportMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }

    clone(): BaseReportDto {
        const json = this.toJSON();
        let result = new BaseReportDto();
        result.init(json);
        return result;
    }
}

export interface IBaseReportDto {
    metadata?: ReportMetadata;
}

export class TestReportDto extends BaseReportDto implements ITestReportDto {

    constructor(data?: ITestReportDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TestReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestReportDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TestReportDto {
        const json = this.toJSON();
        let result = new TestReportDto();
        result.init(json);
        return result;
    }
}

export interface ITestReportDto extends IBaseReportDto {
}

export class ReportMetadata implements IReportMetadata {
    userName?: string | undefined;
    creationDate?: Date | undefined;
    author?: string | undefined;
    customProperties?: { [key: string]: string; } | undefined;

    constructor(data?: IReportMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.author = _data["author"];
            if (_data["customProperties"]) {
                this.customProperties = {} as any;
                for (let key in _data["customProperties"]) {
                    if (_data["customProperties"].hasOwnProperty(key))
                        (<any>this.customProperties)![key] = _data["customProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): ReportMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ReportMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["author"] = this.author;
        if (this.customProperties) {
            data["customProperties"] = {};
            for (let key in this.customProperties) {
                if (this.customProperties.hasOwnProperty(key))
                    (<any>data["customProperties"])[key] = (<any>this.customProperties)[key];
            }
        }
        return data;
    }

    clone(): ReportMetadata {
        const json = this.toJSON();
        let result = new ReportMetadata();
        result.init(json);
        return result;
    }
}

export interface IReportMetadata {
    userName?: string | undefined;
    creationDate?: Date | undefined;
    author?: string | undefined;
    customProperties?: { [key: string]: string; } | undefined;
}

export class EditRoomDto extends LastUpdateViewerDto implements IEditRoomDto {
    id?: number;
    name?: string | undefined;
    capacity?: number;
    colorHexaCode?: string | undefined;
    hasWindows?: boolean;
    hasVideoProjector?: boolean;
    isMergeable?: boolean;
    associatedRoomId?: number | undefined;
    siteId?: number;

    constructor(data?: IEditRoomDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.capacity = _data["capacity"];
            this.colorHexaCode = _data["colorHexaCode"];
            this.hasWindows = _data["hasWindows"];
            this.hasVideoProjector = _data["hasVideoProjector"];
            this.isMergeable = _data["isMergeable"];
            this.associatedRoomId = _data["associatedRoomId"];
            this.siteId = _data["siteId"];
        }
    }

    static override fromJS(data: any): EditRoomDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditRoomDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["capacity"] = this.capacity;
        data["colorHexaCode"] = this.colorHexaCode;
        data["hasWindows"] = this.hasWindows;
        data["hasVideoProjector"] = this.hasVideoProjector;
        data["isMergeable"] = this.isMergeable;
        data["associatedRoomId"] = this.associatedRoomId;
        data["siteId"] = this.siteId;
        super.toJSON(data);
        return data;
    }

    clone(): EditRoomDto {
        const json = this.toJSON();
        let result = new EditRoomDto();
        result.init(json);
        return result;
    }
}

export interface IEditRoomDto extends ILastUpdateViewerDto {
    id?: number;
    name?: string | undefined;
    capacity?: number;
    colorHexaCode?: string | undefined;
    hasWindows?: boolean;
    hasVideoProjector?: boolean;
    isMergeable?: boolean;
    associatedRoomId?: number | undefined;
    siteId?: number;
}

export class PaginatedResultsOfRoomGridDto implements IPaginatedResultsOfRoomGridDto {
    totalCount?: number;
    results?: RoomGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfRoomGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(RoomGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfRoomGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfRoomGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfRoomGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfRoomGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfRoomGridDto {
    totalCount?: number;
    results?: RoomGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class RoomGridDto implements IRoomGridDto {
    id?: number;
    name?: string | undefined;
    associatedRoomName?: string | undefined;
    siteName?: string | undefined;
    colorHexaCode?: string | undefined;
    capacity?: number;

    constructor(data?: IRoomGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.associatedRoomName = _data["associatedRoomName"];
            this.siteName = _data["siteName"];
            this.colorHexaCode = _data["colorHexaCode"];
            this.capacity = _data["capacity"];
        }
    }

    static fromJS(data: any): RoomGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["associatedRoomName"] = this.associatedRoomName;
        data["siteName"] = this.siteName;
        data["colorHexaCode"] = this.colorHexaCode;
        data["capacity"] = this.capacity;
        return data;
    }

    clone(): RoomGridDto {
        const json = this.toJSON();
        let result = new RoomGridDto();
        result.init(json);
        return result;
    }
}

export interface IRoomGridDto {
    id?: number;
    name?: string | undefined;
    associatedRoomName?: string | undefined;
    siteName?: string | undefined;
    colorHexaCode?: string | undefined;
    capacity?: number;
}

export class SearchQueryOfRoomSearchDto implements ISearchQueryOfRoomSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: RoomSearchDto | undefined;

    constructor(data?: ISearchQueryOfRoomSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? RoomSearchDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfRoomSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfRoomSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfRoomSearchDto {
        const json = this.toJSON();
        let result = new SearchQueryOfRoomSearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfRoomSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: RoomSearchDto | undefined;
}

export class RoomSearchDto extends PaginatedSearchable implements IRoomSearchDto {

    constructor(data?: IRoomSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): RoomSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): RoomSearchDto {
        const json = this.toJSON();
        let result = new RoomSearchDto();
        result.init(json);
        return result;
    }
}

export interface IRoomSearchDto extends IPaginatedSearchable {
}

export class EditSessionDto implements IEditSessionDto {
    siteId?: number;
    siteName?: string | undefined;
    trainingId?: number;
    employeeId?: number;
    employeeName?: string | undefined;
    visioUri?: string | undefined;
    description?: string | undefined;
    roomId?: number | undefined;
    roomName?: string | undefined;
    visio?: boolean;
    occursOn?: Date;
    duration?: number;
    employeeInRoomNextHour?: boolean;
    employeeInRoomPreviousHour?: boolean;
    lapsFormation?: boolean;

    constructor(data?: IEditSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.trainingId = _data["trainingId"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.visioUri = _data["visioUri"];
            this.description = _data["description"];
            this.roomId = _data["roomId"];
            this.roomName = _data["roomName"];
            this.visio = _data["visio"];
            this.occursOn = _data["occursOn"] ? new Date(_data["occursOn"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.employeeInRoomNextHour = _data["employeeInRoomNextHour"];
            this.employeeInRoomPreviousHour = _data["employeeInRoomPreviousHour"];
            this.lapsFormation = _data["lapsFormation"];
        }
    }

    static fromJS(data: any): EditSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["trainingId"] = this.trainingId;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["visioUri"] = this.visioUri;
        data["description"] = this.description;
        data["roomId"] = this.roomId;
        data["roomName"] = this.roomName;
        data["visio"] = this.visio;
        data["occursOn"] = this.occursOn ? this.occursOn.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["employeeInRoomNextHour"] = this.employeeInRoomNextHour;
        data["employeeInRoomPreviousHour"] = this.employeeInRoomPreviousHour;
        data["lapsFormation"] = this.lapsFormation;
        return data;
    }

    clone(): EditSessionDto {
        const json = this.toJSON();
        let result = new EditSessionDto();
        result.init(json);
        return result;
    }
}

export interface IEditSessionDto {
    siteId?: number;
    siteName?: string | undefined;
    trainingId?: number;
    employeeId?: number;
    employeeName?: string | undefined;
    visioUri?: string | undefined;
    description?: string | undefined;
    roomId?: number | undefined;
    roomName?: string | undefined;
    visio?: boolean;
    occursOn?: Date;
    duration?: number;
    employeeInRoomNextHour?: boolean;
    employeeInRoomPreviousHour?: boolean;
    lapsFormation?: boolean;
}

export class PaginatedResultsOfSessionGridDto implements IPaginatedResultsOfSessionGridDto {
    totalCount?: number;
    results?: SessionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfSessionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SessionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfSessionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfSessionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfSessionGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfSessionGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfSessionGridDto {
    totalCount?: number;
    results?: SessionGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class SessionGridDto implements ISessionGridDto {
    employeeId?: number;
    trainingId?: number;
    employeeName?: string | undefined;
    siteId?: number;
    siteName?: string | undefined;
    roomId?: number;
    roomName?: string | undefined;
    occursOn?: Date;
    duration?: number;
    visioUri?: string | undefined;
    id?: number;

    constructor(data?: ISessionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.trainingId = _data["trainingId"];
            this.employeeName = _data["employeeName"];
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.roomId = _data["roomId"];
            this.roomName = _data["roomName"];
            this.occursOn = _data["occursOn"] ? new Date(_data["occursOn"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.visioUri = _data["visioUri"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SessionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["trainingId"] = this.trainingId;
        data["employeeName"] = this.employeeName;
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["roomId"] = this.roomId;
        data["roomName"] = this.roomName;
        data["occursOn"] = this.occursOn ? this.occursOn.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["visioUri"] = this.visioUri;
        data["id"] = this.id;
        return data;
    }

    clone(): SessionGridDto {
        const json = this.toJSON();
        let result = new SessionGridDto();
        result.init(json);
        return result;
    }
}

export interface ISessionGridDto {
    employeeId?: number;
    trainingId?: number;
    employeeName?: string | undefined;
    siteId?: number;
    siteName?: string | undefined;
    roomId?: number;
    roomName?: string | undefined;
    occursOn?: Date;
    duration?: number;
    visioUri?: string | undefined;
    id?: number;
}

export class SearchQueryOfSessionSearch implements ISearchQueryOfSessionSearch {
    expression?: AbstractSearchExpression | undefined;
    criteria?: SessionSearch | undefined;

    constructor(data?: ISearchQueryOfSessionSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? SessionSearch.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfSessionSearch {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfSessionSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfSessionSearch {
        const json = this.toJSON();
        let result = new SearchQueryOfSessionSearch();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfSessionSearch {
    expression?: AbstractSearchExpression | undefined;
    criteria?: SessionSearch | undefined;
}

export class SessionSearch extends PaginatedSearchable implements ISessionSearch {
    trainingId?: number;

    constructor(data?: ISessionSearch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trainingId = _data["trainingId"];
        }
    }

    static override fromJS(data: any): SessionSearch {
        data = typeof data === 'object' ? data : {};
        let result = new SessionSearch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingId"] = this.trainingId;
        super.toJSON(data);
        return data;
    }

    clone(): SessionSearch {
        const json = this.toJSON();
        let result = new SessionSearch();
        result.init(json);
        return result;
    }
}

export interface ISessionSearch extends IPaginatedSearchable {
    trainingId?: number;
}

export class PaginatedResultsOfSiteGridDto implements IPaginatedResultsOfSiteGridDto {
    totalCount?: number;
    results?: SiteGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfSiteGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SiteGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfSiteGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfSiteGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfSiteGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfSiteGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfSiteGridDto {
    totalCount?: number;
    results?: SiteGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class SiteGridDto implements ISiteGridDto {
    id?: number;
    name?: string | undefined;
    welcomeOffice?: string | undefined;

    constructor(data?: ISiteGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.welcomeOffice = _data["welcomeOffice"];
        }
    }

    static fromJS(data: any): SiteGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiteGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["welcomeOffice"] = this.welcomeOffice;
        return data;
    }

    clone(): SiteGridDto {
        const json = this.toJSON();
        let result = new SiteGridDto();
        result.init(json);
        return result;
    }
}

export interface ISiteGridDto {
    id?: number;
    name?: string | undefined;
    welcomeOffice?: string | undefined;
}

export class EditSiteDto extends LastUpdateViewerDto implements IEditSiteDto {
    id?: number;
    name?: string | undefined;
    welcomeOffice?: string | undefined;

    constructor(data?: IEditSiteDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.welcomeOffice = _data["welcomeOffice"];
        }
    }

    static override fromJS(data: any): EditSiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditSiteDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["welcomeOffice"] = this.welcomeOffice;
        super.toJSON(data);
        return data;
    }

    clone(): EditSiteDto {
        const json = this.toJSON();
        let result = new EditSiteDto();
        result.init(json);
        return result;
    }
}

export interface IEditSiteDto extends ILastUpdateViewerDto {
    id?: number;
    name?: string | undefined;
    welcomeOffice?: string | undefined;
}

export class EditSmsTemplateDto extends LastUpdateViewerDto implements IEditSmsTemplateDto {
    id?: number;
    code?: ESmsTemplate;
    descriptionTranslation?: DataTranslationDto | undefined;
    smsContents?: SmsContentGridDto[] | undefined;
    frenchContent?: SmsContentGridDto | undefined;

    constructor(data?: IEditSmsTemplateDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.descriptionTranslation = _data["descriptionTranslation"] ? DataTranslationDto.fromJS(_data["descriptionTranslation"]) : <any>undefined;
            if (Array.isArray(_data["smsContents"])) {
                this.smsContents = [] as any;
                for (let item of _data["smsContents"])
                    this.smsContents!.push(SmsContentGridDto.fromJS(item));
            }
            this.frenchContent = _data["frenchContent"] ? SmsContentGridDto.fromJS(_data["frenchContent"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): EditSmsTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditSmsTemplateDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["descriptionTranslation"] = this.descriptionTranslation ? this.descriptionTranslation.toJSON() : <any>undefined;
        if (Array.isArray(this.smsContents)) {
            data["smsContents"] = [];
            for (let item of this.smsContents)
                data["smsContents"].push(item.toJSON());
        }
        data["frenchContent"] = this.frenchContent ? this.frenchContent.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): EditSmsTemplateDto {
        const json = this.toJSON();
        let result = new EditSmsTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IEditSmsTemplateDto extends ILastUpdateViewerDto {
    id?: number;
    code?: ESmsTemplate;
    descriptionTranslation?: DataTranslationDto | undefined;
    smsContents?: SmsContentGridDto[] | undefined;
    frenchContent?: SmsContentGridDto | undefined;
}

export enum ESmsTemplate {
    TrainingReminder = "TrainingReminder",
    InterviewReminder = "InterviewReminder",
}

export class SmsContentGridDto implements ISmsContentGridDto {
    smsTemplateId?: number;
    apaLanguageId?: number;
    smsBody?: string | undefined;
    apaLanguageLabel?: string | undefined;
    hasContent?: boolean;

    constructor(data?: ISmsContentGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smsTemplateId = _data["smsTemplateId"];
            this.apaLanguageId = _data["apaLanguageId"];
            this.smsBody = _data["smsBody"];
            this.apaLanguageLabel = _data["apaLanguageLabel"];
            this.hasContent = _data["hasContent"];
        }
    }

    static fromJS(data: any): SmsContentGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmsContentGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsTemplateId"] = this.smsTemplateId;
        data["apaLanguageId"] = this.apaLanguageId;
        data["smsBody"] = this.smsBody;
        data["apaLanguageLabel"] = this.apaLanguageLabel;
        data["hasContent"] = this.hasContent;
        return data;
    }

    clone(): SmsContentGridDto {
        const json = this.toJSON();
        let result = new SmsContentGridDto();
        result.init(json);
        return result;
    }
}

export interface ISmsContentGridDto {
    smsTemplateId?: number;
    apaLanguageId?: number;
    smsBody?: string | undefined;
    apaLanguageLabel?: string | undefined;
    hasContent?: boolean;
}

export class EditSmsContentDto extends LastUpdateViewerDto implements IEditSmsContentDto {
    smsTemplateId?: number;
    apaLanguageId?: number;
    apaLanguageLabel?: string | undefined;
    smsBody?: string | undefined;

    constructor(data?: IEditSmsContentDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.smsTemplateId = _data["smsTemplateId"];
            this.apaLanguageId = _data["apaLanguageId"];
            this.apaLanguageLabel = _data["apaLanguageLabel"];
            this.smsBody = _data["smsBody"];
        }
    }

    static override fromJS(data: any): EditSmsContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditSmsContentDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsTemplateId"] = this.smsTemplateId;
        data["apaLanguageId"] = this.apaLanguageId;
        data["apaLanguageLabel"] = this.apaLanguageLabel;
        data["smsBody"] = this.smsBody;
        super.toJSON(data);
        return data;
    }

    clone(): EditSmsContentDto {
        const json = this.toJSON();
        let result = new EditSmsContentDto();
        result.init(json);
        return result;
    }
}

export interface IEditSmsContentDto extends ILastUpdateViewerDto {
    smsTemplateId?: number;
    apaLanguageId?: number;
    apaLanguageLabel?: string | undefined;
    smsBody?: string | undefined;
}

export class PaginatedResultsOfSmsTemplateGridDto implements IPaginatedResultsOfSmsTemplateGridDto {
    totalCount?: number;
    results?: SmsTemplateGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfSmsTemplateGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SmsTemplateGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfSmsTemplateGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfSmsTemplateGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfSmsTemplateGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfSmsTemplateGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfSmsTemplateGridDto {
    totalCount?: number;
    results?: SmsTemplateGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class SmsTemplateGridDto implements ISmsTemplateGridDto {
    id?: number;
    code?: ESmsTemplate;
    description?: string | undefined;
    isTranslated?: boolean;

    constructor(data?: ISmsTemplateGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.isTranslated = _data["isTranslated"];
        }
    }

    static fromJS(data: any): SmsTemplateGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmsTemplateGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["isTranslated"] = this.isTranslated;
        return data;
    }

    clone(): SmsTemplateGridDto {
        const json = this.toJSON();
        let result = new SmsTemplateGridDto();
        result.init(json);
        return result;
    }
}

export interface ISmsTemplateGridDto {
    id?: number;
    code?: ESmsTemplate;
    description?: string | undefined;
    isTranslated?: boolean;
}

export class SearchQueryOfSmsTemplateSearch implements ISearchQueryOfSmsTemplateSearch {
    expression?: AbstractSearchExpression | undefined;
    criteria?: SmsTemplateSearch | undefined;

    constructor(data?: ISearchQueryOfSmsTemplateSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? SmsTemplateSearch.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfSmsTemplateSearch {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfSmsTemplateSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfSmsTemplateSearch {
        const json = this.toJSON();
        let result = new SearchQueryOfSmsTemplateSearch();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfSmsTemplateSearch {
    expression?: AbstractSearchExpression | undefined;
    criteria?: SmsTemplateSearch | undefined;
}

export class SmsTemplateSearch extends PaginatedSearchable implements ISmsTemplateSearch {

    constructor(data?: ISmsTemplateSearch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SmsTemplateSearch {
        data = typeof data === 'object' ? data : {};
        let result = new SmsTemplateSearch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): SmsTemplateSearch {
        const json = this.toJSON();
        let result = new SmsTemplateSearch();
        result.init(json);
        return result;
    }
}

export interface ISmsTemplateSearch extends IPaginatedSearchable {
}

export class SystemInfoDto implements ISystemInfoDto {
    applicationName?: string | undefined;
    applicationVersion?: string | undefined;
    environment?: string | undefined;
    database?: string | undefined;

    constructor(data?: ISystemInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.applicationVersion = _data["applicationVersion"];
            this.environment = _data["environment"];
            this.database = _data["database"];
        }
    }

    static fromJS(data: any): SystemInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["applicationVersion"] = this.applicationVersion;
        data["environment"] = this.environment;
        data["database"] = this.database;
        return data;
    }

    clone(): SystemInfoDto {
        const json = this.toJSON();
        let result = new SystemInfoDto();
        result.init(json);
        return result;
    }
}

export interface ISystemInfoDto {
    applicationName?: string | undefined;
    applicationVersion?: string | undefined;
    environment?: string | undefined;
    database?: string | undefined;
}

export class ExposedTypes implements IExposedTypes {
    actionCode?: ActionCode;
    errorDetails?: ErrorDetails | undefined;
    errorResult?: ResultError | undefined;

    constructor(data?: IExposedTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionCode = _data["actionCode"];
            this.errorDetails = _data["errorDetails"] ? ErrorDetails.fromJS(_data["errorDetails"]) : <any>undefined;
            this.errorResult = _data["errorResult"] ? ResultError.fromJS(_data["errorResult"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExposedTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ExposedTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionCode"] = this.actionCode;
        data["errorDetails"] = this.errorDetails ? this.errorDetails.toJSON() : <any>undefined;
        data["errorResult"] = this.errorResult ? this.errorResult.toJSON() : <any>undefined;
        return data;
    }

    clone(): ExposedTypes {
        const json = this.toJSON();
        let result = new ExposedTypes();
        result.init(json);
        return result;
    }
}

export interface IExposedTypes {
    actionCode?: ActionCode;
    errorDetails?: ErrorDetails | undefined;
    errorResult?: ResultError | undefined;
}

export class ErrorDetails implements IErrorDetails {
    statusCode?: number;
    message?: string | undefined;
    stackTrace?: string | undefined;
    exceptionType?: string | undefined;
    errorCode?: string | undefined;

    constructor(data?: IErrorDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.stackTrace = _data["stackTrace"];
            this.exceptionType = _data["exceptionType"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): ErrorDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["stackTrace"] = this.stackTrace;
        data["exceptionType"] = this.exceptionType;
        data["errorCode"] = this.errorCode;
        return data;
    }

    clone(): ErrorDetails {
        const json = this.toJSON();
        let result = new ErrorDetails();
        result.init(json);
        return result;
    }
}

export interface IErrorDetails {
    statusCode?: number;
    message?: string | undefined;
    stackTrace?: string | undefined;
    exceptionType?: string | undefined;
    errorCode?: string | undefined;
}

export class FrontendSettings implements IFrontendSettings {
    clientId?: string | undefined;
    authority?: string | undefined;
    scope?: string | undefined;

    constructor(data?: IFrontendSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.authority = _data["authority"];
            this.scope = _data["scope"];
        }
    }

    static fromJS(data: any): FrontendSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FrontendSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["authority"] = this.authority;
        data["scope"] = this.scope;
        return data;
    }

    clone(): FrontendSettings {
        const json = this.toJSON();
        let result = new FrontendSettings();
        result.init(json);
        return result;
    }
}

export interface IFrontendSettings {
    clientId?: string | undefined;
    authority?: string | undefined;
    scope?: string | undefined;
}

export class EditThematicTypeDto extends LastUpdateViewerDto implements IEditThematicTypeDto {
    id?: number;
    dataTranslation?: DataTranslationDto | undefined;

    constructor(data?: IEditThematicTypeDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): EditThematicTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditThematicTypeDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): EditThematicTypeDto {
        const json = this.toJSON();
        let result = new EditThematicTypeDto();
        result.init(json);
        return result;
    }
}

export interface IEditThematicTypeDto extends ILastUpdateViewerDto {
    id?: number;
    dataTranslation?: DataTranslationDto | undefined;
}

export class PaginatedResultsOfThematicTypeGridDto implements IPaginatedResultsOfThematicTypeGridDto {
    totalCount?: number;
    results?: ThematicTypeGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfThematicTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ThematicTypeGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfThematicTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfThematicTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfThematicTypeGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfThematicTypeGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfThematicTypeGridDto {
    totalCount?: number;
    results?: ThematicTypeGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class ThematicTypeGridDto implements IThematicTypeGridDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IThematicTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ThematicTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThematicTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): ThematicTypeGridDto {
        const json = this.toJSON();
        let result = new ThematicTypeGridDto();
        result.init(json);
        return result;
    }
}

export interface IThematicTypeGridDto {
    id?: number;
    name?: string | undefined;
}

export class SearchQueryOfThematicTypeSearchDto implements ISearchQueryOfThematicTypeSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: ThematicTypeSearchDto | undefined;

    constructor(data?: ISearchQueryOfThematicTypeSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? ThematicTypeSearchDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfThematicTypeSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfThematicTypeSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfThematicTypeSearchDto {
        const json = this.toJSON();
        let result = new SearchQueryOfThematicTypeSearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfThematicTypeSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: ThematicTypeSearchDto | undefined;
}

export class ThematicTypeSearchDto extends PaginatedSearchable implements IThematicTypeSearchDto {

    constructor(data?: IThematicTypeSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ThematicTypeSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThematicTypeSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ThematicTypeSearchDto {
        const json = this.toJSON();
        let result = new ThematicTypeSearchDto();
        result.init(json);
        return result;
    }
}

export interface IThematicTypeSearchDto extends IPaginatedSearchable {
}

export class EditTrainingDto extends LastUpdateViewerDto implements IEditTrainingDto {
    id?: number;
    trainingTypeId?: number;
    hourlyTypeId?: number;
    operatorId?: number | undefined;
    apaLanguageId?: number;
    operatorTypeId?: number;
    isBapa?: boolean;
    capacity?: number | undefined;
    sessionQuantity?: number;
    localisationSiteId?: number | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    description?: string | undefined;
    dailyDurationDescription?: string | undefined;
    locationDescription?: string | undefined;
    contactsDescription?: string | undefined;
    hasSession?: boolean;
    plannedSessionQuantity?: number;

    constructor(data?: IEditTrainingDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.trainingTypeId = _data["trainingTypeId"];
            this.hourlyTypeId = _data["hourlyTypeId"];
            this.operatorId = _data["operatorId"];
            this.apaLanguageId = _data["apaLanguageId"];
            this.operatorTypeId = _data["operatorTypeId"];
            this.isBapa = _data["isBapa"];
            this.capacity = _data["capacity"];
            this.sessionQuantity = _data["sessionQuantity"];
            this.localisationSiteId = _data["localisationSiteId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.dailyDurationDescription = _data["dailyDurationDescription"];
            this.locationDescription = _data["locationDescription"];
            this.contactsDescription = _data["contactsDescription"];
            this.hasSession = _data["hasSession"];
            this.plannedSessionQuantity = _data["plannedSessionQuantity"];
        }
    }

    static override fromJS(data: any): EditTrainingDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditTrainingDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trainingTypeId"] = this.trainingTypeId;
        data["hourlyTypeId"] = this.hourlyTypeId;
        data["operatorId"] = this.operatorId;
        data["apaLanguageId"] = this.apaLanguageId;
        data["operatorTypeId"] = this.operatorTypeId;
        data["isBapa"] = this.isBapa;
        data["capacity"] = this.capacity;
        data["sessionQuantity"] = this.sessionQuantity;
        data["localisationSiteId"] = this.localisationSiteId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["dailyDurationDescription"] = this.dailyDurationDescription;
        data["locationDescription"] = this.locationDescription;
        data["contactsDescription"] = this.contactsDescription;
        data["hasSession"] = this.hasSession;
        data["plannedSessionQuantity"] = this.plannedSessionQuantity;
        super.toJSON(data);
        return data;
    }

    clone(): EditTrainingDto {
        const json = this.toJSON();
        let result = new EditTrainingDto();
        result.init(json);
        return result;
    }
}

export interface IEditTrainingDto extends ILastUpdateViewerDto {
    id?: number;
    trainingTypeId?: number;
    hourlyTypeId?: number;
    operatorId?: number | undefined;
    apaLanguageId?: number;
    operatorTypeId?: number;
    isBapa?: boolean;
    capacity?: number | undefined;
    sessionQuantity?: number;
    localisationSiteId?: number | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    description?: string | undefined;
    dailyDurationDescription?: string | undefined;
    locationDescription?: string | undefined;
    contactsDescription?: string | undefined;
    hasSession?: boolean;
    plannedSessionQuantity?: number;
}

export class TrainingTypeInfoDto implements ITrainingTypeInfoDto {
    planningTypeCode?: EPlanningTypes;
    planningTypeQuantity?: number;

    constructor(data?: ITrainingTypeInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planningTypeCode = _data["planningTypeCode"];
            this.planningTypeQuantity = _data["planningTypeQuantity"];
        }
    }

    static fromJS(data: any): TrainingTypeInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingTypeInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planningTypeCode"] = this.planningTypeCode;
        data["planningTypeQuantity"] = this.planningTypeQuantity;
        return data;
    }

    clone(): TrainingTypeInfoDto {
        const json = this.toJSON();
        let result = new TrainingTypeInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingTypeInfoDto {
    planningTypeCode?: EPlanningTypes;
    planningTypeQuantity?: number;
}

export class IntDto implements IIntDto {
    value?: number;

    constructor(data?: IIntDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): IntDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }

    clone(): IntDto {
        const json = this.toJSON();
        let result = new IntDto();
        result.init(json);
        return result;
    }
}

export interface IIntDto {
    value?: number;
}

export class PaginatedResultsOfTrainingGridDto implements IPaginatedResultsOfTrainingGridDto {
    totalCount?: number;
    results?: TrainingGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTrainingGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TrainingGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTrainingGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTrainingGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfTrainingGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfTrainingGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfTrainingGridDto {
    totalCount?: number;
    results?: TrainingGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class TrainingGridDto implements ITrainingGridDto {
    id?: number;
    localisationSiteId?: number;
    site?: string | undefined;
    trainingType?: string | undefined;
    trainingTypeId?: number;
    apaLanguageId?: number;
    capacity?: number | undefined;
    sessionQuantity?: number;
    from?: Date;
    to?: Date;
    trainers?: string | undefined;
    rooms?: string | undefined;

    constructor(data?: ITrainingGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.localisationSiteId = _data["localisationSiteId"];
            this.site = _data["site"];
            this.trainingType = _data["trainingType"];
            this.trainingTypeId = _data["trainingTypeId"];
            this.apaLanguageId = _data["apaLanguageId"];
            this.capacity = _data["capacity"];
            this.sessionQuantity = _data["sessionQuantity"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.trainers = _data["trainers"];
            this.rooms = _data["rooms"];
        }
    }

    static fromJS(data: any): TrainingGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["localisationSiteId"] = this.localisationSiteId;
        data["site"] = this.site;
        data["trainingType"] = this.trainingType;
        data["trainingTypeId"] = this.trainingTypeId;
        data["apaLanguageId"] = this.apaLanguageId;
        data["capacity"] = this.capacity;
        data["sessionQuantity"] = this.sessionQuantity;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["trainers"] = this.trainers;
        data["rooms"] = this.rooms;
        return data;
    }

    clone(): TrainingGridDto {
        const json = this.toJSON();
        let result = new TrainingGridDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingGridDto {
    id?: number;
    localisationSiteId?: number;
    site?: string | undefined;
    trainingType?: string | undefined;
    trainingTypeId?: number;
    apaLanguageId?: number;
    capacity?: number | undefined;
    sessionQuantity?: number;
    from?: Date;
    to?: Date;
    trainers?: string | undefined;
    rooms?: string | undefined;
}

export class SearchQueryOfTrainingSearch implements ISearchQueryOfTrainingSearch {
    expression?: AbstractSearchExpression | undefined;
    criteria?: TrainingSearch | undefined;

    constructor(data?: ISearchQueryOfTrainingSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? TrainingSearch.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfTrainingSearch {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfTrainingSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfTrainingSearch {
        const json = this.toJSON();
        let result = new SearchQueryOfTrainingSearch();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfTrainingSearch {
    expression?: AbstractSearchExpression | undefined;
    criteria?: TrainingSearch | undefined;
}

export class TrainingSearch extends PaginatedSearchable implements ITrainingSearch {

    constructor(data?: ITrainingSearch) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TrainingSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingSearch();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TrainingSearch {
        const json = this.toJSON();
        let result = new TrainingSearch();
        result.init(json);
        return result;
    }
}

export interface ITrainingSearch extends IPaginatedSearchable {
}

export class TrainingPlanificationInformationsDto implements ITrainingPlanificationInformationsDto {
    trainingId?: number;
    duration?: number;
    trainerEmployeeId?: number | undefined;
    trainingDateFrom?: Date;
    trainingDateTo?: Date;
    timeFrom?: Date | undefined;
    timeTo?: Date | undefined;
    siteName?: string | undefined;
    siteId?: number | undefined;
    roomId?: number | undefined;
    apaLanguageId?: number;
    trainingType?: ETrainingTypes | undefined;
    trainingTypeId?: number;

    constructor(data?: ITrainingPlanificationInformationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingId = _data["trainingId"];
            this.duration = _data["duration"];
            this.trainerEmployeeId = _data["trainerEmployeeId"];
            this.trainingDateFrom = _data["trainingDateFrom"] ? new Date(_data["trainingDateFrom"].toString()) : <any>undefined;
            this.trainingDateTo = _data["trainingDateTo"] ? new Date(_data["trainingDateTo"].toString()) : <any>undefined;
            this.timeFrom = _data["timeFrom"] ? new Date(_data["timeFrom"].toString()) : <any>undefined;
            this.timeTo = _data["timeTo"] ? new Date(_data["timeTo"].toString()) : <any>undefined;
            this.siteName = _data["siteName"];
            this.siteId = _data["siteId"];
            this.roomId = _data["roomId"];
            this.apaLanguageId = _data["apaLanguageId"];
            this.trainingType = _data["trainingType"];
            this.trainingTypeId = _data["trainingTypeId"];
        }
    }

    static fromJS(data: any): TrainingPlanificationInformationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingPlanificationInformationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingId"] = this.trainingId;
        data["duration"] = this.duration;
        data["trainerEmployeeId"] = this.trainerEmployeeId;
        data["trainingDateFrom"] = this.trainingDateFrom ? this.trainingDateFrom.toISOString() : <any>undefined;
        data["trainingDateTo"] = this.trainingDateTo ? this.trainingDateTo.toISOString() : <any>undefined;
        data["timeFrom"] = this.timeFrom ? this.timeFrom.toISOString() : <any>undefined;
        data["timeTo"] = this.timeTo ? this.timeTo.toISOString() : <any>undefined;
        data["siteName"] = this.siteName;
        data["siteId"] = this.siteId;
        data["roomId"] = this.roomId;
        data["apaLanguageId"] = this.apaLanguageId;
        data["trainingType"] = this.trainingType;
        data["trainingTypeId"] = this.trainingTypeId;
        return data;
    }

    clone(): TrainingPlanificationInformationsDto {
        const json = this.toJSON();
        let result = new TrainingPlanificationInformationsDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingPlanificationInformationsDto {
    trainingId?: number;
    duration?: number;
    trainerEmployeeId?: number | undefined;
    trainingDateFrom?: Date;
    trainingDateTo?: Date;
    timeFrom?: Date | undefined;
    timeTo?: Date | undefined;
    siteName?: string | undefined;
    siteId?: number | undefined;
    roomId?: number | undefined;
    apaLanguageId?: number;
    trainingType?: ETrainingTypes | undefined;
    trainingTypeId?: number;
}

export class EditTrainingTypeDto implements IEditTrainingTypeDto {
    id?: number;
    planningTypeId?: number;
    code?: ETrainingTypes | undefined;
    isInternal?: boolean;
    colorHexCode?: string | undefined;
    planningTypeQuantity?: number;
    lastUpdate?: Date;
    lastUpdateBy?: string | undefined;
    action?: UserRoles;
    assignmentIds?: number[] | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    useForVia?: boolean;
    isActive?: boolean;

    constructor(data?: IEditTrainingTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.planningTypeId = _data["planningTypeId"];
            this.code = _data["code"];
            this.isInternal = _data["isInternal"];
            this.colorHexCode = _data["colorHexCode"];
            this.planningTypeQuantity = _data["planningTypeQuantity"];
            this.lastUpdate = _data["lastUpdate"] ? new Date(_data["lastUpdate"].toString()) : <any>undefined;
            this.lastUpdateBy = _data["lastUpdateBy"];
            this.action = _data["action"];
            if (Array.isArray(_data["assignmentIds"])) {
                this.assignmentIds = [] as any;
                for (let item of _data["assignmentIds"])
                    this.assignmentIds!.push(item);
            }
            this.dataTranslation = _data["dataTranslation"] ? DataTranslationDto.fromJS(_data["dataTranslation"]) : <any>undefined;
            this.useForVia = _data["useForVia"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EditTrainingTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditTrainingTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["planningTypeId"] = this.planningTypeId;
        data["code"] = this.code;
        data["isInternal"] = this.isInternal;
        data["colorHexCode"] = this.colorHexCode;
        data["planningTypeQuantity"] = this.planningTypeQuantity;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        data["lastUpdateBy"] = this.lastUpdateBy;
        data["action"] = this.action;
        if (Array.isArray(this.assignmentIds)) {
            data["assignmentIds"] = [];
            for (let item of this.assignmentIds)
                data["assignmentIds"].push(item);
        }
        data["dataTranslation"] = this.dataTranslation ? this.dataTranslation.toJSON() : <any>undefined;
        data["useForVia"] = this.useForVia;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): EditTrainingTypeDto {
        const json = this.toJSON();
        let result = new EditTrainingTypeDto();
        result.init(json);
        return result;
    }
}

export interface IEditTrainingTypeDto {
    id?: number;
    planningTypeId?: number;
    code?: ETrainingTypes | undefined;
    isInternal?: boolean;
    colorHexCode?: string | undefined;
    planningTypeQuantity?: number;
    lastUpdate?: Date;
    lastUpdateBy?: string | undefined;
    action?: UserRoles;
    assignmentIds?: number[] | undefined;
    dataTranslation?: DataTranslationDto | undefined;
    useForVia?: boolean;
    isActive?: boolean;
}

export class PaginatedResultsOfTrainingTypeGridDto implements IPaginatedResultsOfTrainingTypeGridDto {
    totalCount?: number;
    results?: TrainingTypeGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTrainingTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TrainingTypeGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTrainingTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTrainingTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfTrainingTypeGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfTrainingTypeGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfTrainingTypeGridDto {
    totalCount?: number;
    results?: TrainingTypeGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class TrainingTypeGridDto implements ITrainingTypeGridDto {
    id?: number;
    name?: string | undefined;
    isInternal?: boolean;
    useForVia?: boolean;
    colorHexCode?: string | undefined;

    constructor(data?: ITrainingTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isInternal = _data["isInternal"];
            this.useForVia = _data["useForVia"];
            this.colorHexCode = _data["colorHexCode"];
        }
    }

    static fromJS(data: any): TrainingTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isInternal"] = this.isInternal;
        data["useForVia"] = this.useForVia;
        data["colorHexCode"] = this.colorHexCode;
        return data;
    }

    clone(): TrainingTypeGridDto {
        const json = this.toJSON();
        let result = new TrainingTypeGridDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingTypeGridDto {
    id?: number;
    name?: string | undefined;
    isInternal?: boolean;
    useForVia?: boolean;
    colorHexCode?: string | undefined;
}

export class SearchQueryOfTrainingTypeSearchDto implements ISearchQueryOfTrainingTypeSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: TrainingTypeSearchDto | undefined;

    constructor(data?: ISearchQueryOfTrainingTypeSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? TrainingTypeSearchDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfTrainingTypeSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfTrainingTypeSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfTrainingTypeSearchDto {
        const json = this.toJSON();
        let result = new SearchQueryOfTrainingTypeSearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfTrainingTypeSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: TrainingTypeSearchDto | undefined;
}

export class TrainingTypeSearchDto extends PaginatedSearchable implements ITrainingTypeSearchDto {

    constructor(data?: ITrainingTypeSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TrainingTypeSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingTypeSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TrainingTypeSearchDto {
        const json = this.toJSON();
        let result = new TrainingTypeSearchDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingTypeSearchDto extends IPaginatedSearchable {
}

export class PaginatedResultsOfTranslationCodeDto implements IPaginatedResultsOfTranslationCodeDto {
    totalCount?: number;
    results?: TranslationCodeDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTranslationCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TranslationCodeDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTranslationCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTranslationCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfTranslationCodeDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfTranslationCodeDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfTranslationCodeDto {
    totalCount?: number;
    results?: TranslationCodeDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class TranslationCodeDto implements ITranslationCodeDto {
    id?: number;
    translationCode?: string | undefined;
    toTranslate?: boolean;
    dataTranslationValues?: TranslationValueDto[] | undefined;

    constructor(data?: ITranslationCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.translationCode = _data["translationCode"];
            this.toTranslate = _data["toTranslate"];
            if (Array.isArray(_data["dataTranslationValues"])) {
                this.dataTranslationValues = [] as any;
                for (let item of _data["dataTranslationValues"])
                    this.dataTranslationValues!.push(TranslationValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TranslationCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["translationCode"] = this.translationCode;
        data["toTranslate"] = this.toTranslate;
        if (Array.isArray(this.dataTranslationValues)) {
            data["dataTranslationValues"] = [];
            for (let item of this.dataTranslationValues)
                data["dataTranslationValues"].push(item.toJSON());
        }
        return data;
    }

    clone(): TranslationCodeDto {
        const json = this.toJSON();
        let result = new TranslationCodeDto();
        result.init(json);
        return result;
    }
}

export interface ITranslationCodeDto {
    id?: number;
    translationCode?: string | undefined;
    toTranslate?: boolean;
    dataTranslationValues?: TranslationValueDto[] | undefined;
}

export class TranslationValueDto implements ITranslationValueDto {
    id?: number;
    text?: string | undefined;
    languageId?: number;
    languageCode?: string | undefined;

    constructor(data?: ITranslationValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.languageId = _data["languageId"];
            this.languageCode = _data["languageCode"];
        }
    }

    static fromJS(data: any): TranslationValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["languageId"] = this.languageId;
        data["languageCode"] = this.languageCode;
        return data;
    }

    clone(): TranslationValueDto {
        const json = this.toJSON();
        let result = new TranslationValueDto();
        result.init(json);
        return result;
    }
}

export interface ITranslationValueDto {
    id?: number;
    text?: string | undefined;
    languageId?: number;
    languageCode?: string | undefined;
}

export class SearchQueryOfTranslationCodeSearchCriteria implements ISearchQueryOfTranslationCodeSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: TranslationCodeSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfTranslationCodeSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? TranslationCodeSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfTranslationCodeSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfTranslationCodeSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfTranslationCodeSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfTranslationCodeSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfTranslationCodeSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: TranslationCodeSearchCriteria | undefined;
}

export class TranslationCodeSearchCriteria extends PaginatedSearchable implements ITranslationCodeSearchCriteria {

    constructor(data?: ITranslationCodeSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TranslationCodeSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationCodeSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TranslationCodeSearchCriteria {
        const json = this.toJSON();
        let result = new TranslationCodeSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ITranslationCodeSearchCriteria extends IPaginatedSearchable {
}

export class TranslationDto implements ITranslationDto {
    languageCode?: string | undefined;
    translationCode?: string | undefined;
    text?: string | undefined;
    translationId?: number;
    languageId?: number;
    createdOn?: Date;
    updatedOn?: Date;
    toTranslate?: boolean;

    constructor(data?: ITranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["languageCode"];
            this.translationCode = _data["translationCode"];
            this.text = _data["text"];
            this.translationId = _data["translationId"];
            this.languageId = _data["languageId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.toTranslate = _data["toTranslate"];
        }
    }

    static fromJS(data: any): TranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        data["translationCode"] = this.translationCode;
        data["text"] = this.text;
        data["translationId"] = this.translationId;
        data["languageId"] = this.languageId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["toTranslate"] = this.toTranslate;
        return data;
    }

    clone(): TranslationDto {
        const json = this.toJSON();
        let result = new TranslationDto();
        result.init(json);
        return result;
    }
}

export interface ITranslationDto {
    languageCode?: string | undefined;
    translationCode?: string | undefined;
    text?: string | undefined;
    translationId?: number;
    languageId?: number;
    createdOn?: Date;
    updatedOn?: Date;
    toTranslate?: boolean;
}

export class SearchQueryOfTranslationSearchCriteria implements ISearchQueryOfTranslationSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: TranslationSearchCriteria | undefined;

    constructor(data?: ISearchQueryOfTranslationSearchCriteria) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? TranslationSearchCriteria.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfTranslationSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfTranslationSearchCriteria();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfTranslationSearchCriteria {
        const json = this.toJSON();
        let result = new SearchQueryOfTranslationSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfTranslationSearchCriteria {
    expression?: AbstractSearchExpression | undefined;
    criteria?: TranslationSearchCriteria | undefined;
}

export class TranslationSearchCriteria extends PaginatedSearchable implements ITranslationSearchCriteria {
    languageCode?: string | undefined;

    constructor(data?: ITranslationSearchCriteria) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageCode = _data["languageCode"];
        }
    }

    static override fromJS(data: any): TranslationSearchCriteria {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationSearchCriteria();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        super.toJSON(data);
        return data;
    }

    clone(): TranslationSearchCriteria {
        const json = this.toJSON();
        let result = new TranslationSearchCriteria();
        result.init(json);
        return result;
    }
}

export interface ITranslationSearchCriteria extends IPaginatedSearchable {
    languageCode?: string | undefined;
}

export class SaveTranslationDto implements ISaveTranslationDto {
    translationCode?: string | undefined;
    languageCode?: string | undefined;
    text?: string | undefined;

    constructor(data?: ISaveTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.translationCode = _data["translationCode"];
            this.languageCode = _data["languageCode"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SaveTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translationCode"] = this.translationCode;
        data["languageCode"] = this.languageCode;
        data["text"] = this.text;
        return data;
    }

    clone(): SaveTranslationDto {
        const json = this.toJSON();
        let result = new SaveTranslationDto();
        result.init(json);
        return result;
    }
}

export interface ISaveTranslationDto {
    translationCode?: string | undefined;
    languageCode?: string | undefined;
    text?: string | undefined;
}

export class UpdateTranslationCommand implements IUpdateTranslationCommand {
    translationId?: number;
    text?: string | undefined;

    constructor(data?: IUpdateTranslationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.translationId = _data["translationId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): UpdateTranslationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTranslationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translationId"] = this.translationId;
        data["text"] = this.text;
        return data;
    }

    clone(): UpdateTranslationCommand {
        const json = this.toJSON();
        let result = new UpdateTranslationCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateTranslationCommand {
    translationId?: number;
    text?: string | undefined;
}

export class PaginatedResultsOfTranslationDto implements IPaginatedResultsOfTranslationDto {
    totalCount?: number;
    results?: TranslationDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TranslationDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfTranslationDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfTranslationDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfTranslationDto {
    totalCount?: number;
    results?: TranslationDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class ConcurrencyBaseDto extends EntityDto implements IConcurrencyBaseDto {
    updatedOn?: Date;
    rowVersion?: string | undefined;

    constructor(data?: IConcurrencyBaseDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.rowVersion = _data["rowVersion"];
        }
    }

    static override fromJS(data: any): ConcurrencyBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConcurrencyBaseDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["rowVersion"] = this.rowVersion;
        super.toJSON(data);
        return data;
    }

    clone(): ConcurrencyBaseDto {
        const json = this.toJSON();
        let result = new ConcurrencyBaseDto();
        result.init(json);
        return result;
    }
}

export interface IConcurrencyBaseDto extends IEntityDto {
    updatedOn?: Date;
    rowVersion?: string | undefined;
}

export class EditUserDto extends ConcurrencyBaseDto implements IEditUserDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    login?: string | undefined;
    roleId?: number | undefined;
    employeeId?: number | undefined;
    isActive?: boolean;
    fullName?: string | undefined;
    newComerId?: number | undefined;
    roleName?: UserRoles;

    constructor(data?: IEditUserDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.login = _data["login"];
            this.roleId = _data["roleId"];
            this.employeeId = _data["employeeId"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.newComerId = _data["newComerId"];
            this.roleName = _data["roleName"];
        }
    }

    static override fromJS(data: any): EditUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["login"] = this.login;
        data["roleId"] = this.roleId;
        data["employeeId"] = this.employeeId;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["newComerId"] = this.newComerId;
        data["roleName"] = this.roleName;
        super.toJSON(data);
        return data;
    }

    clone(): EditUserDto {
        const json = this.toJSON();
        let result = new EditUserDto();
        result.init(json);
        return result;
    }
}

export interface IEditUserDto extends IConcurrencyBaseDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    login?: string | undefined;
    roleId?: number | undefined;
    employeeId?: number | undefined;
    isActive?: boolean;
    fullName?: string | undefined;
    newComerId?: number | undefined;
    roleName?: UserRoles;
}

export class UserProfileDto implements IUserProfileDto {
    userId?: string | undefined;
    employeeId?: number | undefined;
    userName?: string | undefined;
    actions?: ActionCode[] | undefined;
    role?: string | undefined;
    newComerId?: number | undefined;

    constructor(data?: IUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.employeeId = _data["employeeId"];
            this.userName = _data["userName"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(item);
            }
            this.role = _data["role"];
            this.newComerId = _data["newComerId"];
        }
    }

    static fromJS(data: any): UserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["employeeId"] = this.employeeId;
        data["userName"] = this.userName;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item);
        }
        data["role"] = this.role;
        data["newComerId"] = this.newComerId;
        return data;
    }

    clone(): UserProfileDto {
        const json = this.toJSON();
        let result = new UserProfileDto();
        result.init(json);
        return result;
    }
}

export interface IUserProfileDto {
    userId?: string | undefined;
    employeeId?: number | undefined;
    userName?: string | undefined;
    actions?: ActionCode[] | undefined;
    role?: string | undefined;
    newComerId?: number | undefined;
}

export class PaginatedResultsOfUserGridDto implements IPaginatedResultsOfUserGridDto {
    totalCount?: number;
    results?: UserGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfUserGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(AggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfUserGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfUserGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginatedResultsOfUserGridDto {
        const json = this.toJSON();
        let result = new PaginatedResultsOfUserGridDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedResultsOfUserGridDto {
    totalCount?: number;
    results?: UserGridDto[] | undefined;
    aggregateResults?: AggregateResult[] | undefined;
}

export class UserGridDto implements IUserGridDto {
    id?: number;
    role?: string | undefined;
    login?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    employee?: string | undefined;
    newComer?: string | undefined;

    constructor(data?: IUserGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.role = _data["role"];
            this.login = _data["login"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.employee = _data["employee"];
            this.newComer = _data["newComer"];
        }
    }

    static fromJS(data: any): UserGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["role"] = this.role;
        data["login"] = this.login;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["employee"] = this.employee;
        data["newComer"] = this.newComer;
        return data;
    }

    clone(): UserGridDto {
        const json = this.toJSON();
        let result = new UserGridDto();
        result.init(json);
        return result;
    }
}

export interface IUserGridDto {
    id?: number;
    role?: string | undefined;
    login?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    employee?: string | undefined;
    newComer?: string | undefined;
}

export class SearchQueryOfUserSearchDto implements ISearchQueryOfUserSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: UserSearchDto | undefined;

    constructor(data?: ISearchQueryOfUserSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? AbstractSearchExpression.fromJS(_data["expression"]) : <any>undefined;
            this.criteria = _data["criteria"] ? UserSearchDto.fromJS(_data["criteria"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchQueryOfUserSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOfUserSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["criteria"] = this.criteria ? this.criteria.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchQueryOfUserSearchDto {
        const json = this.toJSON();
        let result = new SearchQueryOfUserSearchDto();
        result.init(json);
        return result;
    }
}

export interface ISearchQueryOfUserSearchDto {
    expression?: AbstractSearchExpression | undefined;
    criteria?: UserSearchDto | undefined;
}

export class UserSearchDto extends PaginatedSearchable implements IUserSearchDto {

    constructor(data?: IUserSearchDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UserSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSearchDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): UserSearchDto {
        const json = this.toJSON();
        let result = new UserSearchDto();
        result.init(json);
        return result;
    }
}

export interface IUserSearchDto extends IPaginatedSearchable {
}

export class HealthCheckViewModel implements IHealthCheckViewModel {
    globalStatus?: string | undefined;
    checkTime?: Date;
    worstExecutionTime?: string | undefined;
    totalExecutionTime?: string | undefined;
    entries?: HealthCheckEntryViewModel[] | undefined;

    constructor(data?: IHealthCheckViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.globalStatus = _data["globalStatus"];
            this.checkTime = _data["checkTime"] ? new Date(_data["checkTime"].toString()) : <any>undefined;
            this.worstExecutionTime = _data["worstExecutionTime"];
            this.totalExecutionTime = _data["totalExecutionTime"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(HealthCheckEntryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthCheckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["globalStatus"] = this.globalStatus;
        data["checkTime"] = this.checkTime ? this.checkTime.toISOString() : <any>undefined;
        data["worstExecutionTime"] = this.worstExecutionTime;
        data["totalExecutionTime"] = this.totalExecutionTime;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }

    clone(): HealthCheckViewModel {
        const json = this.toJSON();
        let result = new HealthCheckViewModel();
        result.init(json);
        return result;
    }
}

export interface IHealthCheckViewModel {
    globalStatus?: string | undefined;
    checkTime?: Date;
    worstExecutionTime?: string | undefined;
    totalExecutionTime?: string | undefined;
    entries?: HealthCheckEntryViewModel[] | undefined;
}

export class HealthCheckEntryViewModel implements IHealthCheckEntryViewModel {
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    statusDescription?: string | undefined;
    executionTime?: string | undefined;
    context?: { [key: string]: string[]; } | undefined;

    constructor(data?: IHealthCheckEntryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.statusDescription = _data["statusDescription"];
            this.executionTime = _data["executionTime"];
            if (_data["context"]) {
                this.context = {} as any;
                for (let key in _data["context"]) {
                    if (_data["context"].hasOwnProperty(key))
                        (<any>this.context)![key] = _data["context"][key] !== undefined ? _data["context"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HealthCheckEntryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckEntryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["statusDescription"] = this.statusDescription;
        data["executionTime"] = this.executionTime;
        if (this.context) {
            data["context"] = {};
            for (let key in this.context) {
                if (this.context.hasOwnProperty(key))
                    (<any>data["context"])[key] = (<any>this.context)[key];
            }
        }
        return data;
    }

    clone(): HealthCheckEntryViewModel {
        const json = this.toJSON();
        let result = new HealthCheckEntryViewModel();
        result.init(json);
        return result;
    }
}

export interface IHealthCheckEntryViewModel {
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    statusDescription?: string | undefined;
    executionTime?: string | undefined;
    context?: { [key: string]: string[]; } | undefined;
}

export class ClientApiKey implements IClientApiKey {
    clientName?: string | undefined;
    clientId?: string | undefined;
    apiKey?: string | undefined;
    hashedApiKey?: string | undefined;

    constructor(data?: IClientApiKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientName = _data["clientName"];
            this.clientId = _data["clientId"];
            this.apiKey = _data["apiKey"];
            this.hashedApiKey = _data["hashedApiKey"];
        }
    }

    static fromJS(data: any): ClientApiKey {
        data = typeof data === 'object' ? data : {};
        let result = new ClientApiKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientName"] = this.clientName;
        data["clientId"] = this.clientId;
        data["apiKey"] = this.apiKey;
        data["hashedApiKey"] = this.hashedApiKey;
        return data;
    }

    clone(): ClientApiKey {
        const json = this.toJSON();
        let result = new ClientApiKey();
        result.init(json);
        return result;
    }
}

export interface IClientApiKey {
    clientName?: string | undefined;
    clientId?: string | undefined;
    apiKey?: string | undefined;
    hashedApiKey?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

export interface Middleware {
  pre?(context: RequestInit): Promise<RequestInit | void>;
  post?(response: Response): Promise<Response | void>;
}

export interface Configuration {
  basePath?: string; // override base path
  apiKey?: string; // parameter for apiKey security
  apiKeyPromise?: () => Promise<string>;
  headers?: HTTPHeaders; //header params we want to use on every request
  credentials?: RequestCredentials; //value for the credentials param we want to use on each request
  middlewares?: Middleware[];
}

export type Json = any;
export type HTTPMethod =
  | "GET"
  | "POST"
  | "PUT"
  | "PATCH"
  | "DELETE"
  | "OPTIONS";
export type HTTPHeaders = { [key: string]: string };